var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 206,
    viewBox: "0 0 241 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.977 205.565C187.251 205.565 240.977 171.575 240.977 129.647C240.977 87.7195 187.251 53.7303 120.977 53.7303C54.7024 53.7303 0.976562 87.7195 0.976562 129.647C0.976562 171.575 54.7024 205.565 120.977 205.565Z",
    fill: "#DCEAF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5344 194.198L17.4494 147.999C17.2035 147.914 16.9899 147.753 16.839 147.539C16.688 147.324 16.6073 147.067 16.6082 146.803C16.6091 146.539 16.6916 146.282 16.8441 146.069C16.9965 145.855 17.2112 145.695 17.4577 145.613L140.314 74.1005C140.942 73.7775 141.636 73.6103 142.339 73.6128C143.043 73.6152 143.736 73.7871 144.361 74.1145L222.476 120.313C222.718 120.4 222.928 120.561 223.076 120.775C223.224 120.988 223.303 121.243 223.303 121.504C223.302 121.766 223.221 122.02 223.071 122.233C222.921 122.445 222.711 122.605 222.467 122.69L99.5817 194.212C98.954 194.535 98.2599 194.702 97.5564 194.699C96.8528 194.697 96.1599 194.525 95.5344 194.198Z",
    fill: "#C6D9EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7415 18.596C53.6637 18.5577 53.577 18.5412 53.4905 18.5483C53.4041 18.5555 53.3212 18.5859 53.2507 18.6364L52.2403 19.2889L52.0151 19.8663C51.9633 20.0575 51.9616 20.2589 52.0101 20.4511C52.0586 20.6432 52.1558 20.8196 52.2922 20.9633C52.4596 21.1345 52.614 21.3178 52.7542 21.5119C52.8544 21.6625 53.0095 21.768 53.1865 21.8058C53.3634 21.8435 53.5481 21.8106 53.7011 21.7139L56.0627 20.2012C56.1311 20.1513 56.2117 20.1207 56.296 20.1126C56.3803 20.1045 56.4652 20.1191 56.5419 20.155L53.7415 18.596ZM50.1039 27.0318C49.7748 25.1726 48.5565 24.2372 46.9744 24.3642C47.1274 24.7135 47.2378 25.0799 47.3035 25.4555C47.8232 28.406 45.9005 32.5921 43.0135 34.8093C42.1454 35.5189 41.0947 35.9692 39.9821 36.1085C40.9348 38.0889 43.331 38.2737 45.8254 36.3625C48.7124 34.1684 50.6293 29.9823 50.1039 27.0318ZM50.1559 14.4156C50.0991 14.3801 50.0366 14.3547 49.9711 14.3406L48.1927 13.9537C47.9993 13.9164 47.799 13.9397 47.6193 14.0203C47.4395 14.1008 47.2889 14.2349 47.1881 14.4041L45.5078 17.5163C45.4143 17.6786 45.2885 17.8201 45.1383 17.932C45.0499 18.0022 44.9552 18.064 44.8554 18.1168L45.375 19.8085C45.4007 19.8921 45.444 19.9692 45.502 20.0347C45.56 20.1001 45.6313 20.1524 45.7112 20.1879C45.791 20.2235 45.8776 20.2415 45.965 20.2408C46.0525 20.2401 46.1387 20.2207 46.218 20.1838C46.5754 20.0421 46.9419 19.9244 47.3151 19.8316C47.5352 19.7644 47.7408 19.6567 47.9214 19.5141C48.0752 19.4003 48.2047 19.257 48.3024 19.0926L49.9711 15.9862C50.0742 15.8176 50.2259 15.6844 50.4063 15.6039C50.5868 15.5235 50.7873 15.4998 50.9816 15.5358L52.7657 15.9226C52.8258 15.9368 52.884 15.9581 52.9389 15.9862L50.1559 14.4156ZM45.1441 44.4403C45.062 44.3737 45.0034 44.2827 44.9766 44.1805L44.3992 42.2346C44.3725 42.1494 44.3272 42.0711 44.2667 42.0054C44.2062 41.9397 44.1319 41.8882 44.0491 41.8545C43.9664 41.8209 43.8772 41.8059 43.788 41.8107C43.6988 41.8156 43.6118 41.8401 43.5331 41.8824C43.1779 42.0232 42.8132 42.1389 42.4418 42.2289C42.3207 42.262 42.2043 42.3105 42.0954 42.3732L42.1762 42.6215C42.2091 42.7472 42.29 42.855 42.4014 42.9218L45.1441 44.4403ZM41.7374 15.9631C41.6761 15.9336 41.6091 15.9178 41.5411 15.9169C41.4207 15.9179 41.3043 15.9608 41.212 16.0381L38.5444 18.0763C38.5071 18.104 38.4724 18.1349 38.4405 18.1687C38.4144 18.1929 38.3911 18.2201 38.3712 18.2496C38.2743 18.375 38.1947 18.5129 38.1345 18.6595C38.1345 18.6884 38.1345 18.723 38.1345 18.7577C38.0832 18.8902 38.0577 19.0313 38.0594 19.1734L38.198 21.6735C38.1978 22.1073 38.0513 22.5284 37.7823 22.8687C37.3434 23.3768 36.9335 23.9138 36.5466 24.4624C36.398 24.6587 36.1982 24.8105 35.9692 24.9012C35.8955 24.934 35.8179 24.9573 35.7383 24.9705C35.7 24.9761 35.6611 24.9761 35.6228 24.9705C35.5712 24.9791 35.5185 24.9791 35.4669 24.9705L33.7347 24.8896H33.6943C33.6463 24.8839 33.5979 24.8839 33.5499 24.8896C33.5084 24.8937 33.4676 24.9034 33.4287 24.9185C33.3807 24.9307 33.3342 24.9481 33.2901 24.9705C33.2022 25.0114 33.119 25.0618 33.0418 25.1206C32.9263 25.2132 32.8319 25.3293 32.7647 25.4613L31.1768 29.018C31.1059 29.166 31.0938 29.3354 31.1431 29.492C31.1925 29.6485 31.2994 29.7804 31.4424 29.861L33.3247 30.9119C33.3896 31.0631 33.4038 31.2312 33.3652 31.3911C33.2377 31.9437 33.1394 32.5026 33.0707 33.0656C33.0065 33.5023 32.8041 33.907 32.4933 34.2204H32.4644L30.1548 36.3105C30.1107 36.3451 30.0717 36.386 30.0394 36.4318C29.9999 36.476 29.9687 36.5268 29.947 36.5819C29.7944 36.8328 29.7313 37.1279 29.768 37.4192L30.2126 39.9251C30.2207 39.9934 30.2435 40.0593 30.2794 40.1181C30.3152 40.1768 30.3633 40.2272 30.4204 40.2657L33.1804 41.8824C33.1266 41.8429 33.0815 41.7928 33.0477 41.7352C33.014 41.6776 32.9923 41.6138 32.9841 41.5475L32.5395 39.0416C32.5084 38.8834 32.5084 38.7206 32.5395 38.5624C32.5997 38.3131 32.7275 38.0853 32.909 37.9042L35.2186 35.8198C35.5271 35.5047 35.7291 35.1008 35.796 34.665C35.8667 34.102 35.967 33.543 36.0962 32.9905C36.1404 32.8148 36.126 32.6294 36.0551 32.4627C35.9842 32.2959 35.8608 32.1568 35.7036 32.0667L34.3121 31.4893C34.229 31.4559 34.1535 31.4061 34.0901 31.3428C34.0268 31.2795 33.9769 31.2041 33.9435 31.121C33.91 31.038 33.8937 30.949 33.8955 30.8595C33.8974 30.7699 33.9173 30.6817 33.9541 30.6001L35.565 27.0837C35.6303 26.9506 35.7251 26.8341 35.8422 26.7431C36.041 26.5769 36.2934 26.4887 36.5524 26.4948L38.2846 26.5756C38.4552 26.5789 38.6246 26.5454 38.7811 26.4775C39.0102 26.3868 39.2099 26.235 39.3585 26.0386C39.7454 25.4613 40.1611 24.9531 40.5942 24.445C40.8583 24.1009 40.9986 23.6778 40.9926 23.244L40.8309 20.7786C40.8273 20.6335 40.8488 20.489 40.8944 20.3513C40.9746 20.0881 41.129 19.8535 41.339 19.6757L44.0181 17.6317C44.0869 17.566 44.1746 17.5234 44.2688 17.5099C44.363 17.4965 44.4591 17.5128 44.5436 17.5567L41.7374 15.9631ZM37.7361 42.1654C37.7896 41.9747 37.7916 41.7732 37.7419 41.5815C37.6922 41.3898 37.5926 41.2147 37.4531 41.0741C37.2862 40.8939 37.1337 40.7008 36.997 40.4967C36.8976 40.3453 36.7433 40.2384 36.5667 40.1985C36.39 40.1587 36.2048 40.189 36.0501 40.283L34.7047 41.1491L33.7231 43.7301C33.6734 43.8566 33.6698 43.9966 33.7131 44.1255C33.7564 44.2543 33.8438 44.3638 33.9599 44.4345L36.7776 46.0166C36.6592 45.9465 36.5697 45.8365 36.5252 45.7063C36.4808 45.5761 36.4842 45.4343 36.5351 45.3064L37.7361 42.1654Z",
    fill: "#E2F0FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2725 35.8255L32.9629 37.9099C32.7814 38.0911 32.6535 38.3189 32.5933 38.5682L29.793 36.9977C29.8254 36.8708 29.8739 36.7485 29.9373 36.6339C29.959 36.5788 29.9903 36.528 30.0297 36.4838C30.0621 36.438 30.101 36.3971 30.1452 36.3625L32.4548 34.2723L35.2725 35.8255Z",
    fill: "#D9E0E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7629 26.4717C38.6064 26.5397 38.437 26.5732 38.2664 26.5699L36.5342 26.489C36.2752 26.4829 36.0228 26.5712 35.824 26.7373L33.0352 25.1379C33.1123 25.0791 33.1955 25.0288 33.2834 24.9878C33.3276 24.9655 33.3741 24.948 33.422 24.9359C33.4609 24.9208 33.5017 24.9111 33.5433 24.907C33.5912 24.9013 33.6397 24.9013 33.6876 24.907H33.728L35.4602 24.9878C35.5118 24.9964 35.5645 24.9964 35.6161 24.9878H35.7316C35.8067 24.9878 35.8759 24.9416 35.951 24.9185L38.7629 26.4717Z",
    fill: "#D9E0E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5411 20.1607C56.4635 20.1259 56.3779 20.1128 56.2934 20.123C56.209 20.1332 56.1289 20.1662 56.0618 20.2185L53.6945 21.7313C53.5405 21.8259 53.3557 21.8571 53.1791 21.8183C53.0025 21.7795 52.8479 21.6738 52.7476 21.5234C52.6103 21.3182 52.4557 21.125 52.2857 20.946C52.1467 20.8051 52.0478 20.6297 51.9991 20.4379C51.9504 20.2462 51.9537 20.0449 52.0085 19.8547L52.2337 19.2773L53.2441 18.6306C53.3135 18.578 53.3962 18.5458 53.483 18.5376C53.5697 18.5295 53.6569 18.5457 53.7349 18.5845L56.5411 20.1607Z",
    fill: "#D9E0E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9547 15.9862C52.8997 15.9581 52.8415 15.9368 52.7815 15.9227L50.9973 15.5358C50.8031 15.4998 50.6025 15.5236 50.4221 15.604C50.2417 15.6844 50.0899 15.8177 49.9869 15.9862L48.3182 19.0926C48.2205 19.257 48.0909 19.4003 47.9371 19.5141L45.1367 17.932C45.2869 17.8201 45.4127 17.6786 45.5063 17.5163L47.1865 14.4099C47.2874 14.2407 47.4379 14.1066 47.6177 14.0261C47.7975 13.9455 47.9977 13.9222 48.1912 13.9595L49.9695 14.3464C50.035 14.3605 50.0975 14.3859 50.1543 14.4214L52.9547 15.9862Z",
    fill: "#D9E0E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5434 17.5625C44.459 17.5186 44.3629 17.5022 44.2687 17.5157C44.1745 17.5292 44.0868 17.5717 44.018 17.6375L41.3504 19.6757C41.1404 19.8535 40.9861 20.0881 40.9058 20.3513L38.1055 18.7865C38.1055 18.7519 38.1055 18.7172 38.1055 18.6884C38.1657 18.5418 38.2453 18.4039 38.3422 18.2784C38.3621 18.2489 38.3854 18.2218 38.4115 18.1976C38.4434 18.1638 38.4781 18.1329 38.5154 18.1052L41.183 16.067C41.2753 15.9897 41.3917 15.9468 41.5121 15.9457C41.5801 15.9467 41.6471 15.9624 41.7084 15.9919L44.5434 17.5625Z",
    fill: "#D9E0E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2048 23.0189L56.7602 20.5187C56.7559 20.4398 56.7296 20.3636 56.6841 20.2989C56.6386 20.2342 56.5758 20.1836 56.503 20.1529C56.4301 20.1222 56.3501 20.1126 56.272 20.1252C56.1939 20.1378 56.121 20.1722 56.0615 20.2243L53.6942 21.7313C53.5401 21.8259 53.3554 21.8571 53.1788 21.8183C53.0022 21.7796 52.8475 21.6739 52.7472 21.5234C52.6071 21.3294 52.4527 21.146 52.2853 20.9749C52.1489 20.8312 52.0517 20.6548 52.0032 20.4626C51.9546 20.2705 51.9564 20.0691 52.0082 19.8778L53.2149 16.7079C53.2516 16.6267 53.269 16.5382 53.2657 16.4492C53.2624 16.3602 53.2386 16.2731 53.1961 16.1948C53.1537 16.1166 53.0936 16.0492 53.0208 15.9979C52.9479 15.9467 52.8642 15.9131 52.7761 15.8996L50.9977 15.5127C50.8038 15.4777 50.6037 15.5025 50.4242 15.584C50.2447 15.6655 50.0943 15.7998 49.9931 15.9689L48.3186 19.0695C48.0857 19.4332 47.7253 19.6968 47.3082 19.8085C46.935 19.9013 46.5685 20.019 46.2111 20.1608C46.1318 20.1976 46.0455 20.217 45.9581 20.2178C45.8707 20.2185 45.7841 20.2004 45.7042 20.1649C45.6244 20.1293 45.553 20.077 45.495 20.0116C45.4371 19.9461 45.3938 19.869 45.3681 19.7855L44.7907 17.8454C44.7755 17.7661 44.739 17.6925 44.6851 17.6324C44.6312 17.5723 44.562 17.528 44.4848 17.5043C44.4077 17.4805 44.3255 17.4782 44.2472 17.4976C44.1688 17.5171 44.0972 17.5574 44.0401 17.6144L41.3725 19.6527C41.2125 19.7883 41.0841 19.9573 40.9963 20.1478C40.9085 20.3383 40.8635 20.5457 40.8644 20.7555L40.9914 23.2441C40.9912 23.6779 40.8448 24.099 40.5757 24.4393C40.1367 24.9489 39.7243 25.4808 39.3401 26.0329C39.2113 26.1984 39.0468 26.3327 38.8588 26.4257C38.6708 26.5187 38.4643 26.568 38.2546 26.5699L36.5224 26.489C36.3206 26.4852 36.1217 26.537 35.9475 26.6389C35.7733 26.7408 35.6306 26.8887 35.535 27.0664L33.9241 30.577C33.8841 30.6616 33.8625 30.7537 33.8606 30.8472C33.8588 30.9408 33.8767 31.0337 33.9132 31.1198C33.9497 31.2059 34.004 31.2834 34.0726 31.3471C34.1411 31.4107 34.2224 31.4592 34.3109 31.4893L35.6967 32.0667C35.8702 32.1442 36.0122 32.2785 36.0993 32.4475C36.1864 32.6164 36.2134 32.81 36.1759 32.9963C36.0439 33.5482 35.9436 34.1073 35.8757 34.6708C35.8115 35.1075 35.6091 35.5121 35.2983 35.8256L32.9367 37.9388C32.7862 38.0878 32.6719 38.2695 32.6028 38.4697C32.5337 38.67 32.5117 38.8835 32.5383 39.0936L32.9829 41.5995C32.9875 41.679 33.0141 41.7557 33.0599 41.8208C33.1057 41.886 33.1687 41.937 33.242 41.9682C33.3152 41.9995 33.3957 42.0096 33.4744 41.9975C33.5531 41.9854 33.6269 41.9515 33.6874 41.8998L36.0489 40.387C36.2026 40.2909 36.3878 40.2589 36.5648 40.2977C36.7418 40.3366 36.8965 40.4432 36.9958 40.5949C37.1345 40.7991 37.289 40.9921 37.4578 41.1723C37.5967 41.3132 37.6956 41.4885 37.7443 41.6803C37.793 41.8721 37.7898 42.0734 37.7349 42.2635L36.5281 45.3468C36.4959 45.4269 36.4819 45.5131 36.4874 45.5992C36.4928 45.6854 36.5175 45.7692 36.5596 45.8445C36.6017 45.9198 36.6601 45.9848 36.7306 46.0346C36.8011 46.0843 36.8819 46.1177 36.967 46.1321L38.7454 46.519C38.9396 46.5558 39.1405 46.5324 39.3211 46.4519C39.5017 46.3714 39.6533 46.2377 39.7558 46.0686L41.4303 42.9622C41.6632 42.5985 42.0235 42.3349 42.4407 42.2231C42.8144 42.1321 43.181 42.0144 43.5378 41.8709C43.6168 41.8351 43.7025 41.8164 43.7893 41.8162C43.876 41.816 43.9618 41.8343 44.041 41.8698C44.1202 41.9053 44.1909 41.9572 44.2485 42.0221C44.3061 42.087 44.3492 42.1634 44.375 42.2462L44.9524 44.192C44.9693 44.2702 45.0067 44.3424 45.0608 44.4013C45.1149 44.4602 45.1837 44.5037 45.2601 44.5272C45.3365 44.5507 45.4178 44.5534 45.4957 44.5351C45.5735 44.5168 45.6451 44.4781 45.703 44.423L48.3706 42.379C48.5288 42.2435 48.6557 42.0752 48.7424 41.8857C48.8291 41.6963 48.8737 41.4903 48.8729 41.282L48.717 38.8107C48.7172 38.3769 48.8637 37.9558 49.1327 37.6155C49.5658 37.1074 49.9815 36.5762 50.3684 36.0219C50.4971 35.8563 50.6617 35.7221 50.8496 35.6291C51.0376 35.5361 51.2442 35.4868 51.4539 35.4849L53.1861 35.5715C53.3867 35.5737 53.5842 35.521 53.7571 35.4193C53.9301 35.3176 54.072 35.1705 54.1676 34.9941L55.7901 31.4893C55.8305 31.407 55.853 31.3171 55.8563 31.2256C55.8596 31.134 55.8436 31.0427 55.8093 30.9577C55.775 30.8728 55.7231 30.796 55.6572 30.7324C55.5912 30.6687 55.5125 30.6198 55.4264 30.5886L54.0406 30.0112C53.8668 29.9344 53.7247 29.8 53.6385 29.6306C53.5522 29.4612 53.527 29.2673 53.5671 29.0816C53.6978 28.5296 53.7962 27.9705 53.8616 27.4071C53.9274 26.9709 54.1295 26.5667 54.439 26.2523L56.8063 24.139C56.9524 23.9941 57.064 23.8181 57.133 23.6243C57.2019 23.4304 57.2264 23.2235 57.2048 23.0189ZM45.8185 36.3799C42.9315 38.5913 40.1658 37.9908 39.6403 35.0345C39.1149 32.0782 41.0376 27.8979 43.9246 25.7153C46.8116 23.5328 49.5831 24.1044 50.1028 27.0607C50.6224 30.0169 48.7112 34.1684 45.8185 36.3799Z",
    fill: "#C6D9EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1253 58.5577C57.0336 58.5138 56.9318 58.495 56.8304 58.5031C56.729 58.5112 56.6316 58.546 56.5479 58.6038L55.3932 59.3545L55.1391 60.0358C55.0754 60.2567 55.0713 60.4906 55.127 60.7136C55.1828 60.9367 55.2965 61.1411 55.4567 61.3061C55.6486 61.5049 55.8261 61.7172 55.9879 61.9412C56.1054 62.1139 56.2849 62.2347 56.4891 62.2788C56.6933 62.3229 56.9066 62.2868 57.0849 62.1779L59.816 60.4457C59.8966 60.3818 59.9939 60.3424 60.0962 60.3322C60.1986 60.3219 60.3018 60.3413 60.3934 60.388L57.1253 58.5577ZM52.9277 68.3099C52.5408 66.162 51.132 65.0822 49.3074 65.2324C49.484 65.6348 49.6101 66.0576 49.6827 66.4911C50.2601 69.9035 48.066 74.7421 44.7228 77.3C43.7259 78.1336 42.5123 78.6663 41.2238 78.8358C42.3209 81.1454 45.0924 81.336 47.9736 79.1303C51.311 76.5667 53.5282 71.7223 52.9277 68.3099ZM52.9854 53.7306C52.918 53.689 52.8437 53.6597 52.766 53.644L50.7105 53.1936C50.4874 53.1534 50.2573 53.1821 50.051 53.276C49.8447 53.3698 49.6719 53.5244 49.5557 53.7191L47.6156 57.3105C47.5057 57.4948 47.3605 57.6557 47.1883 57.7839C47.0874 57.8694 46.9769 57.943 46.8592 58.0033L47.4366 59.9607C47.4659 60.057 47.5156 60.1459 47.5823 60.2212C47.6491 60.2966 47.7314 60.3566 47.8235 60.3971C47.9156 60.4377 48.0154 60.4579 48.1161 60.4563C48.2167 60.4548 48.3158 60.4314 48.4066 60.388C48.8216 60.2279 49.2458 60.0929 49.6769 59.9838C49.9429 59.9091 50.1919 59.7836 50.4102 59.6143C50.5877 59.4838 50.7369 59.3189 50.849 59.1293L52.7775 55.5379C52.8977 55.3471 53.0711 55.1957 53.2763 55.1024C53.4815 55.009 53.7096 54.9777 53.9323 55.0124L55.9936 55.4686C56.0642 55.4811 56.1324 55.5045 56.1957 55.5379L52.9854 53.7306ZM47.2114 88.4668C47.1169 88.3878 47.0501 88.2805 47.0209 88.1608L46.3222 85.9147C46.2936 85.8179 46.2444 85.7284 46.1779 85.6525C46.1114 85.5765 46.0292 85.5159 45.937 85.4747C45.8448 85.4335 45.7448 85.4128 45.6438 85.4141C45.5429 85.4153 45.4434 85.4383 45.3522 85.4817C44.9414 85.6478 44.5187 85.7829 44.0877 85.8859C43.9467 85.9252 43.811 85.9814 43.6835 86.0533L43.7759 86.342C43.8157 86.4878 43.9111 86.6122 44.0415 86.6885L47.2114 88.4668ZM43.2678 55.5552C43.1983 55.5186 43.1212 55.4988 43.0426 55.4974C42.9043 55.499 42.7711 55.5503 42.6673 55.6418L39.5782 57.9976C39.537 58.0311 39.4984 58.0678 39.4628 58.1073C39.4328 58.1353 39.4057 58.1663 39.3819 58.1997C39.2681 58.3408 39.1766 58.4985 39.1105 58.6674C39.1105 58.7078 39.1105 58.7482 39.0759 58.7828C39.0178 58.9377 38.9903 59.1025 38.9951 59.2679L39.1741 62.126C39.1766 62.6272 39.0075 63.1142 38.6948 63.5059C38.1887 64.0955 37.7127 64.7102 37.2687 65.3478C37.0288 65.6463 36.6915 65.8508 36.3159 65.9252C36.2738 65.9309 36.2311 65.9309 36.1889 65.9252C36.1296 65.9337 36.0693 65.9337 36.0099 65.9252L34.0294 65.8329H33.9833C33.9295 65.8269 33.8753 65.8269 33.8216 65.8329C33.7703 65.8341 33.7196 65.8438 33.6715 65.8617C33.6138 65.8778 33.5578 65.8991 33.504 65.9252C33.4033 65.9718 33.3084 66.03 33.2211 66.0985C33.0887 66.2055 32.9805 66.3393 32.9035 66.4911L31.0443 70.5329C30.9644 70.705 30.9521 70.9008 31.0099 71.0816C31.0676 71.2623 31.1912 71.4148 31.3561 71.5087L33.556 72.7443C33.6337 72.9266 33.6499 73.1293 33.6022 73.3217C33.4538 73.9598 33.3401 74.6055 33.2615 75.256C33.1841 75.7554 32.9518 76.2179 32.5975 76.5782H32.5629L29.8606 78.9917C29.8134 79.0371 29.7691 79.0853 29.7278 79.1361C29.6852 79.1897 29.6484 79.2478 29.6181 79.3093C29.4412 79.6019 29.3699 79.9463 29.416 80.2851L29.9299 83.1721C29.9405 83.2502 29.9669 83.3254 30.0077 83.3929C30.0484 83.4605 30.1025 83.5189 30.1667 83.5647L33.4001 85.372C33.3368 85.329 33.2838 85.2725 33.2449 85.2066C33.206 85.1407 33.1821 85.0671 33.1749 84.9909L32.661 82.1039C32.6263 81.9114 32.6382 81.7135 32.6957 81.5265C32.7625 81.2399 32.9086 80.9778 33.1172 80.7701L35.7963 78.4779H35.8309C36.1856 78.1194 36.4198 77.6592 36.5007 77.1614C36.5784 76.5085 36.6941 75.8608 36.8471 75.2213C36.8894 75.0032 36.855 74.7772 36.7498 74.5815C36.6445 74.3858 36.475 74.2325 36.2698 74.1474L34.6704 73.4834C34.5742 73.445 34.4868 73.3875 34.4134 73.3144C34.34 73.2413 34.2821 73.1542 34.2433 73.0582C34.2044 72.9622 34.1854 72.8593 34.1874 72.7557C34.1893 72.6522 34.2122 72.5501 34.2546 72.4556L36.1139 68.4138C36.1872 68.2581 36.2959 68.1216 36.4314 68.0154C36.665 67.8307 36.9535 67.7291 37.2513 67.7267L39.2376 67.8249C39.4358 67.8313 39.6329 67.7939 39.815 67.7152C40.0869 67.6131 40.3234 67.4347 40.4963 67.2013C40.9467 66.5662 41.4259 65.9483 41.9282 65.3594C42.2397 64.967 42.4087 64.4804 42.4075 63.9794L42.2227 61.1271C42.2149 60.9601 42.2404 60.7933 42.2978 60.6363C42.3893 60.3319 42.568 60.0609 42.8117 59.8568L45.8834 57.4721C45.9673 57.4021 46.0694 57.3574 46.1777 57.3431C46.2861 57.3288 46.3962 57.3455 46.4955 57.3913L43.2678 55.5552ZM38.6486 85.8455C38.7099 85.6248 38.7123 85.392 38.6555 85.1701C38.5988 84.9482 38.4849 84.7451 38.3253 84.581C38.1301 84.3851 37.9524 84.1725 37.7941 83.9458C37.6794 83.7714 37.5013 83.6486 37.2976 83.6033C37.0939 83.5581 36.8805 83.5939 36.7028 83.7033L35.1438 84.7022L33.989 87.6874C33.929 87.8327 33.924 87.995 33.9751 88.1438C34.0261 88.2926 34.1296 88.4177 34.2662 88.4957L37.5285 90.3203C37.392 90.2393 37.2894 90.1117 37.2395 89.9611C37.1897 89.8104 37.1959 89.6468 37.2571 89.5004L38.6486 85.8455Z",
    fill: "#E2F0FE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7967 78.4779L33.1002 80.8914C32.8916 81.099 32.7456 81.3611 32.6787 81.6478L29.4453 79.829C29.4845 79.6833 29.5387 79.542 29.607 79.4075C29.6373 79.346 29.674 79.2879 29.7167 79.2343C29.7579 79.1834 29.8023 79.1352 29.8495 79.0899L32.5517 76.6764L35.7967 78.4779Z",
    fill: "#D9E0E6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8372 67.6691C39.6552 67.7477 39.4581 67.7852 39.2599 67.7788L37.2736 67.6806C36.9758 67.683 36.6873 67.7846 36.4537 67.9693L33.1914 66.1332C33.2787 66.0647 33.3736 66.0065 33.4743 65.96C33.5281 65.9338 33.5842 65.9125 33.6418 65.8964C33.6899 65.8785 33.7406 65.8688 33.7919 65.8676C33.8456 65.8616 33.8998 65.8616 33.9536 65.8676H33.9998L35.9802 65.96C36.0396 65.9684 36.0999 65.9684 36.1592 65.96C36.2015 65.9628 36.244 65.9628 36.2863 65.96C36.3745 65.9362 36.4613 65.9073 36.5461 65.8733L39.8372 67.6691Z",
    fill: "#D9E0E6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3638 60.3592C60.2716 60.3133 60.1682 60.2948 60.0658 60.3061C59.9634 60.3174 59.8665 60.3578 59.7864 60.4227L57.0554 62.1549C56.8767 62.2646 56.6625 62.3006 56.4578 62.2554C56.2531 62.2101 56.074 62.0871 55.9583 61.9124C55.7968 61.6881 55.6193 61.4758 55.4271 61.2772C55.2643 61.1152 55.1487 60.9118 55.0928 60.6891C55.0368 60.4663 55.0426 60.2325 55.1095 60.0127L55.3636 59.3372L56.5184 58.5865C56.5992 58.5229 56.6969 58.4841 56.7994 58.4749C56.9019 58.4656 57.0048 58.4864 57.0958 58.5346L60.3638 60.3592Z",
    fill: "#D9E0E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.22 55.5437C56.1567 55.5103 56.0885 55.4869 56.0179 55.4744L53.9566 55.0182C53.7339 54.9835 53.5058 55.0148 53.3006 55.1082C53.0954 55.2015 52.922 55.3529 52.8018 55.5437L50.8733 59.1351C50.7612 59.3247 50.612 59.4896 50.4345 59.6201L47.1953 57.7897C47.3675 57.6615 47.5126 57.5006 47.6226 57.3163L49.5626 53.7249C49.6788 53.5302 49.8516 53.3756 50.058 53.2818C50.2643 53.1879 50.4944 53.1592 50.7174 53.1994L52.773 53.6498C52.8507 53.6655 52.9249 53.6948 52.9924 53.7364L56.22 55.5437Z",
    fill: "#D9E0E6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4973 57.3682C46.3981 57.3224 46.288 57.3057 46.1796 57.32C46.0713 57.3343 45.9692 57.379 45.8853 57.4491L42.8078 59.8106C42.5641 60.0147 42.3854 60.2857 42.2939 60.5901L39.0547 58.7713C39.0547 58.7366 39.0547 58.6962 39.0893 58.6558C39.1553 58.487 39.2469 58.3292 39.3607 58.1881C39.3845 58.1547 39.4116 58.1238 39.4415 58.0957C39.4772 58.0563 39.5158 58.0196 39.557 57.986L42.6461 55.6303C42.7499 55.5387 42.8831 55.4875 43.0214 55.4859C43.1 55.4873 43.1771 55.5071 43.2466 55.5436L46.4973 57.3682Z",
    fill: "#D9E0E6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.132 63.6792L60.6181 60.7922C60.6139 60.6998 60.5837 60.6105 60.531 60.5346C60.4782 60.4586 60.4051 60.3991 60.32 60.3629C60.2349 60.3267 60.1414 60.3153 60.0501 60.3299C59.9588 60.3446 59.8735 60.3847 59.804 60.4457L57.0787 62.1779C56.9001 62.2876 56.6858 62.3237 56.4811 62.2784C56.2765 62.2332 56.0974 62.1102 55.9816 61.9354C55.8204 61.711 55.6428 61.4987 55.4504 61.3003C55.2897 61.1369 55.1756 60.9335 55.1198 60.7112C55.0639 60.4889 55.0685 60.2558 55.1329 60.0358L56.5244 56.3751C56.5621 56.2823 56.5785 56.1821 56.5723 56.0821C56.5662 55.9821 56.5377 55.8847 56.489 55.7972C56.4402 55.7096 56.3724 55.6341 56.2906 55.5763C56.2088 55.5184 56.1151 55.4796 56.0163 55.4628L53.955 55.0182C53.7319 54.9788 53.5022 55.0079 53.296 55.1017C53.0898 55.1955 52.917 55.3496 52.8002 55.5436L50.8717 59.1293C50.6036 59.5452 50.193 59.8491 49.7169 59.9838C49.2874 60.0921 48.865 60.2271 48.4524 60.388C48.3611 60.4315 48.2616 60.4548 48.1606 60.4564C48.0596 60.458 47.9594 60.4379 47.8668 60.3973C47.7743 60.3568 47.6915 60.2969 47.6242 60.2215C47.5568 60.1462 47.5065 60.0572 47.4766 59.9607L46.7664 57.7204C46.7481 57.6287 46.7055 57.5437 46.643 57.4742C46.5805 57.4047 46.5004 57.3533 46.4111 57.3255C46.3219 57.2977 46.2267 57.2946 46.1358 57.3163C46.0449 57.338 45.9615 57.3839 45.8945 57.4491L42.817 59.8106C42.6335 59.9671 42.4867 60.162 42.387 60.3815C42.2872 60.601 42.2369 60.8398 42.2396 61.0809L42.4243 63.9332C42.4269 64.4345 42.2578 64.9215 41.9451 65.3132C41.4428 65.8906 40.9635 66.52 40.5131 67.1609C40.3644 67.3516 40.1744 67.5063 39.9574 67.6132C39.7404 67.7202 39.5021 67.7768 39.2602 67.7787L37.2797 67.6805C37.043 67.6758 36.8096 67.737 36.6056 67.8573C36.4017 67.9776 36.2352 68.1523 36.1249 68.3619L34.2599 72.4036C34.2175 72.4981 34.1946 72.6002 34.1927 72.7038C34.1907 72.8073 34.2097 72.9102 34.2486 73.0062C34.2874 73.1022 34.3453 73.1894 34.4187 73.2625C34.4921 73.3355 34.5795 73.393 34.6757 73.4314L36.2751 74.0954C36.4803 74.1805 36.6498 74.3339 36.7551 74.5296C36.8603 74.7252 36.8947 74.9513 36.8525 75.1694C36.704 75.8095 36.5903 76.4571 36.5118 77.1094C36.4239 77.6215 36.1727 78.0914 35.7958 78.449L33.0647 80.8914C32.8944 81.0611 32.7649 81.2672 32.6859 81.4943C32.6069 81.7213 32.5804 81.9633 32.6086 82.2021L33.1225 85.0891C33.1277 85.1809 33.1586 85.2695 33.2118 85.3446C33.2649 85.4198 33.3381 85.4784 33.423 85.514C33.5079 85.5495 33.6011 85.5604 33.6919 85.5455C33.7827 85.5306 33.8675 85.4905 33.9366 85.4297L36.6619 83.6975C36.8398 83.5873 37.0536 83.5503 37.2582 83.5945C37.4628 83.6386 37.6423 83.7605 37.759 83.9343C37.9173 84.161 38.095 84.3735 38.2902 84.5694C38.4503 84.7332 38.5641 84.9365 38.6199 85.1587C38.6757 85.3809 38.6715 85.6139 38.6077 85.8339L37.2162 89.5004C37.1796 89.5933 37.1642 89.6933 37.1712 89.793C37.1782 89.8926 37.2074 89.9895 37.2566 90.0764C37.3059 90.1633 37.374 90.2381 37.4559 90.2953C37.5378 90.3525 37.6315 90.3906 37.7301 90.4069L39.7856 90.8573C40.0084 90.892 40.2364 90.8607 40.4416 90.7673C40.6469 90.674 40.8202 90.5226 40.9404 90.3318L42.8747 86.7462C43.1391 86.3269 43.5512 86.0219 44.0295 85.8917C44.4593 85.7821 44.8817 85.6452 45.294 85.4817C45.3857 85.4393 45.4855 85.417 45.5865 85.4162C45.6876 85.4155 45.7876 85.4363 45.88 85.4773C45.9723 85.5183 46.0549 85.5785 46.1221 85.6539C46.1893 85.7294 46.2397 85.8183 46.2698 85.9147L46.9627 88.1608C46.9817 88.252 47.0249 88.3365 47.0878 88.4053C47.1506 88.4741 47.2308 88.5247 47.32 88.5518C47.4091 88.579 47.5039 88.5817 47.5944 88.5596C47.685 88.5376 47.7679 88.4915 47.8345 88.4264L50.9121 86.0706C51.0956 85.913 51.2425 85.7171 51.3422 85.4966C51.442 85.2762 51.4922 85.0366 51.4895 84.7946L51.3047 81.9423C51.3031 81.4412 51.4721 80.9545 51.7839 80.5623C52.2921 79.9849 52.7655 79.3555 53.2159 78.7204C53.3647 78.5296 53.5547 78.375 53.7716 78.268C53.9886 78.161 54.2269 78.1045 54.4688 78.1026L56.4493 78.1949C56.6863 78.2011 56.9203 78.1404 57.1245 78.0199C57.3286 77.8995 57.4949 77.724 57.6041 77.5136L59.4691 73.4718C59.5115 73.3774 59.5344 73.2753 59.5364 73.1717C59.5383 73.0682 59.5193 72.9653 59.4805 72.8693C59.4416 72.7733 59.3838 72.6861 59.3104 72.613C59.237 72.5399 59.1496 72.4825 59.0534 72.4441L57.454 71.7801C57.2481 71.6959 57.0778 71.5427 56.9725 71.3467C56.8671 71.1508 56.8332 70.9243 56.8766 70.7061C57.025 70.068 57.1387 69.4223 57.2173 68.7718C57.2956 68.2732 57.5301 67.8122 57.887 67.4553L60.6181 65.0072C60.802 64.8417 60.9443 64.6352 61.0336 64.4045C61.1228 64.1738 61.1566 63.9253 61.132 63.6792ZM47.9731 79.1188C44.63 81.6767 41.4312 80.9838 40.8307 77.5656C40.2302 74.1474 42.4417 69.3146 45.7848 66.7567C49.1279 64.1988 52.3209 64.8975 52.9272 68.3099C53.5335 71.7223 51.3105 76.5667 47.9731 79.1188Z",
    fill: "#C6D9EC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9831 52.1313C72.0652 51.9474 72.1018 51.7464 72.0897 51.5454C72.0777 51.3444 72.0173 51.1492 71.9138 50.9765C71.4615 50.2549 71.1025 49.4788 70.8456 48.6669C70.8219 48.5875 70.7813 48.5141 70.7267 48.4518C70.6721 48.3895 70.6047 48.3396 70.5291 48.3057C70.4535 48.2717 70.3715 48.2544 70.2886 48.255C70.2057 48.2555 70.124 48.2739 70.0488 48.3089L68.894 48.817C69.0072 49.0497 69.1344 49.2753 69.2751 49.4925C69.3773 49.6658 69.4368 49.8608 69.4488 50.0616C69.4609 50.2624 69.4251 50.4631 69.3444 50.6473L66.1572 56.8948C66.0811 57.0546 66.068 57.2372 66.1204 57.4062C66.1728 57.5752 66.2869 57.7184 66.4401 57.8071L69.0557 59.2737C68.9104 59.1807 68.8043 59.0376 68.7575 58.8716C68.7106 58.7056 68.7264 58.5281 68.8016 58.3729L71.9831 52.1313ZM86.1293 8.63591C86.0779 8.60831 86.0202 8.59439 85.9619 8.59549C85.8682 8.59582 85.7763 8.62178 85.6963 8.67055L80.3265 11.6846L80.2457 11.7365L80.1648 11.8L80.0898 11.8693C80.0408 11.9228 79.9945 11.9786 79.9512 12.0368C79.8099 12.2174 79.7201 12.4329 79.6914 12.6604L79.1486 18.469C79.0843 18.8873 78.8809 19.2718 78.5712 19.5603C77.5279 20.5195 76.5481 21.5456 75.638 22.632C75.5055 22.7726 75.3367 22.874 75.1503 22.9249C74.9639 22.9759 74.767 22.9744 74.5814 22.9207L71.117 21.7659C71.0303 21.7342 70.9375 21.7224 70.8456 21.7313C70.8392 21.7286 70.8324 21.7272 70.8254 21.7272C70.8185 21.7272 70.8116 21.7286 70.8052 21.7313C70.788 21.7284 70.7704 21.7284 70.7532 21.7313H70.6551C70.5444 21.7597 70.4418 21.813 70.3548 21.8872C70.3319 21.8973 70.312 21.9132 70.2971 21.9334C70.241 21.974 70.1955 22.0274 70.1643 22.0893L66.2207 28.7351C66.138 28.8845 66.1076 29.0572 66.1341 29.2259C66.1399 29.3279 66.1664 29.4275 66.2121 29.5189C66.2578 29.6102 66.3216 29.6913 66.3997 29.7571L69.1654 32.0667C69.304 32.1954 69.4028 32.3613 69.4499 32.5445C69.4969 32.7277 69.4904 32.9206 69.431 33.1002C68.9248 34.4174 68.51 35.7678 68.1896 37.142C68.13 37.3664 68.026 37.5765 67.8836 37.7598C67.858 37.8039 67.8269 37.8447 67.7912 37.8811L67.7046 37.985C67.6403 38.0463 67.5729 38.1041 67.5025 38.1582L62.6004 41.5187C62.566 41.5365 62.5348 41.56 62.508 41.588C62.4768 41.6125 62.4495 41.6417 62.4272 41.6746C62.2042 41.9102 62.0713 42.2168 62.0519 42.5407V48.5745C62.0465 48.6501 62.0613 48.7257 62.0948 48.7937C62.1282 48.8617 62.1792 48.9196 62.2424 48.9613L64.8869 50.4453C64.8221 50.4032 64.7698 50.3447 64.7353 50.2757C64.7008 50.2066 64.6853 50.1296 64.6906 50.0526V44.0246C64.702 43.7865 64.7756 43.5555 64.9042 43.3548C64.9911 43.2129 65.1048 43.0893 65.2391 42.9911L70.1412 39.6364C70.2891 39.5298 70.418 39.399 70.5223 39.2495C70.662 39.0603 70.7658 38.8469 70.8283 38.6202C71.1511 37.2466 71.5659 35.8963 72.0697 34.5784C72.1291 34.3988 72.1357 34.2059 72.0886 34.0226C72.0415 33.8394 71.9427 33.6736 71.8041 33.5448L69.0384 31.2352C68.8897 31.1055 68.7967 30.9236 68.7785 30.7271C68.7486 30.5603 68.7793 30.3883 68.8652 30.2421L72.8088 23.5963C72.8793 23.4836 72.9759 23.3895 73.0905 23.3222C73.2051 23.2548 73.3343 23.2162 73.467 23.2094C73.5722 23.1974 73.6788 23.2092 73.7788 23.2441L77.2432 24.3989C77.4302 24.453 77.6285 24.4541 77.8161 24.4021C78.0037 24.3501 78.1732 24.2471 78.3056 24.1044C79.2274 23.0137 80.2229 21.9873 81.285 21.0326C81.5939 20.7459 81.7973 20.3635 81.8624 19.9471L82.3301 14.1674C82.3411 14.0468 82.3744 13.9294 82.4282 13.8209C82.5386 13.5612 82.7261 13.3415 82.9652 13.1916L88.3408 10.1256C88.4006 10.0888 88.4676 10.0652 88.5373 10.0562C88.607 10.0473 88.6777 10.0532 88.7449 10.0736L86.1293 8.63591ZM82.4975 60.3592C82.4436 60.3185 82.3996 60.2663 82.3686 60.2063C82.3376 60.1464 82.3205 60.0802 82.3185 60.0127L81.7989 54.9432C81.7892 54.861 81.762 54.7818 81.7191 54.711C81.6762 54.6402 81.6185 54.5795 81.5501 54.533C81.4816 54.4864 81.404 54.4551 81.3224 54.4412C81.2408 54.4273 81.1571 54.4311 81.0771 54.4524C80.4865 54.5832 79.8857 54.6624 79.2814 54.6891L79.6798 58.5404C79.6821 58.611 79.7025 58.6799 79.7388 58.7405C79.7752 58.8012 79.8264 58.8515 79.8877 58.8868L82.4975 60.3592ZM90.9044 23.9831C91.6724 25.0167 92.0592 26.5987 92.0592 28.6658C92.0592 34.2897 88.0174 41.1318 82.9883 43.9495C81.0367 45.0466 79.3738 45.4104 78.0689 45.1043C79.6914 46.9462 82.4686 47.1945 85.627 45.4219C90.6388 42.61 94.6979 35.7678 94.6979 30.1382C94.721 26.72 93.214 24.5605 90.9044 23.9831ZM96.101 7.76981C95.9436 7.68446 95.7604 7.65966 95.5859 7.70008C95.4115 7.7405 95.2579 7.84334 95.1541 7.98922L91.1816 13.7632C91.1656 13.7906 91.1462 13.8158 91.1238 13.8383C91.0991 13.8745 91.0677 13.9059 91.0314 13.9306C91.0168 13.9488 90.9993 13.9645 90.9795 13.9768L90.9217 14.0173C90.6928 14.1773 90.4215 14.2658 90.1422 14.2713C89.8807 14.2569 89.6185 14.2569 89.357 14.2713L89.484 15.5012C89.4938 15.5827 89.5209 15.6613 89.5634 15.7316C89.606 15.8019 89.6631 15.8622 89.7309 15.9087C89.7986 15.9552 89.8755 15.9866 89.9564 16.001C90.0373 16.0153 90.1204 16.0123 90.2 15.992C91.0497 15.8085 91.9176 15.7232 92.7867 15.7379C93.064 15.7365 93.3341 15.6498 93.5604 15.4896C93.6632 15.4232 93.7516 15.3368 93.8203 15.2356L97.7928 9.42694C97.8954 9.28294 98.0469 9.18125 98.2191 9.14087C98.3912 9.10049 98.5722 9.12418 98.7281 9.20753L96.101 7.76981ZM103.786 18.5556H103.7C103.588 18.5328 103.473 18.547 103.37 18.596L99.7501 20.1839C99.8421 20.3466 99.925 20.5143 99.9984 20.6862C100.068 20.8305 100.131 20.9864 100.189 21.1423C100.206 21.1706 100.218 21.202 100.224 21.2347C100.294 21.3943 100.353 21.5583 100.403 21.7255C100.417 21.7533 100.428 21.7823 100.437 21.8121C100.465 21.9024 100.512 21.9853 100.576 22.0546L100.645 22.1124H100.691C100.732 22.1433 100.779 22.1632 100.83 22.1701H100.876C100.952 22.1874 101.031 22.1874 101.107 22.1701C101.143 22.1647 101.179 22.1529 101.211 22.1355L105.992 20.0395C106.048 20.0158 106.107 20.0036 106.168 20.0036C106.228 20.0036 106.288 20.0158 106.344 20.0395C106.365 20.0332 106.387 20.0332 106.408 20.0395L103.786 18.5556Z",
    fill: "#E2F0FE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7322 9.25371C98.5762 9.17036 98.3953 9.14667 98.2231 9.18705C98.051 9.22743 97.8994 9.32912 97.7968 9.47312L93.8243 15.2817C93.7556 15.383 93.6673 15.4694 93.5645 15.5358L90.9258 14.0519C90.9656 14.0297 91.0025 14.0025 91.0355 13.971C91.0718 13.9463 91.1031 13.9149 91.1279 13.8787C91.1503 13.8562 91.1697 13.831 91.1856 13.8036L95.1581 8.02963C95.2619 7.88375 95.4156 7.7809 95.59 7.74048C95.7644 7.70007 95.9476 7.72487 96.105 7.81022L98.7322 9.25371Z",
    fill: "#D9E0E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4913 39.2495C70.387 39.3991 70.2582 39.5298 70.1102 39.6364L65.2081 42.9911C65.0739 43.0893 64.9601 43.2129 64.8733 43.3548L62.2461 41.8825C62.2881 41.8095 62.3385 41.7417 62.3962 41.6804C62.4186 41.6475 62.4458 41.6183 62.4771 41.5938C62.5038 41.5657 62.535 41.5423 62.5694 41.5245L67.4715 38.164C67.5419 38.1099 67.6094 38.0521 67.6736 37.9908L67.7602 37.8869L67.8526 37.7656L70.4913 39.2495Z",
    fill: "#D9E0E6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.438 23.1979C73.3053 23.2046 73.1761 23.2433 73.0615 23.3107C72.9469 23.378 72.8503 23.4721 72.7798 23.5848L68.8362 30.2306C68.7504 30.3768 68.7196 30.5488 68.7496 30.7156L66.1109 29.2375C66.0844 29.0688 66.1148 28.8961 66.1975 28.7467L70.1411 22.1008C70.1723 22.039 70.2178 21.9856 70.2739 21.945C70.2888 21.9248 70.3087 21.9089 70.3316 21.8988C70.4186 21.8246 70.5212 21.7713 70.6319 21.7429H70.73C70.7472 21.74 70.7648 21.74 70.782 21.7429C70.7884 21.7402 70.7953 21.7388 70.8022 21.7388C70.8092 21.7388 70.816 21.7402 70.8224 21.7429L73.438 23.1979Z",
    fill: "#D9E0E6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7369 10.1256C88.6696 10.1052 88.5989 10.0993 88.5292 10.1082C88.4595 10.1172 88.3925 10.1408 88.3327 10.1776L82.9629 13.1974C82.7237 13.3473 82.5363 13.567 82.4259 13.8267L79.793 12.3428C79.8358 12.2456 79.888 12.1528 79.9489 12.0657C79.9922 12.0075 80.0384 11.9517 80.0874 11.8982L80.1625 11.8289L80.2433 11.7654L80.3242 11.7135L85.694 8.69945C85.774 8.65068 85.8659 8.62472 85.9596 8.62439C86.0179 8.62329 86.0756 8.63721 86.127 8.66481L88.7369 10.1256Z",
    fill: "#D9E0E6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M103.809 18.5613L106.448 20.051C106.427 20.0448 106.405 20.0448 106.385 20.051C106.329 20.0274 106.269 20.0152 106.209 20.0152C106.148 20.0152 106.088 20.0274 106.032 20.051L101.252 22.147C101.144 22.197 101.024 22.2128 100.907 22.1921C100.79 22.1715 100.683 22.1154 100.599 22.0315C100.535 21.9622 100.488 21.8793 100.461 21.789C100.452 21.7592 100.44 21.7302 100.426 21.7024C100.377 21.5352 100.317 21.3712 100.247 21.2116C100.241 21.1788 100.23 21.1474 100.212 21.1192C100.155 20.9633 100.091 20.8074 100.022 20.6631C99.9483 20.4912 99.8654 20.3235 99.7734 20.1607L103.394 18.5729C103.496 18.5238 103.612 18.5096 103.723 18.5325L103.809 18.5671V18.5613Z",
    fill: "#D9E0E6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M106.451 20.0511H106.445V20.0571H106.451V20.0511Z",
    fill: "#D9E0E6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M106.641 26.4659V20.4379C106.651 20.3624 106.64 20.2855 106.607 20.2164C106.575 20.1474 106.524 20.089 106.459 20.0483C106.395 20.0076 106.32 19.9862 106.244 19.9867C106.168 19.9872 106.093 20.0095 106.029 20.0511L101.248 22.147C101.174 22.18 101.093 22.1968 101.012 22.1963C100.93 22.1958 100.85 22.1781 100.775 22.1443C100.701 22.1105 100.635 22.0613 100.581 22.0001C100.527 21.9389 100.487 21.8669 100.463 21.789C100.206 20.9782 99.8489 20.2025 99.4007 19.4794C99.3023 19.3102 99.2444 19.1206 99.2313 18.9253C99.2183 18.73 99.2506 18.5343 99.3257 18.3535L102.513 12.1061C102.59 11.9465 102.604 11.7634 102.552 11.594C102.499 11.4246 102.384 11.2815 102.23 11.1938L98.7656 9.25373C98.6086 9.16486 98.4241 9.13752 98.2481 9.17699C98.072 9.21647 97.9169 9.31996 97.8129 9.46736L93.8404 15.276C93.7176 15.4327 93.5607 15.5594 93.3816 15.6465C93.2025 15.7335 93.006 15.7786 92.8069 15.7783C91.9376 15.7605 91.0693 15.8458 90.2201 16.0324C90.1405 16.0527 90.0575 16.0558 89.9766 16.0414C89.8957 16.027 89.8188 15.9956 89.751 15.9491C89.6832 15.9027 89.6261 15.8423 89.5836 15.772C89.541 15.7017 89.5139 15.6232 89.5042 15.5416L88.9787 10.4663C88.9836 10.3898 88.9663 10.3136 88.9289 10.2468C88.8916 10.1799 88.8357 10.1252 88.7681 10.0893C88.7005 10.0533 88.6239 10.0376 88.5476 10.0441C88.4713 10.0505 88.3985 10.0788 88.3378 10.1256L82.968 13.1454C82.798 13.2525 82.6531 13.3952 82.5435 13.5637C82.4338 13.7321 82.362 13.9223 82.3329 14.1212L81.7843 19.9414C81.718 20.3573 81.5148 20.7393 81.2069 21.0269C80.1444 21.983 79.1472 23.0092 78.2218 24.0986C78.0908 24.2398 77.9233 24.3419 77.7379 24.3939C77.5524 24.4459 77.3562 24.4456 77.1709 24.3931L73.7066 23.2383C73.5292 23.1827 73.3385 23.1864 73.1635 23.2489C72.9884 23.3115 72.8385 23.4293 72.7365 23.5847L68.7929 30.2363C68.7039 30.3968 68.6726 30.5828 68.7041 30.7635C68.7357 30.9442 68.8281 31.1087 68.9661 31.2295L71.7319 33.5391C71.8711 33.6674 71.9703 33.8332 72.0174 34.0166C72.0645 34.2 72.0576 34.3931 71.9975 34.5726C71.4915 35.8898 71.0767 37.2402 70.7561 38.6144C70.6438 39.0173 70.4024 39.3723 70.069 39.6248L65.1669 42.9853C65.0018 43.1045 64.8647 43.2581 64.765 43.4356C64.6653 43.6131 64.6054 43.8101 64.5895 44.0131V50.0411C64.5793 50.1166 64.5911 50.1935 64.6234 50.2625C64.6556 50.3316 64.707 50.39 64.7715 50.4307C64.8359 50.4714 64.9107 50.4928 64.9869 50.4923C65.0631 50.4918 65.1376 50.4695 65.2015 50.4279L69.9766 48.332C70.0517 48.297 70.1335 48.2786 70.2164 48.2781C70.2992 48.2775 70.3812 48.2948 70.4568 48.3288C70.5324 48.3627 70.5998 48.4126 70.6544 48.4749C70.7091 48.5372 70.7496 48.6106 70.7734 48.69C71.0303 49.5019 71.3892 50.278 71.8416 50.9996C71.9451 51.1723 72.0054 51.3675 72.0175 51.5685C72.0295 51.7695 71.993 51.9705 71.9109 52.1544L68.7294 58.4076C68.6503 58.5653 68.635 58.7475 68.6866 58.9163C68.7382 59.085 68.8528 59.2275 69.0065 59.3141L72.4709 61.2541C72.6283 61.3417 72.8123 61.3683 72.988 61.3289C73.1637 61.2895 73.3188 61.1869 73.4236 61.0405L77.3904 55.2319C77.5149 55.0756 77.673 54.9494 77.8529 54.8625C78.0327 54.7755 78.2299 54.7301 78.4297 54.7295C79.2989 54.7471 80.1672 54.6618 81.0164 54.4755C81.096 54.4552 81.1791 54.4521 81.26 54.4665C81.3409 54.4808 81.4178 54.5123 81.4856 54.5587C81.5533 54.6052 81.6104 54.6656 81.653 54.7359C81.6955 54.8061 81.7226 54.8847 81.7324 54.9663L82.252 60.0416C82.252 60.1167 82.2729 60.1902 82.3124 60.2541C82.3519 60.3179 82.4083 60.3695 82.4755 60.4031C82.5426 60.4367 82.6178 60.4509 82.6925 60.4441C82.7673 60.4374 82.8387 60.41 82.8987 60.3649L88.2685 57.3452C88.4397 57.2386 88.5856 57.0962 88.6963 56.9277C88.8069 56.7592 88.8797 56.5687 88.9094 56.3694L89.4926 50.5434C89.5623 50.1285 89.7649 49.7476 90.07 49.4579C91.1306 48.5017 92.126 47.4755 93.0494 46.3862C93.1812 46.2444 93.3499 46.1423 93.5366 46.0913C93.7233 46.0403 93.9205 46.0424 94.106 46.0975L97.5704 47.2523C97.7469 47.3084 97.9369 47.305 98.1112 47.2423C98.2855 47.1797 98.4343 47.0614 98.5347 46.9058L102.478 40.2542C102.568 40.0944 102.6 39.9088 102.57 39.7281C102.539 39.5474 102.448 39.3826 102.311 39.2611L99.5451 36.9515C99.4049 36.8238 99.3046 36.6583 99.2564 36.4749C99.2083 36.2915 99.2143 36.098 99.2737 35.9179C99.7823 34.6016 100.197 33.251 100.515 31.8762C100.633 31.476 100.874 31.1228 101.202 30.8657L106.11 27.5053C106.268 27.3803 106.397 27.2228 106.489 27.0435C106.581 26.8641 106.633 26.6672 106.641 26.4659ZM85.6471 45.4334C80.6411 48.2511 76.582 45.9704 76.582 40.3408C76.582 34.7112 80.6238 27.869 85.6471 25.0571C90.6705 22.2452 94.7181 24.5201 94.7181 30.1497C94.7181 35.7794 90.6474 42.6215 85.6471 45.4334Z",
    fill: "#C6D9EC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_879_24545)"
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1705 161.1L17.1445 114.61L17.1705 140.074L97.1964 186.59L97.1705 161.1Z",
    fill: "#B2B9BB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M130.292 49.2761L17.1445 114.61L97.1705 161.1L210.318 95.7654L130.292 49.2761Z",
    fill: "#F0F7FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M210.319 95.7654L97.1719 161.1L97.1978 186.59L210.371 121.255L210.319 95.7654Z",
    fill: "#B3CCE5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5458 171.43L21.4258 128.056V124.37L96.5458 167.745V171.43ZM96.5458 176.155L21.4258 132.78V136.466L96.5458 179.841V176.155Z",
    fill: "#B2B9BB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5458 171.43L21.4258 128.056V124.37L22.0488 124.734V127.745L96.5458 170.756V171.43ZM96.5458 179.218L22.0488 136.155V133.144L21.4258 132.78V136.466L96.5458 179.841V179.218Z",
    fill: "#B2B9BB"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M182.751 88.7829L141.739 65.0581C139.996 64.1631 138.066 63.6962 136.106 63.6962C134.147 63.6962 132.216 64.1631 130.474 65.0581L45.1006 114.377C44.5194 114.656 44.0107 115.066 43.6144 115.575C43.2181 116.084 42.945 116.678 42.8164 117.31C42.9412 117.943 43.2128 118.539 43.6096 119.048C44.0063 119.558 44.517 119.967 45.1006 120.243L86.2427 143.994C87.9855 144.889 89.9164 145.356 91.8755 145.356C93.8346 145.356 95.7654 144.889 97.5082 143.994L182.881 94.6752C183.466 94.4008 183.978 93.992 184.375 93.4823C184.772 92.9726 185.043 92.3763 185.166 91.742C185.033 91.09 184.745 90.4799 184.324 89.9644C183.903 89.4488 183.364 89.0434 182.751 88.7829Z",
    fill: "#B3CCE5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9709 115.986L130.344 66.6674C132.09 65.7846 134.02 65.3246 135.977 65.3246C137.934 65.3246 139.863 65.7846 141.609 66.6674L182.752 90.4442C183.644 90.9049 184.364 91.6426 184.802 92.5467C184.927 92.2946 185.006 92.022 185.036 91.742C184.917 91.1031 184.648 90.5016 184.25 89.9871C183.853 89.4726 183.339 89.0599 182.752 88.7829L141.739 65.0581C139.996 64.1631 138.066 63.6962 136.106 63.6962C134.147 63.6962 132.216 64.1631 130.474 65.0581L45.1006 114.377C44.5194 114.656 44.0107 115.066 43.6144 115.575C43.2181 116.084 42.945 116.678 42.8164 117.31C42.8666 117.594 42.9449 117.872 43.05 118.14C43.4453 117.237 44.1181 116.482 44.9709 115.986Z",
    fill: "#B2B9BB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5742 161.333L94.6261 188.744L97.2997 190.301L97.2738 162.891L94.5742 161.333Z",
    fill: "#C0C7C9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M214.418 92.1314L94.5742 161.333L97.2738 162.891L217.118 93.6888L214.418 92.1314Z",
    fill: "#E9ECED"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2734 162.891L97.2994 190.301L217.144 121.1L217.118 93.6888L97.2734 162.891Z",
    fill: "#D6DCDD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M143.869 141.969C143.866 142.072 143.836 142.172 143.781 142.258C143.726 142.345 143.649 142.416 143.558 142.462C143.376 142.462 143.246 142.462 143.246 142.462C143.254 142.361 143.286 142.263 143.341 142.177C143.395 142.091 143.469 142.02 143.558 141.969C143.739 141.736 143.869 141.787 143.869 141.969ZM145.037 140.983C144.952 141.036 144.879 141.109 144.825 141.194C144.771 141.279 144.737 141.376 144.726 141.476C144.726 141.658 144.881 141.71 145.037 141.476C145.129 141.427 145.207 141.356 145.266 141.271C145.325 141.185 145.362 141.086 145.375 140.983C145.375 140.931 145.219 140.879 145.037 140.983ZM146.543 140.126C146.451 140.175 146.373 140.246 146.314 140.332C146.255 140.417 146.218 140.516 146.205 140.619C146.205 140.801 146.361 140.853 146.543 140.749C146.631 140.699 146.705 140.627 146.76 140.541C146.814 140.455 146.846 140.357 146.854 140.256C146.932 140.126 146.724 140.126 146.543 140.126ZM148.022 139.27C147.934 139.32 147.859 139.392 147.805 139.477C147.751 139.563 147.718 139.661 147.711 139.763C147.711 139.944 147.841 139.996 148.022 139.763C148.11 139.712 148.185 139.641 148.239 139.555C148.294 139.469 148.326 139.371 148.334 139.27C148.334 139.218 148.204 139.166 148.022 139.27ZM149.502 138.413C149.414 138.464 149.339 138.535 149.285 138.621C149.23 138.707 149.198 138.805 149.19 138.906C149.19 139.088 149.32 139.14 149.502 138.906C149.593 138.857 149.672 138.787 149.731 138.701C149.789 138.615 149.827 138.516 149.839 138.413C149.839 138.361 149.683 138.309 149.528 138.413H149.502ZM150.981 137.556C150.896 137.61 150.823 137.682 150.77 137.768C150.716 137.853 150.682 137.949 150.67 138.05C150.67 138.231 150.826 138.283 150.981 138.05C151.073 138 151.151 137.93 151.21 137.844C151.269 137.758 151.306 137.66 151.319 137.556C151.319 137.53 151.163 137.53 150.981 137.53V137.556ZM152.487 136.7C152.395 136.749 152.317 136.819 152.258 136.905C152.199 136.991 152.162 137.09 152.149 137.193C152.149 137.375 152.305 137.427 152.487 137.323C152.575 137.272 152.65 137.201 152.704 137.115C152.758 137.029 152.791 136.931 152.798 136.83C152.798 136.648 152.669 136.596 152.487 136.7ZM153.966 135.843C153.875 135.89 153.798 135.96 153.743 136.047C153.688 136.134 153.658 136.234 153.655 136.336C153.655 136.518 153.655 136.57 153.966 136.466C154.055 136.416 154.129 136.344 154.183 136.258C154.238 136.172 154.27 136.074 154.278 135.973C154.278 135.791 154.148 135.739 153.966 135.843ZM155.446 134.961C155.356 135.015 155.28 135.091 155.226 135.182C155.172 135.272 155.14 135.375 155.134 135.48C155.134 135.662 155.264 135.713 155.446 135.48C155.535 135.428 155.612 135.356 155.67 135.271C155.728 135.186 155.767 135.089 155.783 134.987C155.783 134.935 155.628 134.935 155.446 134.935V134.961ZM156.951 134.104C156.859 134.159 156.781 134.234 156.722 134.324C156.664 134.414 156.627 134.517 156.614 134.623C156.614 134.805 156.77 134.857 156.951 134.623C157.035 134.567 157.105 134.494 157.159 134.409C157.212 134.324 157.248 134.229 157.263 134.13C157.315 134.078 157.107 134.026 156.951 134.104ZM158.431 133.248C158.339 133.302 158.26 133.378 158.202 133.468C158.143 133.558 158.106 133.66 158.094 133.767C158.094 133.922 158.249 134 158.431 133.896C158.518 133.844 158.591 133.772 158.645 133.687C158.699 133.601 158.733 133.504 158.743 133.403C158.743 133.222 158.613 133.144 158.431 133.248ZM159.911 132.339C159.82 132.394 159.745 132.47 159.691 132.56C159.636 132.651 159.605 132.753 159.599 132.858C159.599 133.014 159.599 133.092 159.911 132.988C159.997 132.936 160.071 132.864 160.125 132.778C160.179 132.693 160.212 132.596 160.222 132.495C160.222 132.339 160.092 132.339 159.911 132.339ZM161.39 131.482C161.3 131.537 161.224 131.613 161.17 131.703C161.116 131.794 161.084 131.896 161.079 132.002C161.079 132.157 161.079 132.235 161.39 132.131C161.482 132.076 161.561 132.001 161.619 131.911C161.678 131.821 161.715 131.719 161.728 131.612C161.728 131.508 161.572 131.431 161.39 131.534V131.482ZM162.896 130.626C162.803 130.681 162.725 130.756 162.667 130.846C162.608 130.936 162.571 131.038 162.558 131.145C162.558 131.301 162.714 131.379 162.896 131.275C162.982 131.216 163.054 131.139 163.108 131.049C163.162 130.96 163.196 130.859 163.207 130.756C163.207 130.652 163.051 130.574 162.896 130.678V130.626ZM164.375 129.769C164.285 129.824 164.21 129.9 164.155 129.99C164.101 130.081 164.07 130.183 164.064 130.288C164.064 130.444 164.064 130.522 164.375 130.418C164.465 130.364 164.541 130.288 164.595 130.197C164.649 130.107 164.681 130.004 164.687 129.899C164.687 129.743 164.557 129.743 164.375 129.743V129.769ZM165.855 128.913C165.768 128.965 165.695 129.037 165.64 129.122C165.586 129.208 165.553 129.305 165.543 129.406C165.543 129.588 165.543 129.665 165.855 129.562C165.945 129.507 166.021 129.431 166.075 129.341C166.129 129.25 166.16 129.148 166.166 129.042C166.166 128.939 166.036 128.861 165.855 128.965V128.913ZM167.334 128.056C167.251 128.112 167.181 128.185 167.127 128.27C167.073 128.355 167.038 128.45 167.023 128.549C167.023 128.731 167.179 128.783 167.334 128.705C167.427 128.65 167.505 128.575 167.564 128.485C167.622 128.395 167.659 128.292 167.672 128.186C167.698 128.056 167.516 128.004 167.334 128.108V128.056ZM168.84 127.2C168.751 127.252 168.674 127.323 168.616 127.408C168.558 127.494 168.519 127.591 168.502 127.693C168.502 127.874 168.658 127.926 168.84 127.848C168.926 127.789 168.998 127.712 169.052 127.623C169.106 127.533 169.14 127.433 169.151 127.329C169.151 127.148 168.996 127.148 168.84 127.148V127.2ZM170.319 126.343C170.233 126.395 170.159 126.467 170.105 126.553C170.051 126.638 170.018 126.735 170.008 126.836C170.008 127.018 170.008 127.07 170.319 126.966C170.411 126.919 170.488 126.849 170.543 126.762C170.598 126.675 170.628 126.575 170.631 126.473C170.631 126.343 170.501 126.291 170.293 126.395L170.319 126.343ZM144.596 142.436C144.584 142.54 144.551 142.64 144.497 142.73C144.443 142.82 144.371 142.896 144.284 142.956C144.103 142.956 143.947 142.956 143.947 142.8C143.963 142.698 144.002 142.601 144.06 142.515C144.119 142.43 144.195 142.359 144.284 142.307C144.336 142.203 144.596 142.255 144.596 142.436ZM145.764 141.45C145.677 141.502 145.604 141.574 145.55 141.66C145.496 141.745 145.462 141.842 145.452 141.943C145.452 142.125 145.452 142.177 145.764 142.099C145.854 142.044 145.93 141.968 145.984 141.878C146.038 141.787 146.07 141.685 146.075 141.58C146.075 141.398 145.946 141.346 145.764 141.45ZM147.243 140.593C147.155 140.644 147.081 140.715 147.026 140.801C146.972 140.887 146.94 140.985 146.932 141.087C146.932 141.268 146.932 141.32 147.243 141.216C147.335 141.17 147.412 141.099 147.467 141.013C147.522 140.926 147.552 140.826 147.555 140.723C147.555 140.541 147.425 140.49 147.243 140.593ZM148.723 139.737C148.638 139.79 148.565 139.863 148.511 139.948C148.457 140.033 148.423 140.13 148.412 140.23C148.412 140.412 148.567 140.464 148.723 140.36C148.815 140.311 148.893 140.24 148.952 140.154C149.011 140.069 149.048 139.97 149.06 139.867C149.06 139.685 148.905 139.633 148.723 139.737ZM150.229 138.88C150.137 138.929 150.058 139 150 139.086C149.941 139.171 149.904 139.27 149.891 139.373C149.891 139.555 150.047 139.607 150.229 139.373C150.314 139.32 150.386 139.248 150.44 139.162C150.494 139.077 150.528 138.981 150.54 138.88C150.54 138.828 150.384 138.776 150.229 138.88ZM151.708 138.024C151.62 138.074 151.545 138.146 151.491 138.232C151.437 138.318 151.404 138.415 151.397 138.517C151.397 138.699 151.526 138.75 151.708 138.517C151.796 138.466 151.871 138.395 151.925 138.309C151.979 138.223 152.012 138.125 152.02 138.024C152.123 137.972 151.89 137.92 151.708 138.024ZM153.188 137.167C153.099 137.218 153.025 137.289 152.971 137.375C152.916 137.461 152.884 137.559 152.876 137.66C152.876 137.842 153.006 137.894 153.188 137.79C153.276 137.739 153.35 137.668 153.405 137.582C153.459 137.496 153.491 137.398 153.499 137.297C153.499 137.115 153.369 137.063 153.188 137.167ZM154.667 136.31C154.582 136.364 154.509 136.436 154.455 136.522C154.402 136.607 154.367 136.703 154.356 136.804C154.356 136.985 154.511 137.037 154.667 136.933C154.759 136.884 154.837 136.814 154.896 136.728C154.955 136.642 154.992 136.543 155.005 136.44C155.005 136.259 154.849 136.207 154.719 136.31H154.667ZM156.173 135.454C156.081 135.503 156.003 135.573 155.944 135.659C155.885 135.745 155.848 135.844 155.835 135.947C155.835 136.129 155.991 136.181 156.173 135.947C156.258 135.893 156.331 135.821 156.385 135.736C156.438 135.651 156.473 135.554 156.484 135.454C156.484 135.402 156.329 135.35 156.173 135.454ZM157.652 134.597C157.561 134.644 157.484 134.714 157.429 134.801C157.374 134.888 157.344 134.988 157.341 135.09C157.341 135.272 157.471 135.324 157.652 135.09C157.739 135.038 157.813 134.967 157.867 134.881C157.921 134.795 157.954 134.698 157.964 134.597C157.964 134.545 157.834 134.493 157.652 134.597ZM159.132 133.715C159.042 133.769 158.966 133.845 158.912 133.936C158.858 134.026 158.826 134.129 158.82 134.234C158.82 134.416 158.95 134.468 159.132 134.364C159.219 134.311 159.292 134.24 159.346 134.154C159.4 134.068 159.434 133.971 159.443 133.871C159.443 133.689 159.314 133.637 159.132 133.715ZM160.611 132.858C160.525 132.917 160.453 132.994 160.399 133.084C160.345 133.173 160.312 133.273 160.3 133.377C160.3 133.559 160.456 133.611 160.611 133.507C160.701 133.455 160.777 133.384 160.835 133.298C160.894 133.213 160.932 133.116 160.949 133.014C160.949 132.832 160.793 132.78 160.611 132.858ZM162.117 132.002C162.025 132.056 161.946 132.132 161.888 132.222C161.829 132.312 161.792 132.414 161.78 132.521C161.78 132.676 161.935 132.754 162.117 132.521C162.2 132.464 162.271 132.392 162.324 132.307C162.378 132.222 162.413 132.127 162.428 132.028C162.415 131.999 162.394 131.975 162.368 131.957C162.342 131.939 162.312 131.928 162.28 131.926C162.249 131.923 162.217 131.929 162.188 131.942C162.16 131.955 162.135 131.976 162.117 132.002ZM163.597 131.145C163.506 131.2 163.431 131.276 163.377 131.366C163.322 131.456 163.291 131.559 163.285 131.664C163.285 131.82 163.415 131.898 163.597 131.794C163.687 131.739 163.762 131.663 163.817 131.573C163.871 131.482 163.902 131.38 163.908 131.275C163.908 131.119 163.778 131.041 163.597 131.145ZM165.076 130.288C164.986 130.343 164.91 130.419 164.856 130.509C164.802 130.6 164.77 130.702 164.765 130.808C164.765 130.963 164.894 131.041 165.076 130.937C165.166 130.883 165.242 130.807 165.296 130.716C165.35 130.626 165.382 130.524 165.388 130.418C165.388 130.262 165.258 130.185 165.102 130.288H165.076ZM166.556 129.432C166.469 129.491 166.397 129.568 166.343 129.657C166.29 129.747 166.256 129.847 166.244 129.951C166.244 130.107 166.4 130.185 166.556 130.081C166.648 130.026 166.726 129.95 166.785 129.86C166.843 129.77 166.88 129.668 166.893 129.562C166.893 129.406 166.737 129.328 166.556 129.432ZM168.061 128.575C167.972 128.627 167.896 128.699 167.837 128.784C167.779 128.869 167.74 128.966 167.724 129.068C167.724 129.25 167.879 129.328 168.061 129.224C168.147 129.165 168.22 129.088 168.274 128.999C168.327 128.909 168.361 128.809 168.373 128.705C168.373 128.549 168.217 128.471 168.061 128.575ZM169.541 127.719C169.454 127.771 169.381 127.843 169.326 127.928C169.272 128.014 169.239 128.111 169.229 128.212C169.229 128.394 169.229 128.471 169.541 128.368C169.631 128.313 169.706 128.237 169.761 128.147C169.815 128.056 169.846 127.954 169.852 127.848C169.852 127.667 169.722 127.615 169.541 127.719ZM143.869 143.76C143.859 143.861 143.826 143.958 143.772 144.044C143.718 144.129 143.644 144.201 143.558 144.253C143.376 144.253 143.246 144.253 143.246 144.124C143.252 144.018 143.283 143.916 143.338 143.825C143.392 143.735 143.467 143.659 143.558 143.604C143.739 143.501 143.869 143.578 143.869 143.76ZM145.037 142.748C144.951 142.807 144.879 142.884 144.825 142.973C144.771 143.063 144.737 143.163 144.726 143.267C144.726 143.423 144.881 143.501 145.037 143.267C145.129 143.212 145.208 143.137 145.266 143.047C145.325 142.957 145.362 142.854 145.375 142.748C145.375 142.722 145.219 142.722 145.037 142.722V142.748ZM146.543 141.891C146.45 141.946 146.372 142.022 146.313 142.112C146.255 142.202 146.218 142.304 146.205 142.41C146.205 142.566 146.361 142.644 146.543 142.41C146.633 142.356 146.708 142.28 146.763 142.189C146.817 142.099 146.848 141.997 146.854 141.891C146.932 141.865 146.724 141.787 146.543 141.891ZM148.022 141.035C147.932 141.089 147.856 141.165 147.802 141.256C147.748 141.346 147.717 141.448 147.711 141.554C147.711 141.71 147.841 141.787 148.022 141.684C148.112 141.629 148.188 141.553 148.242 141.463C148.296 141.372 148.328 141.27 148.334 141.164C148.334 141.009 148.204 140.931 148.022 141.035ZM149.528 140.126C149.441 140.178 149.368 140.25 149.313 140.336C149.259 140.421 149.226 140.519 149.216 140.619C149.216 140.801 149.346 140.879 149.528 140.775C149.62 140.72 149.698 140.645 149.757 140.555C149.815 140.465 149.852 140.363 149.865 140.256C149.839 140.126 149.683 140.126 149.528 140.126ZM151.007 139.27C150.924 139.326 150.853 139.399 150.8 139.484C150.746 139.568 150.711 139.664 150.696 139.763C150.689 139.801 150.695 139.841 150.712 139.876C150.73 139.911 150.759 139.939 150.794 139.957C150.828 139.974 150.868 139.98 150.907 139.973C150.945 139.966 150.981 139.947 151.007 139.919C151.1 139.864 151.178 139.788 151.236 139.698C151.295 139.608 151.332 139.506 151.345 139.399C151.319 139.27 151.163 139.218 150.981 139.322L151.007 139.27ZM152.513 138.413C152.424 138.465 152.347 138.537 152.289 138.622C152.231 138.707 152.192 138.804 152.175 138.906C152.175 139.088 152.331 139.14 152.513 139.062C152.603 139.007 152.679 138.931 152.733 138.841C152.787 138.75 152.818 138.648 152.824 138.543C152.798 138.413 152.669 138.361 152.487 138.465L152.513 138.413ZM153.992 137.556C153.906 137.609 153.832 137.68 153.778 137.766C153.724 137.852 153.691 137.949 153.681 138.05C153.681 138.231 153.681 138.283 153.992 138.205C154.083 138.151 154.158 138.075 154.212 137.984C154.267 137.894 154.298 137.792 154.304 137.686C154.278 137.53 154.148 137.53 153.966 137.53L153.992 137.556ZM155.472 136.7C155.384 136.75 155.309 136.822 155.255 136.908C155.201 136.994 155.168 137.092 155.16 137.193C155.16 137.375 155.29 137.427 155.472 137.193C155.567 137.148 155.648 137.078 155.707 136.992C155.766 136.905 155.801 136.804 155.809 136.7C155.783 136.7 155.628 136.648 155.446 136.752L155.472 136.7ZM156.977 135.843C156.886 135.892 156.807 135.963 156.749 136.049C156.69 136.135 156.653 136.233 156.64 136.336C156.64 136.518 156.796 136.57 156.977 136.336C157.063 136.283 157.135 136.211 157.189 136.125C157.243 136.04 157.277 135.944 157.289 135.843C157.315 135.843 157.107 135.791 156.951 135.895L156.977 135.843ZM158.457 134.987C158.365 135.036 158.287 135.106 158.228 135.192C158.169 135.278 158.132 135.377 158.12 135.48C158.12 135.662 158.275 135.713 158.457 135.61C158.545 135.559 158.62 135.488 158.674 135.402C158.728 135.316 158.761 135.218 158.768 135.116C158.743 134.935 158.613 134.935 158.431 134.935L158.457 134.987ZM159.937 134.13C159.848 134.181 159.774 134.252 159.72 134.338C159.665 134.424 159.633 134.522 159.625 134.623C159.625 134.805 159.625 134.857 159.937 134.753C160.025 134.702 160.099 134.631 160.154 134.545C160.208 134.459 160.24 134.361 160.248 134.26C160.222 134.13 160.092 134.078 159.911 134.182L159.937 134.13ZM161.416 133.273C161.328 133.324 161.253 133.395 161.199 133.481C161.145 133.567 161.112 133.665 161.105 133.767C161.105 133.948 161.105 134 161.416 133.767C161.508 133.718 161.586 133.647 161.645 133.561C161.704 133.475 161.741 133.377 161.754 133.273C161.728 133.273 161.572 133.222 161.39 133.325L161.416 133.273ZM162.922 132.417C162.83 132.466 162.751 132.537 162.693 132.622C162.634 132.708 162.597 132.807 162.584 132.91C162.584 133.092 162.74 133.144 162.922 132.91C163.007 132.856 163.079 132.784 163.133 132.699C163.187 132.614 163.221 132.517 163.233 132.417C163.207 132.339 163.051 132.339 162.896 132.469L162.922 132.417ZM164.401 131.56C164.31 131.607 164.233 131.677 164.178 131.764C164.123 131.851 164.092 131.951 164.09 132.053C164.09 132.235 164.09 132.287 164.401 132.183C164.489 132.133 164.564 132.061 164.618 131.975C164.673 131.889 164.705 131.791 164.713 131.69C164.687 131.56 164.557 131.508 164.375 131.612L164.401 131.56ZM165.881 130.704C165.789 130.75 165.712 130.821 165.657 130.908C165.602 130.994 165.572 131.094 165.569 131.197C165.569 131.379 165.569 131.431 165.881 131.327C165.968 131.275 166.041 131.203 166.095 131.117C166.149 131.031 166.182 130.934 166.192 130.834C166.166 130.704 166.036 130.652 165.855 130.756L165.881 130.704ZM167.36 129.821C167.274 129.88 167.202 129.957 167.148 130.047C167.094 130.136 167.06 130.236 167.049 130.34C167.049 130.522 167.205 130.574 167.36 130.47C167.449 130.418 167.526 130.347 167.584 130.261C167.643 130.176 167.681 130.079 167.698 129.977C167.698 129.743 167.516 129.743 167.334 129.873L167.36 129.821ZM168.866 128.965C168.774 129.02 168.695 129.095 168.637 129.185C168.578 129.275 168.541 129.377 168.528 129.484C168.528 129.665 168.684 129.717 168.866 129.484C168.949 129.428 169.02 129.355 169.073 129.27C169.127 129.185 169.162 129.09 169.177 128.991C169.151 128.991 168.996 128.939 168.84 129.017L168.866 128.965ZM170.345 128.108C170.255 128.163 170.18 128.239 170.125 128.329C170.071 128.419 170.04 128.522 170.034 128.627C170.034 128.783 170.034 128.861 170.345 128.757C170.432 128.705 170.506 128.633 170.56 128.547C170.614 128.462 170.647 128.365 170.657 128.264C170.631 128.134 170.501 128.056 170.293 128.16L170.345 128.108ZM144.596 144.227C144.581 144.327 144.545 144.422 144.492 144.507C144.438 144.592 144.368 144.664 144.284 144.721C144.103 144.721 143.947 144.721 143.947 144.591C143.96 144.484 143.997 144.382 144.055 144.292C144.114 144.202 144.192 144.127 144.284 144.072C144.336 143.994 144.596 144.046 144.596 144.227ZM145.764 143.215C145.674 143.27 145.598 143.346 145.544 143.436C145.49 143.527 145.458 143.629 145.452 143.734C145.452 143.916 145.452 143.968 145.764 143.734C145.851 143.682 145.924 143.61 145.978 143.525C146.032 143.439 146.066 143.342 146.075 143.241C146.075 143.189 145.946 143.111 145.764 143.215ZM147.243 142.358C147.153 142.413 147.078 142.489 147.024 142.58C146.969 142.67 146.938 142.772 146.932 142.878C146.932 143.033 146.932 143.111 147.243 142.878C147.33 142.825 147.404 142.754 147.458 142.668C147.512 142.582 147.545 142.485 147.555 142.384C147.555 142.333 147.425 142.255 147.243 142.358ZM148.723 141.502C148.637 141.561 148.564 141.638 148.511 141.727C148.457 141.817 148.423 141.917 148.412 142.021C148.412 142.177 148.567 142.255 148.723 142.151C148.815 142.096 148.894 142.021 148.952 141.931C149.011 141.841 149.048 141.738 149.06 141.632C149.06 141.476 148.905 141.398 148.723 141.502ZM150.229 140.645C150.136 140.7 150.058 140.776 149.999 140.866C149.941 140.956 149.904 141.058 149.891 141.164C149.891 141.32 150.047 141.398 150.229 141.294C150.315 141.235 150.387 141.158 150.441 141.069C150.495 140.979 150.528 140.879 150.54 140.775C150.54 140.619 150.384 140.541 150.229 140.645ZM151.708 139.789C151.618 139.843 151.542 139.919 151.488 140.01C151.434 140.1 151.402 140.203 151.397 140.308C151.397 140.464 151.526 140.541 151.708 140.308C151.798 140.253 151.874 140.177 151.928 140.087C151.982 139.996 152.014 139.894 152.02 139.789C152.123 139.763 151.89 139.685 151.708 139.789ZM153.188 138.932C153.101 138.984 153.027 139.056 152.973 139.142C152.919 139.227 152.886 139.325 152.876 139.425C152.876 139.607 153.006 139.685 153.188 139.581C153.278 139.526 153.353 139.451 153.408 139.36C153.462 139.27 153.493 139.167 153.499 139.062C153.499 138.906 153.369 138.828 153.188 138.932ZM154.667 138.076C154.584 138.132 154.513 138.205 154.46 138.29C154.406 138.374 154.371 138.469 154.356 138.569C154.349 138.607 154.355 138.647 154.372 138.682C154.39 138.717 154.418 138.745 154.453 138.763C154.488 138.78 154.528 138.786 154.567 138.779C154.605 138.772 154.64 138.753 154.667 138.724C154.759 138.67 154.838 138.594 154.896 138.504C154.955 138.414 154.992 138.312 155.005 138.205C155.005 138.024 154.849 137.972 154.719 138.076H154.667ZM156.173 137.219C156.084 137.271 156.007 137.343 155.949 137.428C155.891 137.513 155.852 137.61 155.835 137.712C155.835 137.894 155.991 137.946 156.173 137.868C156.259 137.809 156.331 137.732 156.385 137.642C156.439 137.553 156.473 137.453 156.484 137.349C156.484 137.167 156.329 137.115 156.173 137.219ZM157.652 136.362C157.566 136.415 157.492 136.486 157.438 136.572C157.384 136.658 157.351 136.755 157.341 136.856C157.341 137.037 157.471 137.089 157.652 137.011C157.743 136.957 157.818 136.881 157.872 136.79C157.927 136.7 157.958 136.598 157.964 136.492C157.964 136.31 157.834 136.259 157.652 136.362ZM159.132 135.506C159.044 135.556 158.969 135.628 158.915 135.714C158.861 135.8 158.828 135.898 158.82 135.999C158.82 136.181 158.95 136.233 159.132 136.129C159.223 136.082 159.301 136.012 159.355 135.925C159.41 135.838 159.441 135.738 159.443 135.636C159.443 135.454 159.314 135.402 159.132 135.506ZM160.611 134.649C160.526 134.703 160.454 134.775 160.4 134.86C160.346 134.946 160.312 135.042 160.3 135.142C160.3 135.324 160.456 135.376 160.611 135.272C160.703 135.223 160.782 135.153 160.84 135.067C160.899 134.981 160.936 134.882 160.949 134.779C160.949 134.597 160.793 134.545 160.611 134.649ZM162.117 133.793C162.025 133.842 161.947 133.912 161.888 133.998C161.829 134.084 161.792 134.183 161.78 134.286C161.78 134.468 161.935 134.519 162.117 134.286C162.202 134.232 162.275 134.16 162.329 134.075C162.383 133.989 162.417 133.893 162.428 133.793C162.506 133.741 162.273 133.689 162.117 133.793ZM163.597 132.936C163.508 132.987 163.434 133.058 163.379 133.144C163.325 133.23 163.293 133.328 163.285 133.429C163.285 133.611 163.415 133.663 163.597 133.429C163.685 133.379 163.759 133.307 163.814 133.221C163.868 133.135 163.9 133.037 163.908 132.936C163.908 132.884 163.778 132.832 163.597 132.936ZM165.102 132.079C165.014 132.13 164.939 132.201 164.885 132.287C164.831 132.373 164.798 132.471 164.791 132.573C164.791 132.754 164.92 132.806 165.102 132.573C165.19 132.522 165.265 132.451 165.319 132.365C165.373 132.279 165.406 132.181 165.414 132.079C165.388 132.028 165.258 131.976 165.102 132.079ZM166.582 131.223C166.496 131.277 166.424 131.349 166.37 131.434C166.316 131.519 166.282 131.616 166.27 131.716C166.27 131.898 166.426 131.95 166.582 131.716C166.673 131.667 166.752 131.596 166.81 131.511C166.869 131.425 166.906 131.326 166.919 131.223C166.893 131.171 166.737 131.119 166.556 131.223H166.582ZM168.087 130.366C167.992 130.412 167.911 130.481 167.852 130.568C167.793 130.654 167.758 130.755 167.75 130.859C167.75 131.041 167.905 131.093 168.087 130.989C168.173 130.936 168.245 130.863 168.299 130.778C168.353 130.693 168.387 130.596 168.399 130.496C168.373 130.314 168.217 130.262 168.061 130.366H168.087ZM169.567 129.51C169.475 129.556 169.398 129.627 169.343 129.714C169.288 129.8 169.258 129.9 169.255 130.003C169.255 130.185 169.255 130.236 169.567 130.003C169.653 129.951 169.727 129.879 169.781 129.793C169.835 129.708 169.868 129.611 169.878 129.51C169.852 129.458 169.722 129.406 169.541 129.51H169.567ZM143.895 145.525C143.887 145.627 143.855 145.725 143.801 145.811C143.746 145.897 143.672 145.968 143.584 146.018C143.402 146.018 143.272 146.018 143.272 145.889C143.264 145.777 143.286 145.664 143.336 145.564C143.386 145.463 143.463 145.378 143.558 145.318C143.739 145.318 143.869 145.318 143.869 145.525H143.895ZM145.063 144.539C144.978 144.593 144.905 144.665 144.851 144.75C144.797 144.835 144.763 144.932 144.752 145.032C144.752 145.214 144.907 145.266 145.063 145.032C145.155 144.983 145.233 144.912 145.292 144.827C145.351 144.741 145.388 144.642 145.401 144.539C145.375 144.487 145.219 144.435 145.037 144.539H145.063ZM146.569 143.682C146.477 143.731 146.398 143.802 146.34 143.888C146.281 143.974 146.244 144.072 146.231 144.176C146.231 144.357 146.387 144.409 146.569 144.176C146.657 144.125 146.731 144.054 146.786 143.968C146.84 143.882 146.872 143.784 146.88 143.682C146.932 143.63 146.724 143.578 146.543 143.682H146.569ZM148.048 142.826C147.96 142.876 147.885 142.948 147.831 143.034C147.777 143.12 147.744 143.218 147.737 143.319C147.737 143.501 147.866 143.553 148.048 143.449C148.136 143.398 148.211 143.327 148.265 143.241C148.319 143.155 148.352 143.057 148.36 142.956C148.334 142.722 148.204 142.722 148.022 142.722L148.048 142.826ZM149.528 141.969C149.436 142.016 149.359 142.086 149.304 142.173C149.249 142.26 149.219 142.36 149.216 142.462C149.216 142.644 149.346 142.696 149.528 142.592C149.619 142.543 149.698 142.472 149.757 142.387C149.815 142.301 149.853 142.202 149.865 142.099C149.839 141.917 149.683 141.865 149.528 141.969ZM151.007 141.113C150.92 141.165 150.847 141.237 150.793 141.322C150.739 141.408 150.706 141.505 150.696 141.606C150.696 141.787 150.852 141.839 151.007 141.606C151.096 141.553 151.173 141.482 151.231 141.397C151.29 141.312 151.328 141.215 151.345 141.113C151.319 141.061 151.163 141.009 150.981 141.113H151.007ZM152.513 140.23C152.421 140.285 152.342 140.36 152.284 140.45C152.225 140.54 152.188 140.643 152.175 140.749C152.175 140.931 152.331 140.983 152.513 140.749C152.6 140.697 152.673 140.625 152.727 140.54C152.781 140.454 152.814 140.357 152.824 140.256C152.798 140.126 152.669 140.126 152.487 140.126L152.513 140.23ZM153.992 139.373C153.902 139.428 153.827 139.504 153.772 139.594C153.718 139.685 153.687 139.787 153.681 139.893C153.681 140.074 153.681 140.126 153.992 140.022C154.079 139.97 154.153 139.898 154.207 139.813C154.261 139.727 154.294 139.63 154.304 139.529C154.278 139.347 154.148 139.27 153.966 139.373H153.992ZM155.472 138.517C155.382 138.572 155.306 138.647 155.252 138.738C155.198 138.828 155.166 138.931 155.16 139.036C155.16 139.192 155.29 139.27 155.472 139.166C155.561 139.114 155.638 139.042 155.696 138.957C155.754 138.872 155.793 138.775 155.809 138.673C155.783 138.491 155.628 138.413 155.446 138.517H155.472ZM156.977 137.66C156.885 137.715 156.807 137.791 156.748 137.881C156.69 137.971 156.653 138.073 156.64 138.179C156.64 138.335 156.796 138.413 156.977 138.179C157.064 138.12 157.136 138.043 157.19 137.954C157.244 137.864 157.277 137.764 157.289 137.66C157.315 137.53 157.107 137.53 156.951 137.66H156.977ZM158.457 136.804C158.365 136.859 158.286 136.934 158.228 137.024C158.169 137.114 158.132 137.216 158.12 137.323C158.12 137.479 158.275 137.556 158.457 137.323C158.547 137.268 158.623 137.192 158.677 137.102C158.731 137.011 158.763 136.909 158.768 136.804C158.743 136.778 158.613 136.7 158.431 136.804H158.457ZM159.937 135.947C159.846 136.002 159.771 136.078 159.717 136.168C159.662 136.259 159.631 136.361 159.625 136.466C159.625 136.622 159.625 136.7 159.937 136.466C160.027 136.412 160.102 136.336 160.157 136.245C160.211 136.155 160.242 136.052 160.248 135.947C160.222 135.921 160.092 135.843 159.911 135.947H159.937ZM161.416 135.09C161.329 135.143 161.256 135.214 161.202 135.3C161.148 135.386 161.114 135.483 161.105 135.584C161.105 135.765 161.105 135.843 161.416 135.739C161.508 135.685 161.587 135.609 161.645 135.519C161.704 135.429 161.741 135.327 161.754 135.22C161.728 135.065 161.572 134.935 161.39 135.09H161.416ZM162.922 134.234C162.833 134.286 162.756 134.357 162.698 134.443C162.639 134.528 162.601 134.625 162.584 134.727C162.584 134.909 162.74 134.987 162.922 134.883C163.008 134.824 163.08 134.747 163.134 134.657C163.188 134.568 163.222 134.468 163.233 134.364C163.207 134.182 163.051 134.13 162.896 134.234H162.922ZM164.401 133.377C164.314 133.43 164.241 133.501 164.187 133.587C164.133 133.673 164.1 133.77 164.09 133.871C164.09 134.052 164.09 134.104 164.401 134.026C164.491 133.972 164.567 133.896 164.621 133.805C164.675 133.715 164.707 133.612 164.713 133.507C164.687 133.325 164.557 133.273 164.375 133.377H164.401ZM165.881 132.521C165.794 132.573 165.721 132.645 165.666 132.73C165.612 132.816 165.579 132.913 165.569 133.014C165.569 133.196 165.569 133.248 165.881 133.17C165.971 133.115 166.046 133.039 166.101 132.949C166.155 132.858 166.186 132.756 166.192 132.651C166.166 132.469 166.036 132.339 165.855 132.521H165.881ZM167.36 131.664C167.275 131.718 167.202 131.79 167.149 131.875C167.095 131.961 167.061 132.057 167.049 132.157C167.049 132.339 167.205 132.391 167.36 132.287C167.455 132.242 167.536 132.172 167.595 132.086C167.654 131.999 167.69 131.899 167.698 131.794C167.698 131.612 167.516 131.56 167.334 131.664H167.36ZM168.866 130.808C168.774 130.857 168.696 130.927 168.637 131.013C168.578 131.099 168.541 131.198 168.528 131.301C168.528 131.482 168.684 131.534 168.866 131.301C168.951 131.247 169.024 131.175 169.078 131.09C169.131 131.004 169.166 130.908 169.177 130.808C169.151 130.756 168.996 130.704 168.84 130.808H168.866ZM170.345 129.951C170.257 130.002 170.183 130.073 170.128 130.159C170.074 130.245 170.042 130.343 170.034 130.444C170.034 130.626 170.034 130.678 170.345 130.574C170.434 130.523 170.508 130.452 170.562 130.366C170.617 130.28 170.649 130.182 170.657 130.081C170.631 129.899 170.501 129.743 170.293 129.951H170.345ZM144.596 145.992C144.586 146.093 144.553 146.19 144.499 146.276C144.445 146.362 144.371 146.433 144.284 146.486C144.103 146.486 143.947 146.486 143.947 146.356C143.96 146.253 143.997 146.154 144.056 146.068C144.114 145.982 144.193 145.912 144.284 145.863C144.336 145.759 144.596 145.811 144.596 145.992ZM145.764 145.006C145.676 145.057 145.601 145.128 145.547 145.214C145.493 145.3 145.46 145.398 145.452 145.499C145.452 145.681 145.452 145.733 145.764 145.499C145.852 145.449 145.927 145.377 145.981 145.291C146.035 145.205 146.068 145.108 146.075 145.006C146.075 144.954 145.946 144.902 145.764 145.006ZM147.243 144.15C147.155 144.2 147.081 144.271 147.026 144.357C146.972 144.443 146.94 144.541 146.932 144.643C146.932 144.824 146.932 144.876 147.243 144.643C147.332 144.592 147.406 144.521 147.461 144.435C147.515 144.349 147.547 144.251 147.555 144.15C147.555 144.098 147.425 144.046 147.243 144.15ZM148.723 143.293C148.638 143.347 148.565 143.419 148.511 143.504C148.457 143.59 148.423 143.686 148.412 143.786C148.412 143.968 148.567 144.02 148.723 143.916C148.815 143.867 148.893 143.796 148.952 143.71C149.011 143.625 149.048 143.526 149.06 143.423C149.06 143.241 148.905 143.189 148.723 143.293ZM150.229 142.436C150.137 142.486 150.058 142.556 150 142.642C149.941 142.728 149.904 142.826 149.891 142.93C149.891 143.111 150.047 143.163 150.229 143.059C150.314 143.006 150.386 142.933 150.44 142.848C150.494 142.763 150.528 142.666 150.54 142.566C150.54 142.384 150.384 142.333 150.229 142.436ZM151.708 141.58C151.62 141.63 151.545 141.702 151.491 141.788C151.437 141.874 151.404 141.972 151.397 142.073C151.397 142.255 151.526 142.307 151.708 142.073C151.796 142.022 151.871 141.951 151.925 141.865C151.979 141.779 152.012 141.681 152.02 141.58C152.123 141.528 151.89 141.476 151.708 141.58ZM153.188 140.723C153.096 140.77 153.019 140.84 152.964 140.927C152.909 141.014 152.879 141.114 152.876 141.216C152.876 141.398 153.006 141.45 153.188 141.216C153.276 141.166 153.35 141.094 153.405 141.008C153.459 140.923 153.491 140.825 153.499 140.723C153.499 140.671 153.369 140.619 153.188 140.723ZM154.719 139.867C154.632 139.919 154.559 139.991 154.505 140.076C154.451 140.162 154.418 140.259 154.408 140.36C154.408 140.541 154.563 140.593 154.719 140.36C154.808 140.308 154.885 140.236 154.943 140.151C155.001 140.066 155.04 139.969 155.057 139.867C155.005 139.815 154.849 139.763 154.719 139.867ZM156.225 138.984C156.132 139.039 156.054 139.114 155.996 139.204C155.937 139.294 155.9 139.397 155.887 139.503C155.887 139.685 156.043 139.737 156.225 139.633C156.308 139.577 156.378 139.504 156.432 139.419C156.486 139.334 156.521 139.239 156.536 139.14C156.484 138.958 156.329 138.906 156.173 138.984H156.225ZM157.704 138.127C157.614 138.182 157.539 138.258 157.484 138.348C157.43 138.439 157.399 138.541 157.393 138.647C157.393 138.828 157.523 138.88 157.704 138.647C157.791 138.594 157.864 138.523 157.919 138.437C157.973 138.351 158.006 138.254 158.016 138.153C157.964 138.102 157.834 138.024 157.652 138.127H157.704ZM159.184 137.271C159.094 137.326 159.018 137.401 158.964 137.492C158.91 137.582 158.878 137.685 158.872 137.79C158.872 137.946 159.002 138.024 159.184 137.79C159.271 137.738 159.344 137.666 159.398 137.58C159.452 137.495 159.485 137.398 159.495 137.297C159.443 137.245 159.314 137.167 159.132 137.271H159.184ZM160.663 136.414C160.577 136.473 160.505 136.55 160.451 136.64C160.397 136.729 160.363 136.83 160.352 136.933C160.352 137.089 160.508 137.167 160.663 136.933C160.756 136.879 160.834 136.803 160.893 136.713C160.951 136.623 160.988 136.521 161.001 136.414C160.949 136.388 160.793 136.31 160.611 136.414H160.663ZM162.169 135.558C162.077 135.613 161.998 135.688 161.94 135.778C161.881 135.868 161.844 135.97 161.831 136.077C161.831 136.233 161.987 136.31 162.169 136.207C162.255 136.148 162.327 136.071 162.381 135.981C162.435 135.891 162.469 135.791 162.48 135.688C162.506 135.532 162.273 135.454 162.117 135.558H162.169ZM163.648 134.701C163.558 134.756 163.483 134.832 163.428 134.922C163.374 135.013 163.343 135.115 163.337 135.22C163.337 135.376 163.467 135.454 163.648 135.22C163.739 135.166 163.814 135.09 163.868 134.999C163.923 134.909 163.954 134.806 163.96 134.701C163.908 134.675 163.778 134.597 163.597 134.701H163.648ZM165.128 133.845C165.041 133.897 164.968 133.969 164.914 134.054C164.86 134.14 164.826 134.237 164.816 134.338C164.816 134.519 164.946 134.597 165.128 134.493C165.218 134.439 165.294 134.363 165.348 134.272C165.402 134.182 165.434 134.08 165.439 133.974C165.388 133.819 165.258 133.741 165.102 133.845H165.128ZM166.608 132.988C166.524 133.044 166.454 133.117 166.4 133.202C166.347 133.287 166.311 133.382 166.296 133.481C166.289 133.52 166.295 133.559 166.313 133.594C166.33 133.629 166.359 133.658 166.394 133.675C166.429 133.693 166.468 133.698 166.507 133.691C166.546 133.685 166.581 133.665 166.608 133.637C166.7 133.582 166.778 133.507 166.837 133.417C166.895 133.327 166.932 133.224 166.945 133.118C166.893 132.936 166.737 132.884 166.556 132.988H166.608ZM168.113 132.131C168.024 132.184 167.947 132.255 167.889 132.34C167.831 132.425 167.792 132.523 167.776 132.625C167.776 132.806 167.931 132.858 168.113 132.78C168.199 132.721 168.272 132.644 168.325 132.555C168.379 132.465 168.413 132.365 168.425 132.261C168.373 132.079 168.217 132.028 168.061 132.131H168.113ZM169.593 131.275C169.506 131.327 169.432 131.399 169.378 131.484C169.324 131.57 169.291 131.667 169.281 131.768C169.281 131.95 169.281 132.002 169.593 131.768C169.684 131.721 169.761 131.651 169.816 131.564C169.871 131.477 169.901 131.377 169.904 131.275C169.852 131.223 169.722 131.171 169.541 131.275H169.593ZM143.921 147.29C143.915 147.396 143.884 147.498 143.829 147.588C143.775 147.679 143.7 147.755 143.609 147.809C143.428 147.809 143.298 147.809 143.298 147.68C143.304 147.574 143.335 147.472 143.389 147.382C143.444 147.291 143.519 147.215 143.609 147.161C143.739 147.057 143.869 147.135 143.869 147.29H143.921ZM145.089 146.304C145.003 146.363 144.93 146.44 144.877 146.53C144.823 146.619 144.789 146.719 144.778 146.823C144.778 146.979 144.933 147.057 145.089 146.953C145.181 146.898 145.26 146.823 145.318 146.733C145.377 146.643 145.414 146.54 145.426 146.434C145.375 146.278 145.219 146.2 145.037 146.304H145.089ZM146.595 145.447C146.505 145.5 146.429 145.571 146.371 145.656C146.312 145.741 146.274 145.839 146.257 145.941C146.257 146.122 146.413 146.2 146.595 146.096C146.685 146.042 146.76 145.966 146.815 145.875C146.869 145.785 146.9 145.683 146.906 145.577C146.932 145.318 146.724 145.318 146.543 145.447H146.595ZM148.074 144.591C147.987 144.643 147.914 144.715 147.86 144.8C147.806 144.886 147.772 144.983 147.763 145.084C147.763 145.266 147.892 145.344 148.074 145.24C148.164 145.185 148.24 145.109 148.294 145.019C148.348 144.928 148.38 144.826 148.386 144.721C148.334 144.539 148.204 144.487 148.022 144.591H148.074ZM149.554 143.734C149.467 143.786 149.393 143.858 149.339 143.944C149.285 144.029 149.252 144.127 149.242 144.227C149.242 144.409 149.372 144.461 149.554 144.383C149.646 144.328 149.724 144.253 149.783 144.163C149.841 144.073 149.878 143.971 149.891 143.864C149.839 143.682 149.683 143.63 149.528 143.734H149.554ZM151.033 142.878C150.95 142.934 150.879 143.007 150.826 143.092C150.772 143.176 150.737 143.272 150.722 143.371C150.722 143.553 150.878 143.604 151.033 143.371C151.128 143.326 151.209 143.256 151.268 143.169C151.327 143.083 151.363 142.982 151.371 142.878C151.319 142.722 151.163 142.722 150.981 142.878H151.033ZM152.539 142.021C152.447 142.07 152.369 142.141 152.31 142.226C152.251 142.312 152.214 142.411 152.201 142.514C152.201 142.696 152.357 142.748 152.539 142.514C152.63 142.468 152.707 142.397 152.762 142.31C152.817 142.224 152.847 142.124 152.85 142.021C152.798 141.969 152.669 141.917 152.487 142.021H152.539ZM154.018 141.164C153.93 141.215 153.856 141.286 153.801 141.372C153.747 141.458 153.715 141.556 153.707 141.658C153.707 141.839 153.707 141.891 154.018 141.658C154.107 141.607 154.181 141.536 154.235 141.45C154.29 141.364 154.322 141.266 154.33 141.164C154.278 141.113 154.148 141.061 153.966 141.164H154.018ZM155.498 140.308C155.41 140.358 155.335 140.43 155.281 140.516C155.227 140.602 155.194 140.7 155.186 140.801C155.186 140.983 155.316 141.035 155.498 140.931C155.59 140.882 155.668 140.811 155.727 140.725C155.785 140.64 155.823 140.541 155.835 140.438C155.783 140.256 155.628 140.126 155.446 140.308H155.498ZM157.003 139.451C156.912 139.5 156.833 139.571 156.775 139.657C156.716 139.743 156.679 139.841 156.666 139.944C156.666 140.126 156.822 140.178 157.003 139.944C157.089 139.891 157.161 139.819 157.215 139.733C157.269 139.648 157.303 139.552 157.315 139.451C157.315 139.399 157.107 139.347 156.951 139.451H157.003ZM158.483 138.595C158.391 138.644 158.313 138.714 158.254 138.8C158.195 138.886 158.158 138.985 158.146 139.088C158.146 139.27 158.301 139.322 158.483 139.088C158.571 139.037 158.646 138.966 158.7 138.88C158.754 138.794 158.787 138.696 158.794 138.595C158.743 138.543 158.613 138.491 158.431 138.595H158.483ZM159.963 137.738C159.874 137.789 159.8 137.86 159.745 137.946C159.691 138.032 159.659 138.13 159.651 138.231C159.651 138.413 159.651 138.465 159.963 138.231C160.051 138.181 160.125 138.109 160.18 138.023C160.234 137.937 160.266 137.84 160.274 137.738C160.222 137.686 160.092 137.53 159.911 137.738H159.963ZM161.442 136.882C161.351 136.928 161.273 136.999 161.219 137.085C161.164 137.172 161.133 137.272 161.131 137.375C161.131 137.556 161.131 137.608 161.442 137.505C161.534 137.455 161.612 137.385 161.671 137.299C161.73 137.213 161.767 137.115 161.78 137.011C161.728 136.83 161.572 136.778 161.39 136.882H161.442ZM162.948 136.025C162.853 136.07 162.772 136.14 162.713 136.226C162.653 136.313 162.618 136.414 162.61 136.518C162.61 136.7 162.766 136.752 162.948 136.518C163.031 136.462 163.101 136.389 163.155 136.304C163.209 136.219 163.244 136.124 163.259 136.025C163.207 135.973 163.051 135.921 162.896 136.025H162.948ZM164.427 135.142C164.337 135.197 164.261 135.273 164.207 135.363C164.153 135.454 164.121 135.556 164.116 135.662C164.116 135.843 164.116 135.895 164.427 135.662C164.514 135.609 164.587 135.538 164.641 135.452C164.696 135.366 164.729 135.269 164.739 135.168C164.687 135.116 164.557 135.065 164.375 135.142H164.427ZM165.907 134.286C165.816 134.341 165.741 134.416 165.687 134.507C165.632 134.597 165.601 134.7 165.595 134.805C165.595 134.987 165.595 135.039 165.907 134.805C165.994 134.753 166.067 134.681 166.121 134.595C166.175 134.51 166.208 134.413 166.218 134.312C166.166 134.26 166.036 134.182 165.855 134.286H165.907ZM167.386 133.429C167.3 133.488 167.228 133.565 167.174 133.655C167.12 133.744 167.086 133.845 167.075 133.948C167.075 134.104 167.231 134.182 167.386 134.078C167.475 134.026 167.552 133.955 167.61 133.869C167.669 133.784 167.707 133.687 167.724 133.585C167.698 133.403 167.516 133.325 167.334 133.429H167.386ZM168.892 132.573C168.8 132.628 168.721 132.703 168.663 132.793C168.604 132.883 168.567 132.985 168.554 133.092C168.554 133.248 168.71 133.325 168.892 133.222C168.978 133.163 169.05 133.086 169.104 132.996C169.158 132.906 169.192 132.806 169.203 132.702C169.151 132.547 168.996 132.469 168.84 132.573H168.892ZM170.371 131.716C170.281 131.771 170.206 131.847 170.151 131.937C170.097 132.028 170.066 132.13 170.06 132.235C170.06 132.391 170.06 132.469 170.371 132.235C170.462 132.18 170.537 132.105 170.591 132.014C170.646 131.924 170.677 131.821 170.683 131.716C170.631 131.69 170.501 131.612 170.293 131.716H170.371ZM144.596 147.913C144.581 148.013 144.545 148.108 144.492 148.193C144.438 148.277 144.368 148.35 144.284 148.407C144.103 148.407 143.947 148.407 143.947 148.407C143.96 148.3 143.997 148.198 144.055 148.108C144.114 148.018 144.192 147.942 144.284 147.887C144.303 147.862 144.327 147.841 144.356 147.828C144.385 147.815 144.416 147.809 144.448 147.812C144.479 147.814 144.509 147.825 144.535 147.843C144.561 147.861 144.582 147.885 144.596 147.913ZM145.764 146.901C145.674 146.956 145.598 147.032 145.544 147.122C145.49 147.212 145.458 147.315 145.452 147.42C145.452 147.576 145.452 147.654 145.764 147.55C145.854 147.495 145.93 147.419 145.984 147.329C146.038 147.238 146.07 147.136 146.075 147.031C146.075 146.745 145.946 146.667 145.764 146.771V146.901ZM147.243 146.044C147.153 146.099 147.078 146.175 147.024 146.265C146.969 146.356 146.938 146.458 146.932 146.564C146.932 146.719 146.932 146.797 147.243 146.564C147.334 146.509 147.409 146.433 147.463 146.343C147.518 146.252 147.549 146.15 147.555 146.044C147.555 145.889 147.425 145.811 147.243 145.915V146.044ZM148.723 145.188C148.637 145.247 148.564 145.324 148.511 145.413C148.457 145.503 148.423 145.603 148.412 145.707C148.412 145.863 148.567 145.941 148.723 145.707C148.815 145.652 148.894 145.577 148.952 145.487C149.011 145.397 149.048 145.294 149.06 145.188C149.06 145.032 148.905 144.954 148.723 145.058V145.188ZM150.229 144.331C150.139 144.383 150.063 144.455 150.005 144.54C149.946 144.625 149.908 144.722 149.891 144.824C149.891 145.006 150.047 145.084 150.229 144.98C150.315 144.921 150.387 144.844 150.441 144.755C150.495 144.665 150.528 144.565 150.54 144.461C150.54 144.175 150.384 144.098 150.229 144.201V144.331ZM151.708 143.475C151.621 143.527 151.548 143.599 151.494 143.684C151.44 143.77 151.406 143.867 151.397 143.968C151.397 144.15 151.526 144.201 151.708 144.124C151.798 144.069 151.874 143.993 151.928 143.903C151.982 143.812 152.014 143.71 152.02 143.604C152.123 143.293 151.89 143.241 151.708 143.345V143.475ZM153.188 142.618C153.101 142.67 153.027 142.742 152.973 142.828C152.919 142.913 152.886 143.01 152.876 143.111C152.876 143.293 153.006 143.345 153.188 143.267C153.278 143.212 153.353 143.136 153.408 143.046C153.462 142.956 153.493 142.853 153.499 142.748C153.499 142.436 153.369 142.384 153.188 142.488V142.618ZM154.667 141.761C154.584 141.818 154.513 141.891 154.46 141.975C154.406 142.06 154.371 142.155 154.356 142.255C154.356 142.436 154.511 142.488 154.667 142.255C154.762 142.209 154.843 142.14 154.902 142.053C154.961 141.967 154.997 141.866 155.005 141.761C155.005 141.58 154.849 141.528 154.719 141.632L154.667 141.761ZM156.173 140.905C156.081 140.954 156.003 141.025 155.944 141.11C155.885 141.196 155.848 141.295 155.835 141.398C155.835 141.58 155.991 141.632 156.173 141.528C156.26 141.476 156.333 141.404 156.387 141.318C156.441 141.233 156.474 141.135 156.484 141.035C156.484 140.723 156.329 140.671 156.173 140.775V140.905ZM157.652 140.048C157.564 140.099 157.49 140.17 157.435 140.256C157.381 140.342 157.349 140.44 157.341 140.541C157.341 140.723 157.471 140.775 157.652 140.541C157.741 140.491 157.815 140.42 157.869 140.334C157.924 140.248 157.956 140.15 157.964 140.048C157.964 139.867 157.834 139.815 157.652 139.919V140.048ZM159.132 139.192C159.044 139.242 158.969 139.314 158.915 139.4C158.861 139.486 158.828 139.584 158.82 139.685C158.82 139.867 158.95 139.919 159.132 139.685C159.22 139.634 159.295 139.563 159.349 139.477C159.403 139.391 159.436 139.293 159.443 139.192C159.443 139.01 159.314 138.958 159.132 139.062V139.192ZM160.611 138.335C160.526 138.389 160.454 138.461 160.4 138.546C160.346 138.632 160.312 138.728 160.3 138.828C160.3 139.01 160.456 139.062 160.611 138.828C160.703 138.779 160.782 138.709 160.84 138.623C160.899 138.537 160.936 138.438 160.949 138.335C160.949 138.153 160.793 138.102 160.611 138.205V138.335ZM162.117 137.479C162.025 137.528 161.947 137.598 161.888 137.684C161.829 137.77 161.792 137.868 161.78 137.972C161.78 138.153 161.935 138.205 162.117 138.102C162.227 138.05 162.322 137.97 162.39 137.87C162.459 137.769 162.499 137.652 162.506 137.53C162.506 137.297 162.273 137.245 162.117 137.349V137.479ZM163.597 136.622C163.508 136.673 163.434 136.744 163.379 136.83C163.325 136.916 163.293 137.014 163.285 137.115C163.285 137.297 163.415 137.349 163.597 137.245C163.685 137.194 163.759 137.123 163.814 137.037C163.868 136.951 163.9 136.853 163.908 136.752C163.908 136.44 163.778 136.388 163.597 136.492V136.622ZM165.076 135.765C164.985 135.812 164.907 135.882 164.853 135.969C164.798 136.056 164.767 136.156 164.765 136.259C164.765 136.44 164.894 136.492 165.076 136.259C165.164 136.208 165.239 136.137 165.293 136.051C165.347 135.965 165.38 135.867 165.388 135.765C165.388 135.584 165.258 135.532 165.102 135.636L165.076 135.765ZM166.556 134.909C166.469 134.961 166.395 135.033 166.341 135.118C166.287 135.204 166.254 135.301 166.244 135.402C166.244 135.584 166.4 135.636 166.556 135.402C166.645 135.35 166.721 135.278 166.78 135.193C166.838 135.108 166.877 135.011 166.893 134.909C166.893 134.727 166.737 134.675 166.556 134.779V134.909ZM168.061 134.026C167.969 134.081 167.89 134.157 167.832 134.247C167.773 134.337 167.736 134.439 167.724 134.545C167.724 134.727 167.879 134.779 168.061 134.675C168.144 134.619 168.215 134.546 168.269 134.461C168.322 134.376 168.358 134.281 168.373 134.182C168.373 133.87 168.217 133.819 168.061 133.896V134.026ZM169.541 133.17C169.45 133.224 169.375 133.3 169.321 133.391C169.266 133.481 169.235 133.583 169.229 133.689C169.229 133.871 169.229 133.922 169.541 133.819C169.628 133.766 169.701 133.695 169.755 133.609C169.809 133.523 169.842 133.426 169.852 133.325C169.852 133.014 169.722 132.936 169.541 133.04V133.17Z",
    fill: "#A3ACAF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M143.869 152.066C143.861 152.168 143.829 152.266 143.775 152.352C143.72 152.438 143.646 152.509 143.558 152.56C143.376 152.56 143.246 152.56 143.246 152.56C143.254 152.458 143.286 152.36 143.341 152.274C143.395 152.188 143.469 152.117 143.558 152.066C143.739 151.833 143.869 151.885 143.869 152.066ZM145.037 151.08C144.952 151.134 144.879 151.206 144.825 151.291C144.771 151.377 144.737 151.473 144.726 151.573C144.726 151.755 144.881 151.807 145.037 151.703C145.129 151.654 145.207 151.583 145.266 151.498C145.325 151.412 145.362 151.313 145.375 151.21C145.375 151.028 145.219 150.976 145.037 151.08ZM146.543 150.223C146.451 150.273 146.373 150.343 146.314 150.429C146.255 150.515 146.218 150.613 146.205 150.717C146.205 150.898 146.361 150.95 146.543 150.846C146.631 150.796 146.705 150.725 146.76 150.639C146.814 150.553 146.846 150.455 146.854 150.353C146.932 150.172 146.724 150.12 146.543 150.223ZM148.022 149.367C147.934 149.417 147.859 149.489 147.805 149.575C147.751 149.661 147.718 149.759 147.711 149.86C147.711 150.042 147.841 150.094 148.022 149.86C148.11 149.81 148.185 149.738 148.239 149.652C148.294 149.566 148.326 149.468 148.334 149.367C148.334 149.315 148.204 149.263 148.022 149.367ZM149.502 148.51C149.41 148.557 149.333 148.627 149.278 148.714C149.223 148.801 149.193 148.901 149.19 149.003C149.19 149.185 149.32 149.237 149.502 149.003C149.591 148.951 149.667 148.88 149.726 148.795C149.784 148.709 149.823 148.612 149.839 148.51C149.839 148.458 149.683 148.406 149.528 148.51H149.502ZM150.981 147.628C150.895 147.687 150.823 147.764 150.769 147.853C150.715 147.943 150.681 148.043 150.67 148.147C150.67 148.329 150.826 148.381 150.981 148.147C151.07 148.095 151.147 148.023 151.205 147.938C151.264 147.853 151.302 147.756 151.319 147.654C151.319 147.602 151.163 147.55 150.981 147.628ZM152.487 146.771C152.395 146.826 152.316 146.901 152.258 146.991C152.199 147.081 152.162 147.184 152.149 147.29C152.149 147.472 152.305 147.524 152.487 147.42C152.574 147.368 152.647 147.296 152.701 147.21C152.755 147.125 152.788 147.028 152.798 146.927C152.798 146.745 152.669 146.693 152.487 146.771ZM153.966 145.915C153.876 145.969 153.801 146.045 153.746 146.136C153.692 146.226 153.661 146.328 153.655 146.434C153.655 146.615 153.655 146.667 153.966 146.434C154.053 146.382 154.127 146.31 154.181 146.224C154.235 146.138 154.268 146.041 154.278 145.941C154.278 145.889 154.148 145.811 153.966 145.915ZM155.446 145.058C155.356 145.113 155.28 145.189 155.226 145.279C155.172 145.369 155.14 145.472 155.134 145.577C155.134 145.733 155.264 145.811 155.446 145.577C155.538 145.522 155.617 145.447 155.675 145.357C155.734 145.267 155.771 145.165 155.783 145.058C155.783 145.032 155.628 144.954 155.446 145.058ZM156.951 144.201C156.859 144.256 156.781 144.332 156.722 144.422C156.664 144.512 156.627 144.614 156.614 144.721C156.614 144.876 156.77 144.954 156.951 144.721C157.038 144.661 157.11 144.585 157.164 144.495C157.218 144.405 157.251 144.305 157.263 144.201C157.315 144.175 157.107 144.098 156.951 144.201ZM158.431 143.345C158.339 143.4 158.26 143.475 158.202 143.565C158.143 143.655 158.106 143.757 158.094 143.864C158.094 144.02 158.249 144.098 158.431 143.994C158.521 143.939 158.597 143.863 158.651 143.773C158.705 143.682 158.737 143.58 158.743 143.475C158.743 143.319 158.613 143.241 158.431 143.345ZM159.911 142.488C159.824 142.54 159.75 142.612 159.696 142.698C159.642 142.783 159.609 142.881 159.599 142.981C159.599 143.163 159.599 143.241 159.911 143.137C160.001 143.082 160.076 143.007 160.131 142.916C160.185 142.826 160.216 142.723 160.222 142.618C160.222 142.462 160.092 142.384 159.911 142.488ZM161.39 141.632C161.303 141.684 161.23 141.756 161.176 141.841C161.122 141.927 161.088 142.024 161.079 142.125C161.079 142.307 161.079 142.384 161.39 142.281C161.482 142.226 161.561 142.15 161.619 142.06C161.678 141.97 161.715 141.868 161.728 141.761C161.728 141.606 161.572 141.528 161.39 141.632ZM162.896 140.775C162.807 140.827 162.73 140.899 162.672 140.984C162.613 141.069 162.575 141.166 162.558 141.268C162.558 141.45 162.714 141.502 162.896 141.424C162.982 141.365 163.054 141.288 163.108 141.198C163.162 141.109 163.196 141.009 163.207 140.905C163.207 140.723 163.051 140.671 162.896 140.775ZM164.375 139.918C164.288 139.971 164.215 140.042 164.161 140.128C164.107 140.214 164.074 140.311 164.064 140.412C164.064 140.593 164.064 140.645 164.375 140.567C164.465 140.513 164.541 140.437 164.595 140.346C164.649 140.256 164.681 140.154 164.687 140.048C164.687 139.867 164.557 139.815 164.375 139.918ZM165.855 139.062C165.768 139.114 165.695 139.186 165.64 139.272C165.586 139.357 165.553 139.454 165.543 139.555C165.543 139.737 165.543 139.789 165.855 139.555C165.946 139.508 166.023 139.438 166.078 139.351C166.133 139.264 166.163 139.165 166.166 139.062C166.166 139.01 166.036 138.958 165.855 139.062ZM167.334 138.205C167.249 138.259 167.176 138.331 167.123 138.417C167.069 138.502 167.035 138.598 167.023 138.698C167.023 138.88 167.179 138.932 167.334 138.698C167.429 138.653 167.51 138.584 167.569 138.497C167.628 138.411 167.664 138.31 167.672 138.205C167.698 138.153 167.516 138.101 167.334 138.205ZM168.84 137.349C168.748 137.398 168.67 137.468 168.611 137.554C168.552 137.64 168.515 137.739 168.502 137.842C168.502 138.024 168.658 138.076 168.84 137.972C168.925 137.918 168.998 137.846 169.052 137.76C169.106 137.675 169.14 137.579 169.151 137.479C169.151 137.297 168.996 137.245 168.84 137.349ZM170.293 136.492C170.205 136.543 170.131 136.614 170.076 136.7C170.022 136.786 169.99 136.884 169.982 136.985C169.982 137.167 169.982 137.219 170.293 137.115C170.382 137.065 170.456 136.993 170.51 136.907C170.565 136.821 170.597 136.723 170.605 136.622C170.631 136.44 170.501 136.388 170.293 136.492ZM144.596 152.534C144.602 152.643 144.582 152.752 144.536 152.851C144.491 152.951 144.423 153.038 144.336 153.105C144.155 153.105 143.999 153.105 143.999 153.105C144.011 153.001 144.049 152.903 144.107 152.817C144.166 152.731 144.245 152.661 144.336 152.612C144.336 152.3 144.596 152.352 144.596 152.534ZM145.764 151.547C145.676 151.598 145.601 151.669 145.547 151.755C145.493 151.841 145.46 151.939 145.452 152.04C145.452 152.222 145.452 152.274 145.764 152.04C145.852 151.99 145.927 151.919 145.981 151.833C146.035 151.747 146.068 151.649 146.075 151.547C146.075 151.495 145.946 151.443 145.764 151.547ZM147.243 150.691C147.155 150.741 147.081 150.813 147.026 150.899C146.972 150.985 146.94 151.082 146.932 151.184C146.932 151.366 146.932 151.418 147.243 151.314C147.332 151.263 147.406 151.192 147.461 151.106C147.515 151.02 147.547 150.922 147.555 150.82C147.555 150.639 147.425 150.509 147.243 150.691ZM148.723 149.834C148.638 149.888 148.565 149.96 148.511 150.045C148.457 150.131 148.423 150.227 148.412 150.327C148.412 150.509 148.567 150.561 148.723 150.327C148.815 150.278 148.893 150.208 148.952 150.122C149.011 150.036 149.048 149.937 149.06 149.834C149.06 149.782 148.905 149.73 148.723 149.834ZM150.229 148.978C150.137 149.027 150.058 149.097 150 149.183C149.941 149.269 149.904 149.367 149.891 149.471C149.891 149.652 150.047 149.704 150.229 149.471C150.314 149.417 150.386 149.345 150.44 149.26C150.494 149.174 150.528 149.078 150.54 148.978C150.54 148.926 150.384 148.874 150.229 148.978ZM151.708 148.121C151.617 148.168 151.539 148.238 151.485 148.325C151.43 148.412 151.399 148.512 151.397 148.614C151.397 148.796 151.526 148.848 151.708 148.614C151.796 148.564 151.871 148.492 151.925 148.406C151.979 148.32 152.012 148.222 152.02 148.121C152.123 148.069 151.89 147.913 151.708 148.121ZM153.188 147.264C153.096 147.311 153.019 147.381 152.964 147.468C152.909 147.555 152.879 147.655 152.876 147.758C152.876 147.939 153.006 147.991 153.188 147.887C153.274 147.835 153.348 147.763 153.402 147.678C153.456 147.592 153.489 147.495 153.499 147.394C153.499 147.212 153.369 147.161 153.188 147.264ZM154.667 146.382C154.581 146.441 154.509 146.518 154.455 146.607C154.401 146.697 154.367 146.797 154.356 146.901C154.356 147.083 154.511 147.135 154.667 146.901C154.756 146.849 154.833 146.777 154.891 146.692C154.95 146.607 154.988 146.51 155.005 146.408C155.005 146.356 154.849 146.304 154.719 146.382H154.667ZM156.173 145.525C156.081 145.58 156.002 145.655 155.944 145.746C155.885 145.836 155.848 145.938 155.835 146.044C155.835 146.226 155.991 146.278 156.173 146.044C156.256 145.988 156.327 145.915 156.38 145.83C156.434 145.746 156.469 145.65 156.484 145.551C156.484 145.499 156.329 145.447 156.173 145.525ZM157.652 144.669C157.537 144.73 157.444 144.825 157.383 144.941C157.323 145.057 157.299 145.188 157.315 145.318C157.315 145.473 157.445 145.551 157.626 145.318C157.713 145.265 157.787 145.194 157.841 145.108C157.895 145.022 157.928 144.925 157.938 144.824C157.964 144.643 157.834 144.565 157.652 144.669ZM159.132 143.812C159.042 143.867 158.966 143.943 158.912 144.033C158.858 144.124 158.826 144.226 158.82 144.331C158.82 144.487 158.95 144.565 159.132 144.461C159.222 144.406 159.298 144.33 159.352 144.24C159.406 144.149 159.438 144.047 159.443 143.942C159.443 143.786 159.314 143.708 159.132 143.812ZM160.611 142.955C160.525 143.015 160.453 143.091 160.399 143.181C160.345 143.271 160.312 143.371 160.3 143.475C160.3 143.63 160.456 143.708 160.611 143.604C160.704 143.549 160.782 143.474 160.841 143.384C160.899 143.294 160.936 143.192 160.949 143.085C160.949 142.93 160.793 142.852 160.611 142.955ZM162.117 142.099C162.025 142.154 161.946 142.229 161.888 142.319C161.829 142.409 161.792 142.511 161.78 142.618C161.78 142.774 161.935 142.852 162.117 142.618C162.203 142.559 162.276 142.482 162.329 142.392C162.383 142.303 162.417 142.203 162.428 142.099C162.506 142.073 162.273 141.995 162.117 142.099ZM163.597 141.242C163.51 141.294 163.436 141.366 163.382 141.452C163.328 141.538 163.295 141.635 163.285 141.735C163.285 141.917 163.415 141.995 163.597 141.891C163.687 141.837 163.762 141.761 163.817 141.67C163.871 141.58 163.902 141.477 163.908 141.372C163.908 141.216 163.778 141.138 163.597 141.242ZM165.102 140.386C165.015 140.438 164.942 140.51 164.888 140.595C164.834 140.681 164.8 140.778 164.791 140.879C164.791 141.061 164.92 141.138 165.102 141.035C165.192 140.98 165.268 140.904 165.322 140.814C165.376 140.723 165.408 140.621 165.414 140.515C165.388 140.334 165.258 140.282 165.102 140.386ZM166.582 139.529C166.498 139.585 166.428 139.658 166.374 139.743C166.321 139.828 166.285 139.923 166.27 140.022C166.27 140.204 166.426 140.256 166.582 140.178C166.674 140.123 166.752 140.048 166.811 139.958C166.869 139.868 166.906 139.766 166.919 139.659C166.893 139.477 166.737 139.425 166.556 139.529H166.582ZM168.087 138.673C167.998 138.725 167.922 138.796 167.863 138.881C167.805 138.967 167.766 139.064 167.75 139.166C167.75 139.347 167.905 139.399 168.087 139.321C168.173 139.262 168.246 139.185 168.299 139.096C168.353 139.006 168.387 138.906 168.399 138.802C168.373 138.621 168.217 138.569 168.061 138.673H168.087ZM169.567 137.816C169.478 137.866 169.404 137.938 169.35 138.024C169.295 138.11 169.263 138.208 169.255 138.309C169.255 138.491 169.255 138.543 169.567 138.439C169.658 138.392 169.735 138.322 169.79 138.235C169.845 138.148 169.875 138.048 169.878 137.946C169.852 137.764 169.722 137.712 169.541 137.816H169.567ZM143.895 153.832C143.889 153.937 143.858 154.039 143.804 154.13C143.749 154.22 143.674 154.296 143.584 154.351C143.402 154.351 143.272 154.351 143.272 154.351C143.278 154.245 143.309 154.143 143.364 154.053C143.418 153.962 143.493 153.886 143.584 153.832C143.739 153.598 143.869 153.676 143.869 153.832H143.895ZM145.063 152.845C144.98 152.901 144.909 152.974 144.856 153.059C144.802 153.144 144.767 153.239 144.752 153.338C144.745 153.377 144.751 153.417 144.768 153.452C144.786 153.486 144.814 153.515 144.849 153.532C144.884 153.55 144.924 153.556 144.963 153.549C145.001 153.542 145.036 153.523 145.063 153.494C145.155 153.439 145.234 153.364 145.292 153.274C145.351 153.184 145.388 153.082 145.401 152.975C145.375 152.819 145.219 152.741 145.037 152.845H145.063ZM146.569 151.989C146.479 152.041 146.403 152.112 146.345 152.197C146.286 152.283 146.248 152.38 146.231 152.482C146.231 152.663 146.387 152.741 146.569 152.637C146.659 152.583 146.734 152.507 146.789 152.416C146.843 152.326 146.874 152.224 146.88 152.118C146.932 151.937 146.724 151.885 146.543 151.989H146.569ZM148.048 151.132C147.961 151.184 147.888 151.256 147.834 151.342C147.78 151.427 147.747 151.524 147.737 151.625C147.737 151.807 147.866 151.859 148.048 151.781C148.138 151.726 148.214 151.65 148.268 151.56C148.322 151.469 148.354 151.367 148.36 151.262C148.334 151.08 148.204 151.028 148.022 151.132H148.048ZM149.528 150.275C149.441 150.328 149.368 150.399 149.313 150.485C149.259 150.571 149.226 150.668 149.216 150.769C149.216 150.95 149.346 151.002 149.528 150.924C149.62 150.869 149.698 150.794 149.757 150.704C149.815 150.614 149.852 150.512 149.865 150.405C149.839 150.223 149.683 150.172 149.528 150.275ZM151.007 149.419C150.922 149.472 150.849 149.545 150.796 149.63C150.742 149.715 150.708 149.812 150.696 149.912C150.696 150.094 150.852 150.146 151.007 149.912C151.102 149.867 151.183 149.797 151.242 149.711C151.301 149.624 151.337 149.523 151.345 149.419C151.319 149.367 151.163 149.315 150.981 149.419H151.007ZM152.513 148.562C152.421 148.611 152.343 148.682 152.284 148.768C152.225 148.853 152.188 148.952 152.175 149.055C152.175 149.237 152.331 149.289 152.513 149.185C152.601 149.135 152.676 149.063 152.73 148.977C152.784 148.891 152.817 148.793 152.824 148.692C152.798 148.51 152.669 148.458 152.487 148.562H152.513ZM153.992 147.706C153.904 147.756 153.83 147.828 153.775 147.914C153.721 147.999 153.689 148.097 153.681 148.199C153.681 148.381 153.681 148.432 153.992 148.199C154.081 148.148 154.155 148.077 154.209 147.991C154.264 147.905 154.296 147.807 154.304 147.706C154.278 147.654 154.148 147.602 153.966 147.706H153.992ZM155.472 146.849C155.384 146.9 155.309 146.971 155.255 147.057C155.201 147.143 155.168 147.241 155.16 147.342C155.16 147.524 155.29 147.576 155.472 147.342C155.564 147.293 155.642 147.223 155.701 147.137C155.76 147.051 155.797 146.952 155.809 146.849C155.783 146.797 155.628 146.745 155.446 146.849H155.472ZM156.977 145.992C156.886 146.042 156.807 146.112 156.749 146.198C156.69 146.284 156.653 146.382 156.64 146.486C156.64 146.667 156.796 146.719 156.977 146.486C157.063 146.432 157.135 146.36 157.189 146.274C157.243 146.189 157.277 146.093 157.289 145.992C157.315 145.941 157.107 145.889 156.951 145.992H156.977ZM158.457 145.136C158.365 145.185 158.287 145.255 158.228 145.341C158.169 145.427 158.132 145.526 158.12 145.629C158.12 145.811 158.275 145.863 158.457 145.759C158.545 145.708 158.62 145.637 158.674 145.551C158.728 145.465 158.761 145.367 158.768 145.266C158.743 145.084 158.613 145.032 158.431 145.136H158.457ZM159.911 144.279C159.819 144.326 159.742 144.396 159.687 144.483C159.632 144.57 159.602 144.67 159.599 144.772C159.599 144.954 159.599 145.006 159.911 144.902C159.999 144.852 160.073 144.78 160.128 144.694C160.182 144.608 160.214 144.51 160.222 144.409C160.222 144.227 160.092 144.175 159.911 144.279ZM161.39 143.423C161.299 143.469 161.221 143.54 161.167 143.627C161.112 143.713 161.081 143.813 161.079 143.916C161.079 144.098 161.079 144.149 161.39 143.916C161.479 143.864 161.556 143.792 161.614 143.707C161.672 143.622 161.711 143.525 161.728 143.423C161.728 143.371 161.572 143.319 161.39 143.423ZM162.896 142.54C162.803 142.595 162.725 142.67 162.667 142.76C162.608 142.85 162.571 142.953 162.558 143.059C162.558 143.241 162.714 143.293 162.896 143.059C162.979 143.003 163.049 142.93 163.103 142.845C163.157 142.76 163.192 142.665 163.207 142.566C163.207 142.514 163.051 142.462 162.896 142.54ZM164.375 141.684C164.285 141.738 164.21 141.814 164.155 141.905C164.101 141.995 164.07 142.097 164.064 142.203C164.064 142.384 164.064 142.436 164.375 142.332C164.462 142.28 164.535 142.209 164.59 142.123C164.644 142.037 164.677 141.94 164.687 141.839C164.687 141.658 164.557 141.606 164.375 141.684ZM165.855 140.827C165.765 140.882 165.689 140.958 165.635 141.048C165.581 141.138 165.549 141.241 165.543 141.346C165.543 141.502 165.543 141.58 165.855 141.476C165.942 141.424 166.015 141.352 166.069 141.266C166.123 141.181 166.156 141.084 166.166 140.983C166.166 140.801 166.036 140.723 165.855 140.827ZM167.334 139.97C167.248 140.029 167.176 140.106 167.122 140.196C167.068 140.286 167.034 140.386 167.023 140.49C167.023 140.645 167.179 140.723 167.334 140.49C167.497 140.419 167.627 140.289 167.698 140.126C167.698 139.944 167.516 139.867 167.334 139.97ZM168.84 139.114C168.748 139.169 168.669 139.244 168.611 139.334C168.552 139.424 168.515 139.526 168.502 139.633C168.502 139.789 168.658 139.867 168.84 139.633C168.926 139.574 168.998 139.497 169.052 139.407C169.106 139.318 169.14 139.218 169.151 139.114C169.151 139.088 168.996 139.01 168.84 139.114ZM170.319 138.257C170.229 138.312 170.154 138.388 170.099 138.478C170.045 138.569 170.014 138.671 170.008 138.776C170.008 138.932 170.008 139.01 170.319 138.906C170.41 138.851 170.485 138.776 170.539 138.685C170.594 138.595 170.625 138.492 170.631 138.387C170.631 138.231 170.501 138.153 170.293 138.257H170.319ZM144.596 154.299C144.584 154.403 144.551 154.503 144.497 154.592C144.443 154.682 144.371 154.759 144.284 154.818C144.103 154.818 143.947 154.818 143.947 154.818C143.96 154.711 143.997 154.609 144.055 154.519C144.114 154.429 144.192 154.354 144.284 154.299C144.336 154.065 144.596 154.143 144.596 154.299ZM145.764 153.312C145.674 153.367 145.598 153.443 145.544 153.533C145.49 153.624 145.458 153.726 145.452 153.832C145.452 153.987 145.452 154.065 145.764 153.832C145.854 153.777 145.93 153.701 145.984 153.61C146.038 153.52 146.07 153.418 146.075 153.312C146.075 153.286 145.946 153.105 145.764 153.312ZM147.243 152.456C147.133 152.521 147.045 152.618 146.99 152.733C146.934 152.849 146.914 152.978 146.932 153.105C146.932 153.26 146.932 153.338 147.243 153.105C147.334 153.05 147.409 152.974 147.463 152.884C147.518 152.793 147.549 152.691 147.555 152.586C147.555 152.43 147.425 152.352 147.243 152.456ZM148.723 151.599C148.64 151.655 148.569 151.728 148.516 151.813C148.462 151.898 148.427 151.993 148.412 152.092C148.405 152.131 148.411 152.171 148.428 152.206C148.446 152.241 148.474 152.269 148.509 152.286C148.544 152.304 148.584 152.31 148.622 152.303C148.661 152.296 148.696 152.277 148.723 152.248C148.815 152.193 148.894 152.118 148.952 152.028C149.011 151.938 149.048 151.836 149.06 151.729C149.06 151.573 148.905 151.495 148.723 151.599ZM150.229 150.743C150.139 150.795 150.063 150.866 150.005 150.951C149.946 151.037 149.908 151.134 149.891 151.236C149.891 151.417 150.047 151.495 150.229 151.392C150.315 151.332 150.387 151.256 150.441 151.166C150.495 151.076 150.528 150.976 150.54 150.872C150.54 150.691 150.384 150.639 150.229 150.743ZM151.708 149.886C151.621 149.938 151.548 150.01 151.494 150.096C151.44 150.181 151.406 150.278 151.397 150.379C151.397 150.561 151.526 150.613 151.708 150.535C151.798 150.48 151.874 150.404 151.928 150.314C151.982 150.223 152.014 150.121 152.02 150.016C152.123 149.834 151.89 149.782 151.708 149.886ZM153.188 149.029C153.101 149.082 153.027 149.153 152.973 149.239C152.919 149.325 152.886 149.422 152.876 149.523C152.876 149.704 153.006 149.756 153.188 149.678C153.278 149.624 153.353 149.548 153.408 149.457C153.462 149.367 153.493 149.265 153.499 149.159C153.499 148.978 153.369 148.926 153.188 149.029ZM154.719 148.173C154.634 148.227 154.561 148.299 154.507 148.384C154.453 148.469 154.419 148.566 154.408 148.666C154.408 148.848 154.563 148.9 154.719 148.796C154.814 148.751 154.895 148.681 154.954 148.594C155.013 148.508 155.049 148.407 155.057 148.303C155.005 148.121 154.849 148.069 154.719 148.173ZM156.225 147.316C156.133 147.365 156.055 147.436 155.996 147.522C155.937 147.608 155.9 147.706 155.887 147.809C155.887 147.991 156.043 148.043 156.225 147.809C156.31 147.756 156.383 147.684 156.436 147.598C156.49 147.513 156.524 147.417 156.536 147.316C156.484 147.264 156.329 147.212 156.173 147.316H156.225ZM157.704 146.46C157.616 146.51 157.541 146.582 157.487 146.668C157.433 146.754 157.4 146.851 157.393 146.953C157.393 147.135 157.523 147.186 157.704 146.953C157.792 146.902 157.867 146.831 157.921 146.745C157.976 146.659 158.008 146.561 158.016 146.46C157.964 146.408 157.834 146.356 157.652 146.46H157.704ZM159.184 145.603C159.096 145.654 159.021 145.725 158.967 145.811C158.912 145.897 158.88 145.995 158.872 146.096C158.872 146.278 159.002 146.33 159.184 146.226C159.272 146.176 159.347 146.104 159.401 146.018C159.455 145.932 159.488 145.834 159.495 145.733C159.443 145.551 159.314 145.499 159.132 145.603H159.184ZM160.663 144.747C160.578 144.8 160.505 144.872 160.452 144.958C160.398 145.043 160.364 145.139 160.352 145.24C160.352 145.421 160.508 145.473 160.663 145.369C160.755 145.32 160.833 145.25 160.892 145.164C160.951 145.078 160.988 144.98 161.001 144.876C160.949 144.695 160.793 144.643 160.611 144.747H160.663ZM162.169 143.89C162.077 143.939 161.999 144.01 161.94 144.095C161.881 144.181 161.844 144.28 161.831 144.383C161.831 144.565 161.987 144.617 162.169 144.383C162.323 144.309 162.444 144.179 162.506 144.02C162.506 143.838 162.273 143.786 162.117 143.89H162.169ZM163.648 143.033C163.557 143.08 163.48 143.15 163.425 143.237C163.37 143.324 163.34 143.424 163.337 143.527C163.337 143.708 163.467 143.76 163.648 143.527C163.737 143.476 163.811 143.405 163.865 143.319C163.92 143.233 163.952 143.135 163.96 143.033C163.908 142.981 163.778 142.93 163.597 143.033H163.648ZM165.128 142.177C165.037 142.223 164.959 142.294 164.905 142.381C164.85 142.467 164.819 142.567 164.816 142.67C164.816 142.852 164.946 142.904 165.128 142.8C165.215 142.748 165.288 142.676 165.342 142.59C165.396 142.504 165.43 142.407 165.439 142.307C165.388 142.125 165.258 142.073 165.102 142.177H165.128ZM166.608 141.294C166.521 141.353 166.449 141.43 166.395 141.52C166.341 141.609 166.308 141.71 166.296 141.813C166.296 141.995 166.452 142.047 166.608 141.943C166.697 141.891 166.773 141.82 166.831 141.734C166.89 141.649 166.929 141.552 166.945 141.45C166.893 141.268 166.737 141.216 166.556 141.294H166.608ZM168.113 140.438C168.021 140.493 167.942 140.568 167.884 140.658C167.825 140.748 167.788 140.85 167.776 140.957C167.776 141.138 167.931 141.19 168.113 140.957C168.196 140.901 168.267 140.828 168.32 140.743C168.374 140.658 168.409 140.563 168.425 140.464C168.428 140.415 168.412 140.368 168.381 140.331C168.349 140.295 168.304 140.272 168.256 140.269C168.208 140.265 168.16 140.281 168.124 140.313C168.087 140.345 168.065 140.389 168.061 140.438H168.113ZM169.593 139.581C169.502 139.636 169.427 139.712 169.373 139.802C169.318 139.893 169.287 139.995 169.281 140.1C169.281 140.256 169.281 140.334 169.593 140.1C169.679 140.048 169.753 139.976 169.807 139.891C169.861 139.805 169.894 139.708 169.904 139.607C169.852 139.555 169.722 139.477 169.541 139.581H169.593ZM143.869 155.7C143.861 155.802 143.829 155.9 143.775 155.986C143.72 156.072 143.646 156.143 143.558 156.194C143.376 156.194 143.246 156.194 143.246 156.194C143.254 156.092 143.286 155.994 143.341 155.908C143.395 155.822 143.469 155.751 143.558 155.7C143.739 155.389 143.869 155.441 143.869 155.7ZM145.037 154.714C144.95 154.766 144.877 154.838 144.823 154.924C144.769 155.009 144.735 155.106 144.726 155.207C144.726 155.389 144.881 155.441 145.037 155.207C145.129 155.158 145.207 155.088 145.266 155.002C145.325 154.916 145.362 154.817 145.375 154.714C145.375 154.584 145.219 154.532 145.037 154.636V154.714ZM146.543 153.857C146.448 153.903 146.367 153.972 146.308 154.059C146.249 154.145 146.213 154.246 146.205 154.351C146.205 154.532 146.361 154.584 146.543 154.351C146.629 154.298 146.703 154.227 146.757 154.141C146.811 154.055 146.844 153.958 146.854 153.857C146.932 153.728 146.724 153.676 146.543 153.78V153.857ZM148.022 152.975C147.932 153.03 147.856 153.105 147.802 153.196C147.748 153.286 147.717 153.389 147.711 153.494C147.711 153.676 147.841 153.728 148.022 153.624C148.109 153.572 148.182 153.5 148.236 153.414C148.291 153.329 148.324 153.231 148.334 153.131C148.334 152.871 148.204 152.819 148.022 152.897V152.975ZM149.502 152.118C149.412 152.173 149.336 152.249 149.282 152.339C149.227 152.43 149.196 152.532 149.19 152.637C149.19 152.819 149.32 152.871 149.502 152.767C149.591 152.715 149.667 152.644 149.726 152.558C149.784 152.473 149.823 152.376 149.839 152.274C149.839 152.015 149.683 151.937 149.528 152.04L149.502 152.118ZM150.981 151.262C150.895 151.321 150.823 151.398 150.769 151.487C150.715 151.577 150.681 151.677 150.67 151.781C150.67 151.937 150.826 152.015 150.981 151.781C151.07 151.729 151.147 151.657 151.205 151.572C151.264 151.487 151.302 151.39 151.319 151.288C151.319 151.158 151.163 151.08 150.981 151.184V151.262ZM152.487 150.405C152.395 150.46 152.316 150.535 152.258 150.625C152.199 150.715 152.162 150.818 152.149 150.924C152.149 151.08 152.305 151.158 152.487 150.924C152.577 150.87 152.653 150.794 152.707 150.703C152.761 150.613 152.793 150.511 152.798 150.405C152.798 150.301 152.669 150.223 152.487 150.327V150.405ZM153.966 149.549C153.876 149.603 153.801 149.679 153.746 149.77C153.692 149.86 153.661 149.962 153.655 150.068C153.655 150.223 153.655 150.301 153.966 150.198C154.057 150.143 154.132 150.067 154.186 149.976C154.241 149.886 154.272 149.784 154.278 149.678C154.278 149.445 154.148 149.367 153.966 149.471V149.549ZM155.446 148.692C155.356 148.747 155.28 148.823 155.226 148.913C155.172 149.003 155.14 149.106 155.134 149.211C155.134 149.367 155.264 149.445 155.446 149.341C155.538 149.286 155.617 149.211 155.675 149.121C155.734 149.031 155.771 148.928 155.783 148.822C155.783 148.588 155.628 148.51 155.446 148.614V148.692ZM156.951 147.835C156.862 147.888 156.786 147.959 156.728 148.044C156.669 148.129 156.63 148.227 156.614 148.329C156.614 148.51 156.77 148.588 156.951 148.484C157.054 148.426 157.14 148.343 157.204 148.244C157.267 148.144 157.305 148.031 157.315 147.913C157.315 147.732 157.107 147.654 156.951 147.758V147.835ZM158.431 146.979C158.342 147.031 158.265 147.102 158.207 147.188C158.149 147.273 158.11 147.37 158.094 147.472C158.094 147.654 158.249 147.732 158.431 147.628C158.521 147.573 158.597 147.497 158.651 147.407C158.705 147.316 158.737 147.214 158.743 147.109C158.743 146.849 158.613 146.797 158.431 146.901V146.979ZM159.911 146.122C159.824 146.174 159.75 146.246 159.696 146.332C159.642 146.418 159.609 146.515 159.599 146.615C159.599 146.797 159.599 146.849 159.911 146.771C160.001 146.716 160.076 146.641 160.131 146.55C160.185 146.46 160.216 146.357 160.222 146.252C160.222 145.992 160.092 145.941 159.911 146.044V146.122ZM161.39 145.266C161.303 145.318 161.23 145.39 161.176 145.475C161.122 145.561 161.088 145.658 161.079 145.759C161.079 145.941 161.079 145.992 161.39 145.759C161.478 145.718 161.555 145.657 161.613 145.58C161.672 145.503 161.711 145.413 161.728 145.318C161.728 145.136 161.572 145.084 161.39 145.318V145.266ZM162.896 144.409C162.804 144.458 162.726 144.529 162.667 144.615C162.608 144.7 162.571 144.799 162.558 144.902C162.558 145.084 162.714 145.136 162.896 144.902C162.982 144.85 163.056 144.778 163.11 144.693C163.164 144.607 163.197 144.51 163.207 144.409C163.207 144.279 163.051 144.227 162.896 144.331V144.409ZM164.375 143.552C164.287 143.603 164.212 143.674 164.158 143.76C164.104 143.846 164.071 143.944 164.064 144.046C164.064 144.227 164.064 144.279 164.375 144.175C164.463 144.125 164.538 144.054 164.592 143.968C164.647 143.882 164.679 143.784 164.687 143.682C164.687 143.423 164.557 143.371 164.375 143.475V143.552ZM165.855 142.696C165.767 142.746 165.692 142.818 165.638 142.904C165.583 142.99 165.551 143.088 165.543 143.189C165.543 143.371 165.543 143.423 165.855 143.319C165.943 143.268 166.018 143.197 166.072 143.111C166.126 143.025 166.159 142.927 166.166 142.826C166.166 142.566 166.036 142.514 165.855 142.722V142.696ZM167.334 141.839C167.249 141.893 167.176 141.965 167.123 142.051C167.069 142.136 167.035 142.232 167.023 142.332C167.023 142.514 167.179 142.566 167.334 142.332C167.426 142.283 167.504 142.213 167.563 142.127C167.622 142.041 167.659 141.943 167.672 141.839C167.698 141.71 167.516 141.658 167.334 141.761V141.839ZM168.84 140.983C168.748 141.032 168.67 141.102 168.611 141.188C168.552 141.274 168.515 141.373 168.502 141.476C168.502 141.658 168.658 141.71 168.84 141.476C168.925 141.422 168.998 141.35 169.052 141.265C169.106 141.179 169.14 141.083 169.151 140.983C169.151 140.853 168.996 140.801 168.84 140.905V140.983ZM170.293 140.126C170.205 140.177 170.131 140.248 170.076 140.334C170.022 140.42 169.99 140.518 169.982 140.619C169.982 140.801 169.982 140.853 170.293 140.749C170.382 140.699 170.456 140.627 170.51 140.541C170.565 140.455 170.597 140.357 170.605 140.256C170.631 140.126 170.501 139.944 170.293 140.126ZM144.596 156.09C144.584 156.19 144.55 156.286 144.496 156.372C144.442 156.457 144.37 156.529 144.284 156.583C144.103 156.583 143.947 156.583 143.947 156.453C143.965 156.345 144.01 156.243 144.078 156.156C144.146 156.07 144.235 156.003 144.336 155.96C144.336 155.856 144.596 155.908 144.596 156.09ZM145.764 155.103C145.676 155.154 145.601 155.225 145.547 155.311C145.493 155.397 145.46 155.495 145.452 155.597C145.452 155.778 145.452 155.83 145.764 155.597C145.852 155.546 145.927 155.475 145.981 155.389C146.035 155.303 146.068 155.205 146.075 155.103C146.075 155.052 145.946 155 145.764 155.103ZM147.243 154.247C147.155 154.297 147.081 154.369 147.026 154.455C146.972 154.541 146.94 154.639 146.932 154.74C146.932 154.922 146.932 154.974 147.243 154.74C147.332 154.689 147.406 154.618 147.461 154.532C147.515 154.446 147.547 154.348 147.555 154.247C147.555 154.195 147.425 154.143 147.243 154.247ZM148.723 153.39C148.636 153.442 148.563 153.514 148.509 153.6C148.455 153.686 148.421 153.783 148.412 153.883C148.412 154.065 148.567 154.117 148.723 154.013C148.815 153.964 148.893 153.894 148.952 153.808C149.011 153.722 149.048 153.623 149.06 153.52C149.06 153.338 148.905 153.286 148.723 153.39ZM150.229 152.508C150.136 152.563 150.058 152.638 149.999 152.728C149.941 152.818 149.904 152.92 149.891 153.027C149.891 153.209 150.047 153.26 150.229 153.157C150.312 153.1 150.382 153.028 150.436 152.943C150.49 152.858 150.525 152.763 150.54 152.663C150.54 152.482 150.384 152.43 150.229 152.508ZM151.708 151.651C151.618 151.706 151.542 151.782 151.488 151.872C151.434 151.963 151.402 152.065 151.397 152.17C151.397 152.352 151.526 152.404 151.708 152.17C151.8 152.144 151.885 152.098 151.956 152.035C152.028 151.972 152.085 151.894 152.123 151.807C152.123 151.625 151.89 151.573 151.708 151.651ZM153.188 150.795C153.097 150.849 153.022 150.925 152.968 151.016C152.913 151.106 152.882 151.208 152.876 151.314C152.876 151.495 153.006 151.547 153.188 151.314C153.274 151.261 153.348 151.19 153.402 151.104C153.456 151.018 153.489 150.921 153.499 150.82C153.499 150.769 153.369 150.691 153.188 150.795ZM154.667 149.938C154.581 149.997 154.509 150.074 154.455 150.164C154.401 150.253 154.367 150.353 154.356 150.457C154.356 150.613 154.511 150.691 154.667 150.587C154.756 150.535 154.833 150.463 154.891 150.378C154.95 150.293 154.988 150.196 155.005 150.094C155.005 149.912 154.849 149.834 154.719 149.938H154.667ZM156.173 149.081C156.081 149.136 156.002 149.212 155.944 149.302C155.885 149.392 155.848 149.494 155.835 149.601C155.835 149.756 155.991 149.834 156.173 149.73C156.259 149.671 156.331 149.594 156.385 149.505C156.439 149.415 156.473 149.315 156.484 149.211C156.484 149.055 156.329 148.978 156.173 149.081ZM157.652 148.225C157.562 148.279 157.487 148.355 157.432 148.446C157.378 148.536 157.347 148.639 157.341 148.744C157.341 148.9 157.471 148.978 157.652 148.744C157.743 148.689 157.818 148.613 157.872 148.523C157.927 148.432 157.958 148.33 157.964 148.225C157.964 148.199 157.834 148.121 157.652 148.225ZM159.132 147.368C159.042 147.423 158.966 147.499 158.912 147.589C158.858 147.68 158.826 147.782 158.82 147.887C158.82 148.043 158.95 148.121 159.132 147.887C159.222 147.833 159.298 147.757 159.352 147.666C159.406 147.576 159.438 147.474 159.443 147.368C159.443 147.342 159.314 147.264 159.132 147.368ZM160.611 146.512C160.528 146.568 160.458 146.641 160.404 146.726C160.35 146.81 160.315 146.906 160.3 147.005C160.293 147.043 160.299 147.083 160.317 147.118C160.334 147.153 160.363 147.181 160.398 147.199C160.433 147.216 160.472 147.222 160.511 147.215C160.549 147.208 160.585 147.189 160.611 147.161C160.704 147.106 160.782 147.03 160.841 146.94C160.899 146.85 160.936 146.748 160.949 146.641C160.949 146.486 160.793 146.408 160.611 146.512ZM162.117 145.655C162.028 145.707 161.951 145.779 161.893 145.864C161.835 145.949 161.796 146.046 161.78 146.148C161.78 146.33 161.935 146.408 162.117 146.304C162.203 146.245 162.276 146.168 162.329 146.078C162.383 145.989 162.417 145.889 162.428 145.785C162.506 145.603 162.273 145.551 162.117 145.655ZM163.597 144.798C163.51 144.851 163.436 144.922 163.382 145.008C163.328 145.094 163.295 145.191 163.285 145.292C163.285 145.473 163.415 145.525 163.597 145.447C163.687 145.393 163.762 145.317 163.817 145.226C163.871 145.136 163.902 145.034 163.908 144.928C163.908 144.747 163.778 144.695 163.597 144.798ZM165.076 143.942C164.989 143.994 164.916 144.066 164.862 144.151C164.808 144.237 164.774 144.334 164.765 144.435C164.765 144.617 164.894 144.669 165.076 144.565C165.168 144.518 165.245 144.448 165.3 144.361C165.354 144.274 165.385 144.174 165.388 144.072C165.388 143.89 165.258 143.838 165.102 143.942H165.076ZM166.556 143.085C166.47 143.139 166.398 143.211 166.344 143.296C166.29 143.382 166.256 143.478 166.244 143.578C166.244 143.76 166.4 143.812 166.556 143.708C166.65 143.663 166.731 143.593 166.79 143.507C166.85 143.42 166.885 143.32 166.893 143.215C166.893 143.033 166.737 142.981 166.556 143.085ZM168.061 142.229C167.965 142.275 167.881 142.344 167.818 142.43C167.754 142.516 167.713 142.616 167.698 142.722C167.698 142.904 167.853 142.955 168.035 142.722C168.121 142.668 168.193 142.596 168.247 142.511C168.301 142.425 168.335 142.329 168.347 142.229C168.373 142.177 168.217 142.125 168.061 142.229ZM169.541 141.372C169.452 141.423 169.378 141.494 169.324 141.58C169.269 141.666 169.237 141.764 169.229 141.865C169.229 142.047 169.229 142.099 169.541 141.865C169.629 141.815 169.703 141.743 169.758 141.657C169.812 141.571 169.844 141.473 169.852 141.372C169.852 141.32 169.722 141.268 169.541 141.372ZM143.869 157.388C143.863 157.493 143.832 157.595 143.778 157.686C143.723 157.776 143.648 157.852 143.558 157.907C143.376 157.907 143.246 157.907 143.246 157.751C143.256 157.65 143.289 157.553 143.343 157.467C143.397 157.382 143.471 157.31 143.558 157.258C143.739 157.154 143.869 157.206 143.869 157.388ZM145.037 156.401C144.954 156.458 144.883 156.53 144.83 156.615C144.776 156.7 144.741 156.795 144.726 156.894C144.726 157.076 144.881 157.128 145.037 157.05C145.129 156.995 145.208 156.92 145.266 156.83C145.325 156.74 145.362 156.638 145.375 156.531C145.375 156.349 145.219 156.297 145.037 156.401ZM146.543 155.545C146.454 155.597 146.377 155.668 146.319 155.754C146.26 155.839 146.222 155.936 146.205 156.038C146.205 156.22 146.361 156.271 146.543 156.038C146.629 156.016 146.71 155.974 146.778 155.916C146.845 155.857 146.898 155.783 146.932 155.7C146.932 155.493 146.724 155.441 146.543 155.545ZM148.022 154.688C147.934 154.739 147.859 154.81 147.805 154.896C147.751 154.982 147.718 155.08 147.711 155.181C147.711 155.363 147.841 155.415 148.022 155.311C148.114 155.264 148.191 155.194 148.246 155.107C148.3 155.02 148.331 154.921 148.334 154.818C148.334 154.636 148.204 154.584 148.022 154.688ZM149.502 153.832C149.414 153.882 149.339 153.953 149.285 154.039C149.23 154.125 149.198 154.223 149.19 154.325C149.19 154.506 149.32 154.558 149.502 154.454C149.593 154.405 149.672 154.335 149.731 154.249C149.789 154.163 149.827 154.065 149.839 153.961C149.839 153.78 149.683 153.728 149.528 153.832H149.502ZM150.981 152.975C150.896 153.029 150.823 153.101 150.77 153.186C150.716 153.271 150.682 153.368 150.67 153.468C150.67 153.65 150.826 153.702 150.981 153.468C151.073 153.419 151.151 153.349 151.21 153.263C151.269 153.177 151.306 153.078 151.319 152.975C151.319 152.923 151.163 152.871 150.981 153.105V152.975ZM152.487 152.118C152.395 152.167 152.317 152.238 152.258 152.324C152.199 152.41 152.162 152.508 152.149 152.612C152.149 152.793 152.305 152.845 152.487 152.612C152.575 152.561 152.65 152.49 152.704 152.404C152.758 152.318 152.791 152.22 152.798 152.118C152.798 152.066 152.669 152.015 152.487 152.118ZM153.966 151.262C153.878 151.312 153.804 151.384 153.749 151.47C153.695 151.556 153.663 151.654 153.655 151.755C153.655 151.937 153.655 151.989 153.966 151.885C154.055 151.834 154.129 151.763 154.183 151.677C154.238 151.591 154.27 151.493 154.278 151.392C154.278 151.21 154.148 151.158 153.966 151.262ZM155.446 150.405C155.358 150.456 155.283 150.527 155.229 150.613C155.175 150.699 155.142 150.797 155.134 150.898C155.134 151.08 155.264 151.132 155.446 151.028C155.538 150.979 155.616 150.909 155.675 150.823C155.734 150.737 155.771 150.638 155.783 150.535C155.783 150.353 155.628 150.301 155.446 150.509V150.405ZM156.951 149.549C156.857 149.594 156.776 149.663 156.717 149.75C156.657 149.837 156.622 149.937 156.614 150.042C156.614 150.223 156.77 150.275 156.951 150.042C157.037 149.988 157.109 149.916 157.163 149.831C157.217 149.745 157.251 149.649 157.263 149.549C157.315 149.497 157.107 149.445 156.951 149.549ZM158.431 148.692C158.336 148.737 158.255 148.807 158.196 148.893C158.137 148.98 158.102 149.081 158.094 149.185C158.094 149.367 158.249 149.419 158.431 149.185C158.518 149.133 158.591 149.061 158.645 148.976C158.699 148.89 158.733 148.793 158.743 148.692C158.743 148.64 158.613 148.588 158.431 148.692ZM159.911 147.913C159.82 147.968 159.745 148.044 159.691 148.134C159.636 148.225 159.605 148.327 159.599 148.432C159.599 148.614 159.599 148.666 159.911 148.562C159.997 148.51 160.071 148.438 160.125 148.353C160.179 148.267 160.212 148.17 160.222 148.069C160.222 147.913 160.092 147.732 159.911 147.913ZM161.39 147.057C161.3 147.111 161.224 147.187 161.17 147.278C161.116 147.368 161.084 147.471 161.079 147.576C161.079 147.758 161.079 147.809 161.39 147.706C161.479 147.653 161.556 147.582 161.614 147.497C161.672 147.412 161.711 147.314 161.728 147.212C161.728 146.927 161.572 146.849 161.39 146.953V147.057ZM162.896 146.2C162.803 146.255 162.725 146.33 162.667 146.42C162.608 146.51 162.571 146.613 162.558 146.719C162.558 146.875 162.714 146.953 162.896 146.719C162.979 146.663 163.049 146.59 163.103 146.505C163.157 146.42 163.192 146.325 163.207 146.226C163.208 146.19 163.197 146.154 163.177 146.124C163.157 146.093 163.129 146.07 163.095 146.056C163.062 146.042 163.025 146.038 162.989 146.045C162.954 146.053 162.921 146.07 162.896 146.096V146.2ZM164.375 145.344C164.285 145.398 164.21 145.474 164.155 145.565C164.101 145.655 164.07 145.757 164.064 145.863C164.064 146.018 164.064 146.096 164.375 145.863C164.465 145.808 164.541 145.732 164.595 145.642C164.649 145.551 164.681 145.449 164.687 145.344C164.687 145.318 164.557 145.136 164.375 145.318V145.344ZM165.855 144.487C165.765 144.542 165.689 144.617 165.635 144.708C165.581 144.798 165.549 144.901 165.543 145.006C165.543 145.162 165.543 145.24 165.855 145.006C165.945 144.951 166.021 144.876 166.075 144.785C166.129 144.695 166.16 144.592 166.166 144.487C166.166 144.357 166.036 144.279 165.855 144.383V144.487ZM167.334 143.63C167.248 143.689 167.176 143.766 167.122 143.856C167.068 143.946 167.034 144.046 167.023 144.149C167.023 144.305 167.179 144.383 167.334 144.279C167.427 144.224 167.505 144.149 167.564 144.059C167.622 143.969 167.659 143.867 167.672 143.76C167.698 143.501 167.516 143.423 167.334 143.527V143.63ZM168.84 142.774C168.751 142.826 168.674 142.897 168.616 142.983C168.558 143.068 168.519 143.165 168.502 143.267C168.502 143.449 168.658 143.527 168.84 143.423C168.926 143.364 168.998 143.287 169.052 143.197C169.106 143.108 169.14 143.007 169.151 142.904C169.151 142.722 168.996 142.566 168.84 142.722V142.774ZM170.319 141.917C170.233 141.969 170.159 142.041 170.105 142.127C170.051 142.212 170.018 142.31 170.008 142.41C170.008 142.592 170.008 142.67 170.319 142.566C170.41 142.511 170.485 142.436 170.539 142.345C170.594 142.255 170.625 142.152 170.631 142.047C170.631 141.761 170.501 141.71 170.293 141.813L170.319 141.917ZM144.596 157.855C144.566 158.029 144.473 158.185 144.336 158.296C144.155 158.296 143.999 158.296 143.999 158.166C144.012 158.06 144.049 157.958 144.107 157.868C144.166 157.778 144.244 157.702 144.336 157.647C144.336 157.621 144.596 157.699 144.596 157.855ZM145.764 156.869C145.677 156.921 145.604 156.992 145.55 157.078C145.496 157.164 145.462 157.261 145.452 157.362C145.452 157.543 145.452 157.621 145.764 157.517C145.854 157.463 145.93 157.387 145.984 157.296C146.038 157.206 146.07 157.104 146.075 156.998C146.075 156.843 145.946 156.765 145.764 156.869ZM147.243 156.012C147.157 156.064 147.083 156.136 147.029 156.222C146.975 156.307 146.942 156.404 146.932 156.505C146.932 156.687 146.932 156.765 147.243 156.661C147.334 156.606 147.409 156.53 147.463 156.44C147.518 156.349 147.549 156.247 147.555 156.142C147.555 155.96 147.425 155.908 147.243 156.012ZM148.723 155.155C148.64 155.212 148.569 155.284 148.516 155.369C148.462 155.454 148.427 155.549 148.412 155.649C148.412 155.83 148.567 155.882 148.723 155.804C148.815 155.749 148.894 155.674 148.952 155.584C149.011 155.494 149.048 155.392 149.06 155.285C149.06 155.103 148.905 155.052 148.723 155.155ZM150.229 154.299C150.139 154.351 150.063 154.422 150.005 154.508C149.946 154.593 149.908 154.69 149.891 154.792C149.891 154.974 150.047 155.026 150.229 154.922C150.315 154.87 150.389 154.798 150.443 154.712C150.497 154.626 150.53 154.529 150.54 154.429C150.54 154.247 150.384 154.195 150.229 154.299ZM151.708 153.442C151.62 153.493 151.545 153.564 151.491 153.65C151.437 153.736 151.404 153.834 151.397 153.935C151.397 154.117 151.526 154.169 151.708 153.935C151.8 153.889 151.877 153.818 151.932 153.732C151.986 153.645 152.017 153.545 152.02 153.442C152.123 153.39 151.89 153.338 151.708 153.442ZM153.188 152.586C153.099 152.636 153.025 152.707 152.971 152.793C152.916 152.879 152.884 152.977 152.876 153.079C152.876 153.26 153.006 153.312 153.188 153.079C153.276 153.028 153.35 152.957 153.405 152.871C153.459 152.785 153.491 152.687 153.499 152.586C153.499 152.534 153.369 152.482 153.188 152.586ZM154.667 151.729C154.582 151.783 154.509 151.855 154.455 151.94C154.402 152.026 154.367 152.122 154.356 152.222C154.356 152.404 154.511 152.456 154.667 152.352C154.759 152.303 154.837 152.232 154.896 152.147C154.955 152.061 154.992 151.962 155.005 151.859C155.005 151.677 154.849 151.625 154.719 151.729H154.667ZM156.173 150.872C156.081 150.922 156.003 150.992 155.944 151.078C155.885 151.164 155.848 151.262 155.835 151.366C155.835 151.547 155.991 151.599 156.173 151.495C156.258 151.442 156.331 151.37 156.385 151.284C156.438 151.199 156.473 151.102 156.484 151.002C156.484 150.82 156.329 150.769 156.173 150.872ZM157.652 150.016C157.559 150.063 157.48 150.133 157.421 150.219C157.362 150.305 157.325 150.405 157.315 150.509C157.315 150.691 157.445 150.743 157.626 150.509C157.715 150.458 157.789 150.387 157.843 150.301C157.898 150.215 157.93 150.117 157.938 150.016C157.964 149.964 157.834 149.912 157.652 150.016ZM159.132 149.159C159.044 149.21 158.969 149.281 158.915 149.367C158.861 149.453 158.828 149.551 158.82 149.652C158.82 149.834 158.95 149.886 159.132 149.652C159.22 149.602 159.295 149.53 159.349 149.445C159.403 149.359 159.436 149.261 159.443 149.159C159.443 149.107 159.314 149.055 159.132 149.159ZM160.611 148.303C160.525 148.355 160.451 148.427 160.397 148.512C160.343 148.598 160.31 148.695 160.3 148.796C160.3 148.978 160.456 149.029 160.611 148.796C160.703 148.747 160.782 148.676 160.84 148.59C160.899 148.505 160.936 148.406 160.949 148.303C160.949 148.251 160.793 148.199 160.611 148.303ZM162.117 147.42C162.025 147.475 161.946 147.55 161.888 147.64C161.829 147.73 161.792 147.833 161.78 147.939C161.78 148.121 161.935 148.173 162.117 148.069C162.2 148.013 162.271 147.94 162.324 147.855C162.378 147.77 162.413 147.675 162.428 147.576C162.506 147.394 162.273 147.342 162.117 147.42ZM163.597 146.564C163.506 146.618 163.431 146.694 163.377 146.785C163.322 146.875 163.291 146.977 163.285 147.083C163.285 147.264 163.415 147.316 163.597 147.083C163.683 147.03 163.757 146.959 163.811 146.873C163.865 146.787 163.898 146.69 163.908 146.589C163.908 146.538 163.778 146.486 163.597 146.564ZM165.076 145.707C164.986 145.762 164.91 145.837 164.856 145.928C164.802 146.018 164.77 146.121 164.765 146.226C164.765 146.408 164.894 146.46 165.076 146.226C165.163 146.174 165.236 146.102 165.29 146.016C165.344 145.931 165.378 145.834 165.388 145.733C165.388 145.681 165.258 145.603 165.102 145.707H165.076ZM166.556 144.85C166.469 144.909 166.397 144.986 166.343 145.076C166.29 145.166 166.256 145.266 166.244 145.369C166.244 145.525 166.4 145.603 166.556 145.369C166.645 145.317 166.721 145.246 166.78 145.161C166.838 145.075 166.877 144.978 166.893 144.876C166.893 144.824 166.737 144.747 166.556 144.85ZM168.061 143.994C167.969 144.049 167.89 144.124 167.832 144.214C167.773 144.304 167.736 144.406 167.724 144.513C167.724 144.669 167.879 144.747 168.061 144.643C168.147 144.584 168.22 144.507 168.274 144.417C168.327 144.328 168.361 144.227 168.373 144.124C168.373 143.968 168.217 143.89 168.061 143.994ZM169.541 143.137C169.45 143.192 169.375 143.268 169.321 143.358C169.266 143.449 169.235 143.551 169.229 143.656C169.229 143.812 169.229 143.89 169.541 143.656C169.631 143.602 169.706 143.526 169.761 143.435C169.815 143.345 169.846 143.242 169.852 143.137C169.852 143.111 169.722 143.033 169.541 143.137Z",
    fill: "#A3ACAF"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M210.914 109.73L196.43 118.115V110.457L210.914 102.073V109.73Z",
    fill: "#4C5053"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M199.83 109.808V111.859L197.234 113.39V111.34L197.779 111.028V110.665L198.221 110.405V110.146L198.844 109.756V110.042L199.285 109.782V110.12L199.83 109.808ZM199.83 114.818V112.767L197.234 114.299V116.349L197.779 116.012V116.375L198.221 116.116V116.401L198.896 116.012V115.726L199.337 115.493V115.129L199.83 114.818ZM203.256 107.836V109.86L200.661 111.392V109.341L201.18 108.978V108.64L201.621 108.381V108.095L202.296 107.706V107.991L202.711 107.732V108.095L203.256 107.836ZM203.256 112.819V110.795L200.661 112.3V114.351L201.18 114.169V114.507L201.621 114.273V114.532L202.296 114.143V113.884L202.711 113.624V113.287L203.256 112.819ZM206.631 105.837V107.887L204.035 109.419V107.368L204.606 107.031V106.693L205.022 106.434V106.174L205.696 105.785V106.044L206.138 105.811V106.148L206.631 105.837ZM206.631 110.847V108.796L204.035 110.327V112.378L204.606 112.041V112.404L205.022 112.144V112.43L205.696 112.041V111.755L206.138 111.521V111.158L206.631 110.847ZM210.161 103.786V105.837L207.565 107.368V105.318L208.11 105.006V104.643L208.552 104.409V104.124L209.227 103.786V104.072L209.642 103.812V104.176L210.161 103.786ZM210.161 108.796V106.745L207.565 108.277V110.327L208.11 110.016V110.353L208.552 110.12V110.379L209.227 109.99V109.73L209.642 109.471V109.107L210.161 108.796Z",
    fill: "#080709"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M199.832 113.754L199.105 113.338V113.858L199.832 114.247V113.754Z",
    fill: "url(#paint0_linear_879_24545)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M203.256 109.497V109.004L202.555 108.588V109.082L203.256 109.497Z",
    fill: "url(#paint1_linear_879_24545)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M199.832 111.495V111.002L199.105 110.587V111.08L199.832 111.495Z",
    fill: "url(#paint2_linear_879_24545)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M206.711 107.524V107.031L205.984 106.616V107.109L206.711 107.524Z",
    fill: "url(#paint3_linear_879_24545)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M203.256 111.755L202.555 111.366V111.859L203.256 112.274V111.755Z",
    fill: "url(#paint4_linear_879_24545)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M210.161 107.965L209.305 107.446V107.965L210.161 108.458V107.965Z",
    fill: "url(#paint5_linear_879_24545)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M209.305 104.695V105.188L210.161 105.681V105.188L209.305 104.695Z",
    fill: "url(#paint6_linear_879_24545)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M206.711 109.808L205.984 109.367V109.86L206.711 110.301V109.808Z",
    fill: "url(#paint7_linear_879_24545)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M210.914 119.88L196.43 128.264V120.606L210.914 112.222V119.88Z",
    fill: "#4C5053"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M199.83 119.958V121.956L197.234 123.462V121.437L197.779 121.1V120.762L198.221 120.503V120.243L198.896 119.854V120.113L199.337 119.88V120.217L199.83 119.958ZM199.83 124.967V122.917L197.234 124.448V126.473L197.779 126.161V126.525L198.221 126.265V126.551L198.896 126.161V125.876L199.337 125.616V125.279L199.83 124.967ZM203.256 117.959V120.009L200.661 121.541V119.49L201.206 119.179V118.815L201.647 118.582V118.296L202.322 117.907V118.192L202.737 117.933V118.296L203.256 117.959ZM203.256 122.969V120.918L200.661 122.449V124.552L201.206 124.24V124.552L201.647 124.292V124.552L202.322 124.163V123.903L202.737 123.643V123.28L203.256 122.969ZM206.631 115.986V118.037L204.035 119.542V117.518L204.606 117.18V116.765L205.022 116.505V116.246L205.696 115.856V116.116L206.138 115.882V116.22L206.631 115.986ZM206.631 120.996V118.945L204.035 120.477V122.501L204.606 122.19V122.553L205.022 122.294V122.553L205.696 122.19V121.956L206.138 121.697V121.359L206.631 120.996ZM210.083 113.987V116.038L207.487 117.569V115.519L208.033 115.207V114.844L208.474 114.61V114.325L209.149 113.935V114.169L209.564 113.909V114.273L210.083 113.987ZM210.083 118.997V116.946L207.487 118.478V120.529L208.033 120.191V120.555L208.474 120.295V120.58L209.149 120.191V119.906L209.564 119.672V119.36L210.083 118.997Z",
    fill: "#080709"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M199.832 123.903L199.105 123.488V123.981L199.832 124.396V123.903Z",
    fill: "url(#paint8_linear_879_24545)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M203.256 119.646V119.153L202.555 118.737V119.231L203.256 119.646Z",
    fill: "url(#paint9_linear_879_24545)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M199.832 121.645V121.126L199.105 120.736V121.229L199.832 121.645Z",
    fill: "url(#paint10_linear_879_24545)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M206.711 117.673V117.18L205.984 116.765V117.258L206.711 117.673Z",
    fill: "url(#paint11_linear_879_24545)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M203.256 121.904L202.555 121.489V121.982L203.256 122.397V121.904Z",
    fill: "url(#paint12_linear_879_24545)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M210.161 118.089L209.305 117.595V118.089L210.161 118.582V118.089Z",
    fill: "url(#paint13_linear_879_24545)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M209.305 114.844V115.337L210.161 115.83V115.337L209.305 114.844Z",
    fill: "url(#paint14_linear_879_24545)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M206.711 119.931L205.984 119.516V120.009L206.711 120.425V119.931Z",
    fill: "url(#paint15_linear_879_24545)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M194.222 119.386L179.738 127.771V120.113L194.222 111.755V119.386Z",
    fill: "#4C5053"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M183.271 119.36V121.411L180.676 122.943V120.892L181.221 120.58V120.217L181.662 119.983V119.698L182.337 119.309V119.594L182.778 119.334V119.698L183.271 119.36ZM183.271 124.552V122.501L180.676 124.033V126.083L181.221 125.772V126.109L181.662 125.85V126.135L182.337 125.746V125.46L182.778 125.227V124.863L183.271 124.552ZM186.698 117.569V119.62L184.102 121.126V119.075L184.647 118.763V118.426L185.088 118.166V117.907L185.763 117.517V117.777L186.179 117.543V117.881L186.698 117.569ZM186.698 122.579V120.529L184.102 122.034V124.085L184.647 123.773V124.111L185.088 123.877V124.137L185.763 123.747V123.488L186.179 123.228V122.891L186.698 122.579ZM190.15 115.571V117.621L187.554 119.153V117.024L187.944 116.765V116.401L188.359 116.168V115.882L189.034 115.493V115.778L189.475 115.519V115.856L190.15 115.571ZM190.15 120.58V118.53L187.554 120.061V121.956L188.125 121.619V121.956L188.541 121.697V121.982L189.216 121.593V121.307L189.657 121.074V120.71L190.15 120.58ZM193.602 113.598V115.623L191.007 117.154V115.103L191.552 114.792V114.455L191.993 114.195V113.909L192.668 113.52V113.806L193.083 113.546V113.909L193.602 113.598ZM193.602 118.582V116.557L191.007 118.063V120.113L191.552 119.802V120.139L191.993 119.906V120.165L192.668 119.776V119.36L193.083 119.101V118.841L193.602 118.582Z",
    fill: "#080709"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M183.141 123.41L182.414 123.021V123.514L183.141 123.903V123.41Z",
    fill: "url(#paint16_linear_879_24545)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M186.594 119.153V118.66L185.867 118.244V118.738L186.594 119.153Z",
    fill: "url(#paint17_linear_879_24545)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M183.141 121.151V120.658L182.414 120.243V120.736L183.141 121.151Z",
    fill: "url(#paint18_linear_879_24545)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M190.02 117.18V116.687L189.293 116.272V116.765L190.02 117.18Z",
    fill: "url(#paint19_linear_879_24545)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M186.594 121.437L185.867 121.022V121.515L186.594 121.93V121.437Z",
    fill: "url(#paint20_linear_879_24545)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M193.472 117.621L192.59 117.128V117.621L193.472 118.114V117.621Z",
    fill: "url(#paint21_linear_879_24545)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M192.59 114.351V114.844L193.472 115.337V114.844L192.59 114.351Z",
    fill: "url(#paint22_linear_879_24545)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M190.02 119.464L189.293 119.049V119.542L190.02 119.958V119.464Z",
    fill: "url(#paint23_linear_879_24545)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M194.222 129.536L179.738 137.92V130.263L194.222 121.878V129.536Z",
    fill: "#4C5053"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M183.271 129.743V131.794L180.676 133.325V131.275L181.221 130.963V130.6L181.662 130.34V130.081L182.337 129.691V129.743L182.778 129.484V129.821L183.271 129.743ZM183.271 134.753V132.702L180.676 134.234V136.284L181.221 135.947V136.31L181.662 136.051V136.336L182.337 135.947V135.661L182.778 135.428V134.935L183.271 134.753ZM186.698 127.771V129.743L184.102 131.275V129.224L184.647 128.913V128.575L185.088 128.316V128.03L185.763 127.641V127.926L186.179 127.667V128.03L186.698 127.771ZM186.698 132.754V130.73L184.102 132.235V134.286L184.647 133.974V134.312L185.088 134.078V134.338L185.763 133.948V133.689L186.179 133.429V133.092L186.698 132.754ZM190.15 125.772V127.822L187.554 129.328V127.148L188.125 126.81V126.473L188.541 126.213V125.954L189.216 125.564V125.824L189.657 125.59V125.928L190.15 125.772ZM190.15 130.782V128.731L187.554 130.262V132.287L188.125 131.976V132.339L188.541 132.079V132.339L189.216 131.95V131.56L189.657 131.327V130.963L190.15 130.782ZM193.602 123.773V125.824L191.007 127.355V125.305L191.552 124.993V124.552L191.993 124.318V124.033L192.668 123.643V123.929L193.083 123.669V124.033L193.602 123.773ZM193.602 128.783V126.732L191.007 128.264V130.314L191.552 130.003V130.34L191.993 130.107V130.366L192.668 129.977V129.717L193.083 129.458V128.965L193.602 128.783Z",
    fill: "#080709"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M183.141 133.559L182.414 133.144V133.663L183.141 134.052V133.559Z",
    fill: "url(#paint24_linear_879_24545)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M186.594 129.302V128.809L185.867 128.394V128.887L186.594 129.302Z",
    fill: "url(#paint25_linear_879_24545)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M183.141 131.301V130.808L182.414 130.392V130.886L183.141 131.301Z",
    fill: "url(#paint26_linear_879_24545)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M190.02 127.329V126.836L189.293 126.421V126.914L190.02 127.329Z",
    fill: "url(#paint27_linear_879_24545)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M186.594 131.56L185.867 131.171V131.664L186.594 132.053V131.56Z",
    fill: "url(#paint28_linear_879_24545)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M193.472 127.745L192.59 127.251V127.745L193.472 128.264V127.745Z",
    fill: "url(#paint29_linear_879_24545)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M192.59 124.5V124.993L193.472 125.486V124.993L192.59 124.5Z",
    fill: "url(#paint30_linear_879_24545)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M190.02 129.614L189.293 129.172V129.692L190.02 130.107V129.614Z",
    fill: "url(#paint31_linear_879_24545)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M208.164 103.449V102.93L209.176 102.359V102.852L208.164 103.449Z",
    fill: "#080709"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M209.073 102.826L208.242 103.293V102.982L209.073 102.488V102.826Z",
    fill: "#72C93F"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M204.789 105.37V104.876L205.801 104.279V104.798L204.789 105.37Z",
    fill: "#080709"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M205.699 104.747L204.895 105.24V104.902L205.699 104.435V104.747Z",
    fill: "#72C93F"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M201.363 107.368V106.849L202.376 106.278V106.771L201.363 107.368Z",
    fill: "#080709"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M202.272 106.745L201.441 107.213V106.901L202.272 106.408V106.745Z",
    fill: "#72C93F"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M197.988 109.315V108.822L198.975 108.225V108.744L197.988 109.315Z",
    fill: "#080709"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M198.897 108.692L198.066 109.185V108.848L198.897 108.381V108.692Z",
    fill: "#72C93F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M208.164 112.067V111.573L209.176 110.976V111.496L208.164 112.067Z",
    fill: "#080709"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M209.073 111.444L208.242 111.937V111.599L209.073 111.132V111.444Z",
    fill: "#72C93F"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M204.789 114.013V113.494L205.801 112.923V113.416L204.789 114.013Z",
    fill: "#080709"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M205.699 113.39L204.895 113.858V113.546L205.699 113.053V113.39Z",
    fill: "#72C93F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M201.363 115.986V115.493L202.376 114.896V115.415L201.363 115.986Z",
    fill: "#080709"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M202.272 115.363L201.441 115.856V115.519L202.272 115.052V115.363Z",
    fill: "#72C93F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M197.988 117.959V117.44L198.975 116.869V117.362L197.988 117.959Z",
    fill: "#080709"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M198.897 117.336L198.066 117.803V117.492L198.897 116.998V117.336Z",
    fill: "#72C93F"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M208.164 113.572V113.079L209.176 112.508V113.001L208.164 113.572Z",
    fill: "#080709"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M209.073 112.975L208.242 113.442V113.105L209.073 112.638V112.975Z",
    fill: "#72C93F"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M204.789 115.519V115L205.801 114.429V114.948L204.789 115.519Z",
    fill: "#080709"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M205.699 114.896L204.895 115.363V115.052L205.699 114.584V114.896Z",
    fill: "#72C93F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M201.363 117.492V116.998L202.376 116.401V116.921L201.363 117.492Z",
    fill: "#080709"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M202.272 116.895L201.441 117.362V117.024L202.272 116.557V116.895Z",
    fill: "#72C93F"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M197.988 119.464V118.945L198.975 118.374V118.893L197.988 119.464Z",
    fill: "#080709"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M198.897 118.841L198.066 119.309V118.997L198.897 118.53V118.841Z",
    fill: "#72C93F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M208.164 122.216V121.723L209.176 121.126V121.645L208.164 122.216Z",
    fill: "#080709"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M209.073 121.593L208.242 122.086V121.749L209.073 121.281V121.593Z",
    fill: "#72C93F"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M204.789 124.163V123.643L205.801 123.072V123.566L204.789 124.163Z",
    fill: "#080709"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M205.699 123.54L204.895 124.007V123.695L205.699 123.202V123.54Z",
    fill: "#72C93F"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M201.363 126.135V125.616L202.376 125.045V125.564L201.363 126.135Z",
    fill: "#080709"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M202.272 125.512L201.441 125.98V125.668L202.272 125.201V125.512Z",
    fill: "#72C93F"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M197.988 128.108V127.589L198.975 127.018V127.511L197.988 128.108Z",
    fill: "#080709"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M198.897 127.485L198.066 127.952V127.615L198.897 127.148V127.485Z",
    fill: "#72C93F"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M191.578 113.027V112.508L192.59 111.937V112.43L191.578 113.027Z",
    fill: "#080709"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M192.484 112.404L191.68 112.871V112.56L192.484 112.066V112.404Z",
    fill: "#72C93F"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M188.227 114.948V114.455L189.213 113.883V114.377L188.227 114.948Z",
    fill: "#080709"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M189.135 114.351L188.305 114.818V114.48L189.135 114.013V114.351Z",
    fill: "#72C93F"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M184.777 116.946V116.427L185.79 115.856V116.349L184.777 116.946Z",
    fill: "#080709"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M185.684 116.323L184.879 116.791V116.479L185.684 115.986V116.323Z",
    fill: "#72C93F"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M181.402 118.893V118.4L182.415 117.829V118.322L181.402 118.893Z",
    fill: "#080709"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M182.311 118.296L181.48 118.763V118.426L182.311 117.959V118.296Z",
    fill: "#72C93F"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M191.578 121.645V121.152L192.59 120.555V121.074L191.578 121.645Z",
    fill: "#080709"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M192.484 121.048L191.68 121.515V121.177L192.484 120.71V121.048Z",
    fill: "#72C93F"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M188.227 123.591V123.072L189.213 122.501V123.02L188.227 123.591Z",
    fill: "#080709"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M189.135 122.968L188.305 123.436V123.124L189.135 122.657V122.968Z",
    fill: "#72C93F"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M184.777 125.564V125.071L185.79 124.5V124.993L184.777 125.564Z",
    fill: "#080709"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M185.684 124.967L184.879 125.435V125.097L185.684 124.63V124.967Z",
    fill: "#72C93F"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M181.402 127.537V127.018L182.415 126.447V126.966L181.402 127.537Z",
    fill: "#080709"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M182.311 126.914L181.48 127.381V127.07L182.311 126.603V126.914Z",
    fill: "#72C93F"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M191.578 123.176V122.657L192.59 122.086V122.579L191.578 123.176Z",
    fill: "#080709"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M192.484 122.553L191.68 123.02V122.709L192.484 122.216V122.553Z",
    fill: "#72C93F"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M188.227 125.097V124.604L189.213 124.007V124.526L188.227 125.097Z",
    fill: "#080709"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M189.135 124.474L188.305 124.967V124.63L189.135 124.163V124.474Z",
    fill: "#72C93F"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M184.777 127.096V126.577L185.79 126.006V126.499L184.777 127.096Z",
    fill: "#080709"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M185.684 126.473L184.879 126.94V126.628L185.684 126.135V126.473Z",
    fill: "#72C93F"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M181.402 129.043V128.549L182.415 127.952V128.472L181.402 129.043Z",
    fill: "#080709"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M182.311 128.42L181.48 128.913V128.575L182.311 128.108V128.42Z",
    fill: "#72C93F"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M191.578 131.794V131.301L192.59 130.704V131.223L191.578 131.794Z",
    fill: "#080709"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M192.484 131.171L191.68 131.664V131.327L192.484 130.86V131.171Z",
    fill: "#72C93F"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M188.227 133.741V133.222L189.213 132.651V133.144L188.227 133.741Z",
    fill: "#080709"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M189.135 133.118L188.305 133.585V133.273L189.135 132.78V133.118Z",
    fill: "#72C93F"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M184.777 135.713V135.22L185.79 134.623V135.142L184.777 135.713Z",
    fill: "#080709"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M185.684 135.091L184.879 135.584V135.246L185.684 134.779V135.091Z",
    fill: "#72C93F"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M181.402 137.686V137.167L182.415 136.596V137.089L181.402 137.686Z",
    fill: "#080709"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M182.311 137.063L181.48 137.531V137.219L182.311 136.726V137.063Z",
    fill: "#72C93F"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M137.846 152.43L123.336 160.814V153.157L137.846 144.772V152.43Z",
    fill: "#4C5053"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M126.736 152.508V154.559L124.141 156.064V154.039L124.686 153.702V153.364L125.101 153.105V152.845L125.776 152.456V152.716L126.217 152.482V152.819L126.736 152.508ZM126.736 157.518V155.467L124.141 156.998V159.023L124.686 158.712V159.075L125.101 158.815V159.101L125.776 158.712V158.426L126.165 158.296V157.959L126.736 157.518ZM130.189 150.509V152.56L127.593 154.091V152.041L128.138 151.729V151.366L128.579 151.132V150.847L129.254 150.457V150.743L129.695 150.483V150.847L130.189 150.509ZM130.189 155.519V153.468L127.593 155V157.05L128.138 156.739V157.076L128.579 156.817V157.102L129.254 156.713V156.453L129.695 156.194V155.83L130.189 155.519ZM133.615 148.536V150.509L131.019 152.015V149.99L131.564 149.653V149.315L132.006 149.056V148.796L132.681 148.407V148.666L133.096 148.433V148.77L133.615 148.536ZM133.615 153.546V151.496L131.019 153.027V155.052L131.564 154.74V155.104L132.006 154.844V155.104L132.681 154.74V154.455L133.096 154.195V153.858L133.615 153.546ZM137.067 146.538V148.588L134.472 150.12V148.069L135.043 147.758V147.394L135.458 147.161V146.875L136.133 146.486V146.771L136.574 146.512V146.875L137.067 146.538ZM137.067 151.547V149.497L134.472 151.028V153.105L135.043 152.767V153.105L135.458 152.845V153.105L136.133 152.716V152.43L136.574 152.196V151.833L137.067 151.547Z",
    fill: "#080709"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M126.736 156.453L126.035 156.038V156.531L126.736 156.947V156.453Z",
    fill: "url(#paint32_linear_879_24545)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M130.188 152.196V151.703L129.461 151.288V151.781L130.188 152.196Z",
    fill: "url(#paint33_linear_879_24545)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M126.736 154.195V153.702L126.035 153.287V153.78L126.736 154.195Z",
    fill: "url(#paint34_linear_879_24545)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M133.639 150.223V149.73L132.887 149.315V149.808L133.639 150.223Z",
    fill: "url(#paint35_linear_879_24545)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M130.188 154.455L129.461 154.039V154.532L130.188 154.948V154.455Z",
    fill: "url(#paint36_linear_879_24545)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M137.068 150.639L136.211 150.146V150.639L137.068 151.132V150.639Z",
    fill: "url(#paint37_linear_879_24545)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M136.211 147.394V147.887L137.068 148.381V147.887L136.211 147.394Z",
    fill: "url(#paint38_linear_879_24545)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M133.639 152.482L132.887 152.066V152.56L133.639 152.975V152.482Z",
    fill: "url(#paint39_linear_879_24545)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M137.846 162.579L123.336 170.937V163.28L137.846 154.922V162.579Z",
    fill: "#4C5053"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M126.736 162.657V164.708L124.141 166.213V164.163L124.686 163.851V163.488L125.101 163.228V162.969L125.776 162.579V162.839L126.217 162.605V162.943L126.736 162.657ZM126.736 167.667V165.616L124.141 167.122V169.172L124.686 168.861V169.198L125.101 168.965V169.224L125.776 168.835V168.679L126.217 168.42V168.082L126.736 167.667ZM130.189 160.658V162.709L127.593 164.241V162.19L128.138 161.878V161.515L128.579 161.281V160.892L129.254 160.503V160.892L129.695 160.633V160.892L130.189 160.658ZM130.189 165.668V163.618L127.593 165.149V167.2L128.138 166.862V167.226L128.579 166.966V167.252L129.254 166.862V166.577L129.695 166.343V166.084L130.189 165.668ZM133.615 158.686V160.71L131.019 162.242V160.191L131.564 159.88V159.542L132.006 159.283V158.997L132.681 158.608V158.893L133.096 158.634V158.997L133.615 158.686ZM133.615 163.669V161.645L131.019 163.15V165.201L131.564 164.889V165.227L132.006 164.993V165.253L132.681 164.864V164.604L133.096 164.344V164.007L133.615 163.669ZM137.067 156.687V158.738L134.472 160.269V158.296L135.043 157.985V157.621L135.458 157.362V157.102L136.133 156.713V156.973L136.574 156.739V157.076L137.067 156.687ZM137.067 161.697V159.646L134.472 161.178V163.228L135.043 162.891V163.254L135.458 162.995V163.28L136.133 162.891V162.605L136.574 162.372V162.008L137.067 161.697Z",
    fill: "#080709"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M126.736 166.603L126.035 166.187V166.68L126.736 167.096V166.603Z",
    fill: "url(#paint40_linear_879_24545)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M130.188 162.346V161.852L129.461 161.437V161.93L130.188 162.346Z",
    fill: "url(#paint41_linear_879_24545)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M126.736 164.318V163.825L126.035 163.436V163.929L126.736 164.318Z",
    fill: "url(#paint42_linear_879_24545)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M133.639 160.373V159.88L132.887 159.464V159.958L133.639 160.373Z",
    fill: "url(#paint43_linear_879_24545)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M130.188 164.604L129.461 164.188V164.682L130.188 165.097V164.604Z",
    fill: "url(#paint44_linear_879_24545)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M137.068 160.788L136.211 160.295V160.788L137.068 161.281V160.788Z",
    fill: "url(#paint45_linear_879_24545)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M136.211 157.518V158.037L137.068 158.53V158.037L136.211 157.518Z",
    fill: "url(#paint46_linear_879_24545)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M133.639 162.631L132.887 162.216V162.709L133.639 163.124V162.631Z",
    fill: "url(#paint47_linear_879_24545)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M121.129 162.086L106.645 170.47V162.813L121.129 154.429V162.086Z",
    fill: "#4C5053"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M110.045 162.164V164.214L107.449 165.746V163.695L107.994 163.488V163.124L108.41 162.865V162.605L109.085 162.216V162.501L109.526 162.242V162.579L110.045 162.164ZM110.045 167.173V165.123L107.449 166.654V168.679L107.994 168.342V168.679L108.41 168.419V168.679L109.085 168.29V168.004L109.526 167.771V167.407L110.045 167.173ZM113.497 160.191V162.216L110.902 163.747V161.697L111.447 161.385V161.048L111.888 160.788V160.502L112.563 160.113V160.399L113.004 160.139V160.502L113.497 160.191ZM113.497 165.175V163.15L110.902 164.656V166.706L111.447 166.395V166.732L111.888 166.499V166.758L112.563 166.369V166.083L113.004 165.824V165.486L113.497 165.175ZM116.924 158.296V160.347L114.328 161.852V159.828L114.873 159.49V159.153L115.314 158.893V158.634L115.989 158.244V158.296L116.404 158.063V158.4L116.924 158.296ZM116.924 163.306V161.151L114.328 162.683V164.708L114.873 164.396V164.759L115.314 164.5V164.785L115.989 164.396V164.111L116.404 163.877V163.488L116.924 163.306ZM120.376 156.297V158.296L117.78 159.828V157.777L118.351 157.466V157.102L118.767 156.868V156.583L119.441 156.194V156.479L119.883 156.22V156.583L120.376 156.297ZM120.376 161.307V159.257L117.78 160.788V162.839L118.351 162.527V162.865L118.767 162.631V162.891L119.441 162.501V162.242L119.883 161.982V161.619L120.376 161.307Z",
    fill: "#080709"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M110.045 166.109L109.344 165.694V166.213L110.045 166.603V166.109Z",
    fill: "url(#paint48_linear_879_24545)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M113.496 161.852V161.359L112.77 160.944V161.437L113.496 161.852Z",
    fill: "url(#paint49_linear_879_24545)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M110.045 163.851V163.358L109.344 162.943V163.436L110.045 163.851Z",
    fill: "url(#paint50_linear_879_24545)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M116.948 159.88V159.387L116.195 158.971V159.464L116.948 159.88Z",
    fill: "url(#paint51_linear_879_24545)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M113.496 164.111L112.77 163.721V164.214L113.496 164.63V164.111Z",
    fill: "url(#paint52_linear_879_24545)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M120.376 160.295L119.52 159.802V160.295L120.376 160.814V160.295Z",
    fill: "url(#paint53_linear_879_24545)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M119.52 157.05V157.543L120.376 158.037V157.543L119.52 157.05Z",
    fill: "url(#paint54_linear_879_24545)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M116.948 162.138L116.195 161.723V162.242L116.948 162.657V162.138Z",
    fill: "url(#paint55_linear_879_24545)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M121.129 172.235L106.645 180.593V172.962L121.129 164.578V172.235Z",
    fill: "#4C5053"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M110.045 172.313V174.364L107.449 175.869V173.871L107.994 173.533V173.196L108.41 172.936V172.676L109.085 172.287V172.547L109.526 172.313V172.651L110.045 172.313ZM110.045 177.323V175.272L107.449 176.804V178.828L107.994 178.517V178.88L108.41 178.621V178.906L109.085 178.517V178.231L109.526 177.972V177.634L110.045 177.323ZM113.497 170.314V172.365L110.902 173.896V171.846L111.447 171.534V171.275L111.888 171.041V170.756L112.563 170.366V170.652L113.004 170.392V170.756L113.497 170.314ZM113.497 175.324V173.273L110.902 174.805V176.856L111.447 176.544V176.882L111.888 176.622V176.907L112.563 176.518V176.259L113.004 175.999V175.636L113.497 175.324ZM116.924 168.342V170.392L114.328 171.898V169.873L114.873 169.536V169.198L115.314 168.939V168.679L115.989 168.29V168.679L116.404 168.445V168.679L116.924 168.342ZM116.924 173.351V171.275L114.328 172.806V174.831L114.873 174.519V174.883L115.314 174.623V174.883L115.989 174.493V174.234L116.404 173.974V173.637L116.924 173.351ZM120.376 166.343V168.394L117.78 169.925V167.874L118.351 167.563V167.2L118.767 166.966V166.68L119.441 166.291V166.577L119.883 166.317V166.68L120.376 166.343ZM120.376 171.353V169.302L117.78 170.834V172.884L118.351 172.547V172.91L118.767 172.651V172.936L119.441 172.547V172.261L119.883 172.028V171.664L120.376 171.353Z",
    fill: "#080709"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M110.045 176.259L109.344 175.843V176.336L110.045 176.752V176.259Z",
    fill: "url(#paint56_linear_879_24545)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M113.496 172.002V171.508L112.77 171.093V171.586L113.496 172.002Z",
    fill: "url(#paint57_linear_879_24545)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M110.045 174V173.481L109.344 173.092V173.585L110.045 174Z",
    fill: "url(#paint58_linear_879_24545)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M116.948 170.029V169.536L116.195 169.12V169.614L116.948 170.029Z",
    fill: "url(#paint59_linear_879_24545)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M113.496 174.26L112.77 173.844V174.338L113.496 174.753V174.26Z",
    fill: "url(#paint60_linear_879_24545)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M120.376 170.444L119.52 169.951V170.444L120.376 170.937V170.444Z",
    fill: "url(#paint61_linear_879_24545)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M119.52 167.2V167.693L120.376 168.186V167.693L119.52 167.2Z",
    fill: "url(#paint62_linear_879_24545)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M116.948 172.287L116.195 171.872V172.365L116.948 172.78V172.287Z",
    fill: "url(#paint63_linear_879_24545)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M135.066 146.122V145.629L136.079 145.058V145.551L135.066 146.122Z",
    fill: "#080709"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M135.977 145.525L135.172 145.993V145.655L135.977 145.188V145.525Z",
    fill: "#72C93F"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M131.719 148.069V147.576L132.705 146.979V147.498L131.719 148.069Z",
    fill: "#080709"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M132.628 147.446L131.797 147.939V147.602L132.628 147.135V147.446Z",
    fill: "#72C93F"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M128.266 150.042V149.549L129.278 148.978V149.471L128.266 150.042Z",
    fill: "#080709"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M129.176 149.445L128.371 149.912V149.575L129.176 149.107V149.445Z",
    fill: "#72C93F"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M124.895 152.015V151.495L125.907 150.924V151.443L124.895 152.015Z",
    fill: "#080709"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M125.801 151.392L124.996 151.859V151.547L125.801 151.08V151.392Z",
    fill: "#72C93F"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M135.066 154.766V154.273L136.079 153.676V154.195L135.066 154.766Z",
    fill: "#080709"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M135.977 154.143L135.172 154.636V154.299L135.977 153.832V154.143Z",
    fill: "#72C93F"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M131.719 156.713V156.194L132.705 155.623V156.116L131.719 156.713Z",
    fill: "#080709"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M132.628 156.09L131.797 156.557V156.246L132.628 155.752V156.09Z",
    fill: "#72C93F"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M128.266 158.686V158.167L129.278 157.595V158.115L128.266 158.686Z",
    fill: "#080709"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M129.176 158.063L128.371 158.53V158.218L129.176 157.751V158.063Z",
    fill: "#72C93F"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M124.895 160.658V160.139L125.907 159.568V160.061L124.895 160.658Z",
    fill: "#080709"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M125.801 160.035L124.996 160.503V160.191L125.801 159.698V160.035Z",
    fill: "#72C93F"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M135.066 156.272V155.778L136.079 155.181V155.701L135.066 156.272Z",
    fill: "#080709"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M135.977 155.649L135.172 156.142V155.804L135.977 155.337V155.649Z",
    fill: "#72C93F"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M131.719 158.218V157.699L132.705 157.128V157.621L131.719 158.218Z",
    fill: "#080709"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M132.628 157.596L131.797 158.063V157.751L132.628 157.258V157.596Z",
    fill: "#72C93F"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M128.266 160.191V159.698L129.278 159.101V159.62L128.266 160.191Z",
    fill: "#080709"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M129.176 159.568L128.371 160.061V159.724L129.176 159.257V159.568Z",
    fill: "#72C93F"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M124.895 162.164V161.645L125.907 161.074V161.567L124.895 162.164Z",
    fill: "#080709"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M125.801 161.541L124.996 162.008V161.697L125.801 161.203V161.541Z",
    fill: "#72C93F"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M135.066 164.915V164.396L136.079 163.825V164.344L135.066 164.915Z",
    fill: "#080709"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M135.977 164.292L135.172 164.76V164.448L135.977 163.981V164.292Z",
    fill: "#72C93F"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M131.719 166.836V166.343L132.705 165.772V166.265L131.719 166.836Z",
    fill: "#080709"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M132.628 166.239L131.797 166.706V166.369L132.628 165.902V166.239Z",
    fill: "#72C93F"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M128.266 168.835V168.316L129.278 167.745V168.238L128.266 168.835Z",
    fill: "#080709"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M129.176 168.212L128.371 168.679V168.368L129.176 167.874V168.212Z",
    fill: "#72C93F"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M124.895 170.782V170.288L125.907 169.717V170.21L124.895 170.782Z",
    fill: "#080709"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M125.801 170.185L124.996 170.652V170.314L125.801 169.847V170.185Z",
    fill: "#72C93F"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M118.508 155.726V155.207L119.494 154.636V155.129L118.508 155.726Z",
    fill: "#080709"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M119.417 155.104L118.586 155.571V155.259L119.417 154.766V155.104Z",
    fill: "#72C93F"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M115.133 157.647V157.154L116.145 156.557V157.076L115.133 157.647Z",
    fill: "#080709"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M116.042 157.024L115.211 157.518V157.18L116.042 156.713V157.024Z",
    fill: "#72C93F"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M111.68 159.646V159.127L112.692 158.556V159.049L111.68 159.646Z",
    fill: "#080709"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M112.616 159.023L111.785 159.49V159.179L112.616 158.686V159.023Z",
    fill: "#72C93F"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M108.305 161.593V161.1L109.317 160.503V161.022L108.305 161.593Z",
    fill: "#080709"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M109.241 160.97L108.41 161.463V161.126L109.241 160.658V160.97Z",
    fill: "#72C93F"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M118.508 164.344V163.851L119.494 163.254V163.773L118.508 164.344Z",
    fill: "#080709"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M119.417 163.721L118.586 164.215V163.877L119.417 163.41V163.721Z",
    fill: "#72C93F"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M115.133 166.291V165.772L116.145 165.201V165.694L115.133 166.291Z",
    fill: "#080709"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M116.042 165.668L115.211 166.135V165.824L116.042 165.357V165.668Z",
    fill: "#72C93F"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M111.68 168.264V167.771L112.692 167.174V167.693L111.68 168.264Z",
    fill: "#080709"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M112.616 167.641L111.785 168.134V167.797L112.616 167.329V167.641Z",
    fill: "#72C93F"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M108.305 170.236V169.717L109.317 169.146V169.639L108.305 170.236Z",
    fill: "#080709"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M109.241 169.614L108.41 170.081V169.769L109.241 169.276V169.614Z",
    fill: "#72C93F"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M118.508 165.85V165.357L119.494 164.76V165.279L118.508 165.85Z",
    fill: "#080709"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M119.417 165.253L118.586 165.72V165.383L119.417 164.915V165.253Z",
    fill: "#72C93F"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M115.133 167.797V167.303L116.145 166.706V167.226L115.133 167.797Z",
    fill: "#080709"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M116.042 167.174L115.211 167.641V167.329L116.042 166.862V167.174Z",
    fill: "#72C93F"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M111.68 169.769V169.276L112.692 168.705V169.198L111.68 169.769Z",
    fill: "#080709"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M112.616 169.172L111.785 169.64V169.302L112.616 168.835V169.172Z",
    fill: "#72C93F"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M108.305 171.742V171.223L109.317 170.652V171.171L108.305 171.742Z",
    fill: "#080709"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M109.241 171.119L108.41 171.586V171.275L109.241 170.808V171.119Z",
    fill: "#72C93F"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M118.508 174.494V174L119.494 173.403V173.922L118.508 174.494Z",
    fill: "#080709"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M119.417 173.871L118.586 174.364V174.026L119.417 173.559V173.871Z",
    fill: "#72C93F"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M115.133 176.44V175.921L116.145 175.35V175.843L115.133 176.44Z",
    fill: "#080709"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M116.042 175.817L115.211 176.285V175.973L116.042 175.48V175.817Z",
    fill: "#72C93F"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M111.68 178.413V177.894L112.692 177.323V177.842L111.68 178.413Z",
    fill: "#080709"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M112.616 177.79L111.785 178.257V177.946L112.616 177.479V177.79Z",
    fill: "#72C93F"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M108.305 180.386V179.867L109.317 179.296V179.789L108.305 180.386Z",
    fill: "#080709"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M109.241 179.763L108.41 180.23V179.919L109.241 179.425V179.763Z",
    fill: "#72C93F"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M176.288 126.083C176.241 126.568 176.08 127.034 175.819 127.445C175.557 127.855 175.202 128.198 174.783 128.445C173.952 128.939 173.277 128.653 173.277 127.822C173.326 127.335 173.488 126.866 173.749 126.451C174.011 126.037 174.364 125.689 174.783 125.434C175.613 124.967 176.288 125.253 176.288 126.083Z",
    fill: "#A3ACAF"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M176.028 126.161C175.992 126.585 175.853 126.994 175.622 127.352C175.391 127.709 175.076 128.005 174.704 128.212C174.003 128.627 173.406 128.368 173.406 127.667C173.449 127.248 173.589 126.845 173.814 126.489C174.04 126.133 174.344 125.834 174.704 125.616C175.483 125.201 176.028 125.434 176.028 126.161Z",
    fill: "url(#paint64_linear_879_24545)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M176.288 136.518C176.239 137.005 176.078 137.475 175.816 137.889C175.555 138.304 175.201 138.652 174.783 138.906C173.952 139.373 173.277 139.088 173.277 138.257C173.324 137.773 173.485 137.306 173.747 136.896C174.009 136.485 174.364 136.142 174.783 135.895C175.613 135.402 176.288 135.687 176.288 136.518Z",
    fill: "#A3ACAF"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M176.028 136.622C175.988 137.042 175.847 137.445 175.616 137.798C175.386 138.151 175.073 138.442 174.704 138.647C174.003 139.062 173.406 138.828 173.406 138.102C173.453 137.684 173.595 137.282 173.819 136.927C174.044 136.572 174.347 136.272 174.704 136.051C175.483 135.636 176.028 135.895 176.028 136.622Z",
    fill: "url(#paint65_linear_879_24545)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9796 116.246C50.1207 116.286 50.2447 116.371 50.3331 116.488C50.4214 116.605 50.4692 116.748 50.4692 116.895C50.4692 117.041 50.4214 117.184 50.3331 117.301C50.2447 117.418 50.1207 117.503 49.9796 117.543C49.631 117.71 49.2497 117.796 48.8635 117.796C48.4773 117.796 48.096 117.71 47.7473 117.543C47.6063 117.503 47.4822 117.418 47.3939 117.301C47.3056 117.184 47.2578 117.041 47.2578 116.895C47.2578 116.748 47.3056 116.605 47.3939 116.488C47.4822 116.371 47.6063 116.286 47.7473 116.246C48.0919 116.066 48.4748 115.972 48.8635 115.972C49.2521 115.972 49.635 116.066 49.9796 116.246ZM132.627 67.2385C132.486 67.2788 132.362 67.3639 132.274 67.481C132.186 67.5981 132.138 67.7408 132.138 67.8874C132.138 68.0341 132.186 68.1768 132.274 68.2939C132.362 68.4109 132.486 68.4961 132.627 68.5364C132.972 68.7161 133.355 68.8099 133.743 68.8099C134.132 68.8099 134.515 68.7161 134.86 68.5364C134.989 68.4838 135.099 68.3939 135.177 68.2784C135.254 68.1628 135.296 68.0267 135.296 67.8874C135.296 67.7482 135.254 67.6121 135.177 67.4965C135.099 67.3809 134.989 67.2911 134.86 67.2385C134.515 67.0588 134.132 66.965 133.743 66.965C133.355 66.965 132.972 67.0588 132.627 67.2385ZM92.4196 141.969C92.2883 142.016 92.1746 142.102 92.0942 142.216C92.0138 142.33 91.9706 142.466 91.9706 142.605C91.9706 142.745 92.0138 142.881 92.0942 142.994C92.1746 143.108 92.2883 143.194 92.4196 143.241C92.7642 143.421 93.1471 143.515 93.5358 143.515C93.9244 143.515 94.3073 143.421 94.6519 143.241C94.7833 143.194 94.897 143.108 94.9774 142.994C95.0577 142.881 95.1009 142.745 95.1009 142.605C95.1009 142.466 95.0577 142.33 94.9774 142.216C94.897 142.102 94.7833 142.016 94.6519 141.969C94.3073 141.789 93.9244 141.696 93.5358 141.696C93.1471 141.696 92.7642 141.789 92.4196 141.969ZM177.144 92.9621C177.015 93.0147 176.905 93.1045 176.827 93.22C176.749 93.3356 176.708 93.4717 176.708 93.611C176.708 93.7502 176.749 93.8863 176.827 94.0019C176.905 94.1175 177.015 94.2073 177.144 94.2599C177.496 94.43 177.882 94.5184 178.273 94.5184C178.664 94.5184 179.05 94.43 179.402 94.2599C179.531 94.2073 179.641 94.1175 179.719 94.0019C179.797 93.8863 179.838 93.7502 179.838 93.611C179.838 93.4717 179.797 93.3356 179.719 93.22C179.641 93.1045 179.531 93.0147 179.402 92.9621C179.05 92.792 178.664 92.7036 178.273 92.7036C177.882 92.7036 177.496 92.792 177.144 92.9621Z",
    fill: "#B2B9BB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_879_24545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 93,
    width: 121,
    height: 98
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2734 162.891L97.2994 190.301L217.144 121.1L217.118 93.6888L97.2734 162.891Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_879_24545)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M214.418 102.93C214.418 104.081 214.076 105.206 213.436 106.163C212.796 107.119 211.886 107.864 210.823 108.304C209.759 108.743 208.588 108.857 207.46 108.63C206.331 108.404 205.295 107.847 204.483 107.032C203.671 106.216 203.119 105.177 202.898 104.048C202.676 102.918 202.795 101.748 203.239 100.686C203.683 99.6244 204.432 98.7181 205.392 98.0824C206.352 97.4466 207.478 97.11 208.629 97.1151C209.392 97.1151 210.147 97.2657 210.851 97.5582C211.555 97.8507 212.194 98.2794 212.732 98.8197C213.27 99.3599 213.695 100.001 213.985 100.706C214.274 101.412 214.421 102.167 214.418 102.93Z",
    fill: "url(#paint66_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M211.172 104.85C211.172 106 210.831 107.124 210.192 108.081C209.553 109.037 208.645 109.782 207.582 110.222C206.52 110.662 205.351 110.777 204.223 110.553C203.095 110.329 202.059 109.775 201.246 108.962C200.433 108.149 199.879 107.113 199.655 105.985C199.43 104.857 199.545 103.688 199.986 102.625C200.426 101.563 201.171 100.655 202.127 100.016C203.083 99.377 204.207 99.0359 205.357 99.0359C206.122 99.0325 206.88 99.1806 207.587 99.4715C208.293 99.7625 208.936 100.191 209.476 100.731C210.017 101.272 210.445 101.914 210.736 102.621C211.027 103.328 211.175 104.086 211.172 104.85Z",
    fill: "url(#paint67_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M202.01 112.56C205.221 112.56 207.824 109.956 207.824 106.745C207.824 103.534 205.221 100.931 202.01 100.931C198.799 100.931 196.195 103.534 196.195 106.745C196.195 109.956 198.799 112.56 202.01 112.56Z",
    fill: "url(#paint68_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M204.449 108.666C204.454 109.818 204.117 110.946 203.48 111.906C202.843 112.866 201.935 113.616 200.872 114.059C199.808 114.502 198.637 114.619 197.507 114.396C196.376 114.172 195.338 113.618 194.523 112.803C193.709 111.989 193.154 110.95 192.931 109.82C192.707 108.69 192.825 107.518 193.268 106.455C193.711 105.391 194.46 104.484 195.421 103.847C196.381 103.21 197.508 102.872 198.661 102.878C200.196 102.878 201.668 103.487 202.754 104.573C203.839 105.659 204.449 107.131 204.449 108.666Z",
    fill: "url(#paint69_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M214.418 111.573C214.418 112.724 214.076 113.85 213.436 114.806C212.796 115.763 211.886 116.508 210.823 116.948C209.759 117.387 208.588 117.5 207.46 117.274C206.331 117.048 205.295 116.491 204.483 115.675C203.671 114.86 203.119 113.821 202.898 112.692C202.676 111.562 202.795 110.392 203.239 109.33C203.683 108.268 204.432 107.362 205.392 106.726C206.352 106.09 207.478 105.754 208.629 105.759C209.392 105.759 210.147 105.909 210.851 106.202C211.555 106.495 212.194 106.923 212.732 107.463C213.27 108.004 213.695 108.645 213.985 109.35C214.274 110.055 214.421 110.811 214.418 111.573Z",
    fill: "url(#paint70_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M211.172 113.39C211.177 114.541 210.84 115.668 210.204 116.628C209.569 117.587 208.662 118.336 207.6 118.781C206.538 119.225 205.369 119.343 204.239 119.122C203.109 118.901 202.071 118.349 201.255 117.537C200.439 116.725 199.883 115.689 199.657 114.56C199.43 113.432 199.544 112.261 199.983 111.197C200.422 110.133 201.168 109.224 202.124 108.584C203.081 107.943 204.206 107.602 205.357 107.602C206.895 107.602 208.37 108.211 209.46 109.296C210.549 110.38 211.165 111.853 211.172 113.39Z",
    fill: "url(#paint71_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M207.824 115.311C207.829 116.462 207.493 117.589 206.857 118.548C206.221 119.508 205.315 120.257 204.253 120.701C203.191 121.145 202.021 121.264 200.891 121.043C199.762 120.821 198.723 120.27 197.908 119.458C197.092 118.646 196.535 117.61 196.309 116.481C196.082 115.352 196.196 114.182 196.635 113.118C197.075 112.054 197.82 111.144 198.777 110.504C199.733 109.864 200.859 109.523 202.01 109.523C203.547 109.523 205.022 110.132 206.112 111.216C207.202 112.301 207.817 113.774 207.824 115.311Z",
    fill: "url(#paint72_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M198.662 123.046C201.873 123.046 204.476 120.443 204.476 117.232C204.476 114.021 201.873 111.418 198.662 111.418C195.451 111.418 192.848 114.021 192.848 117.232C192.848 120.443 195.451 123.046 198.662 123.046Z",
    fill: "url(#paint73_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M214.418 113.053C214.423 114.205 214.086 115.333 213.449 116.293C212.812 117.253 211.904 118.002 210.841 118.446C209.777 118.889 208.606 119.006 207.476 118.783C206.345 118.559 205.307 118.005 204.492 117.19C203.677 116.375 203.123 115.337 202.9 114.207C202.676 113.076 202.793 111.905 203.237 110.842C203.68 109.778 204.429 108.87 205.389 108.233C206.349 107.597 207.477 107.259 208.629 107.264C210.165 107.264 211.637 107.874 212.722 108.96C213.808 110.045 214.418 111.518 214.418 113.053Z",
    fill: "url(#paint74_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M211.172 114.974C211.177 116.125 210.84 117.251 210.204 118.211C209.569 119.171 208.662 119.92 207.6 120.364C206.538 120.808 205.369 120.927 204.239 120.705C203.109 120.484 202.071 119.932 201.255 119.12C200.439 118.308 199.883 117.272 199.657 116.143C199.43 115.015 199.544 113.845 199.983 112.781C200.422 111.717 201.168 110.807 202.124 110.167C203.081 109.527 204.206 109.185 205.357 109.185C206.895 109.185 208.37 109.794 209.46 110.879C210.549 111.964 211.165 113.436 211.172 114.974Z",
    fill: "url(#paint75_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M207.824 116.894C207.824 118.044 207.483 119.169 206.844 120.125C206.205 121.081 205.297 121.826 204.235 122.266C203.172 122.706 202.003 122.821 200.875 122.597C199.747 122.373 198.711 121.819 197.898 121.006C197.085 120.193 196.531 119.157 196.307 118.029C196.083 116.901 196.198 115.732 196.638 114.669C197.078 113.607 197.823 112.699 198.779 112.06C199.736 111.421 200.86 111.08 202.01 111.08C203.552 111.08 205.031 111.693 206.121 112.783C207.212 113.873 207.824 115.352 207.824 116.894Z",
    fill: "url(#paint76_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M204.449 118.815C204.449 119.966 204.107 121.092 203.467 122.048C202.827 123.005 201.918 123.75 200.854 124.19C199.79 124.629 198.619 124.742 197.491 124.516C196.362 124.29 195.326 123.733 194.514 122.917C193.702 122.102 193.15 121.063 192.929 119.934C192.707 118.804 192.826 117.634 193.27 116.572C193.714 115.51 194.464 114.604 195.423 113.968C196.383 113.332 197.51 112.996 198.661 113.001C199.423 113.001 200.178 113.151 200.882 113.444C201.586 113.737 202.225 114.165 202.763 114.705C203.301 115.246 203.727 115.887 204.016 116.592C204.305 117.297 204.453 118.053 204.449 118.815Z",
    fill: "url(#paint77_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M214.418 121.619C214.423 122.771 214.086 123.899 213.449 124.859C212.812 125.819 211.904 126.568 210.841 127.011C209.777 127.455 208.606 127.572 207.476 127.348C206.345 127.125 205.307 126.571 204.492 125.756C203.677 124.941 203.123 123.903 202.9 122.773C202.676 121.642 202.793 120.471 203.237 119.408C203.68 118.344 204.429 117.436 205.389 116.799C206.349 116.162 207.477 115.825 208.629 115.83C210.165 115.83 211.637 116.44 212.722 117.526C213.808 118.611 214.418 120.083 214.418 121.619Z",
    fill: "url(#paint78_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M211.172 123.539C211.177 124.691 210.84 125.817 210.204 126.777C209.569 127.736 208.662 128.486 207.6 128.93C206.538 129.374 205.369 129.493 204.239 129.271C203.109 129.05 202.071 128.498 201.255 127.686C200.439 126.874 199.883 125.838 199.657 124.709C199.43 123.581 199.544 122.41 199.983 121.346C200.422 120.282 201.168 119.373 202.124 118.733C203.081 118.093 204.206 117.751 205.357 117.751C206.895 117.751 208.37 118.36 209.46 119.445C210.549 120.53 211.165 122.002 211.172 123.539Z",
    fill: "url(#paint79_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M202.01 131.275C205.221 131.275 207.824 128.672 207.824 125.46C207.824 122.249 205.221 119.646 202.01 119.646C198.799 119.646 196.195 122.249 196.195 125.46C196.195 128.672 198.799 131.275 202.01 131.275Z",
    fill: "url(#paint80_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M198.662 133.196C201.873 133.196 204.476 130.592 204.476 127.381C204.476 124.17 201.873 121.567 198.662 121.567C195.451 121.567 192.848 124.17 192.848 127.381C192.848 130.592 195.451 133.196 198.662 133.196Z",
    fill: "url(#paint81_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M192.068 118.452C195.28 118.452 197.883 115.849 197.883 112.637C197.883 109.426 195.28 106.823 192.068 106.823C188.857 106.823 186.254 109.426 186.254 112.637C186.254 115.849 188.857 118.452 192.068 118.452Z",
    fill: "url(#paint82_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M194.508 114.558C194.513 115.711 194.176 116.838 193.539 117.798C192.902 118.759 191.994 119.508 190.93 119.951C189.867 120.394 188.696 120.512 187.565 120.288C186.435 120.065 185.397 119.51 184.582 118.696C183.767 117.881 183.213 116.843 182.989 115.712C182.766 114.582 182.883 113.411 183.326 112.347C183.77 111.284 184.519 110.376 185.479 109.739C186.439 109.102 187.567 108.765 188.719 108.77C190.254 108.77 191.727 109.38 192.812 110.465C193.898 111.551 194.508 113.023 194.508 114.558Z",
    fill: "url(#paint83_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M191.055 116.479C191.06 117.631 190.722 118.759 190.085 119.719C189.449 120.679 188.541 121.429 187.477 121.872C186.414 122.315 185.243 122.432 184.112 122.209C182.982 121.985 181.944 121.431 181.129 120.616C180.314 119.802 179.76 118.763 179.536 117.633C179.313 116.503 179.43 115.331 179.873 114.268C180.317 113.204 181.066 112.297 182.026 111.66C182.986 111.023 184.114 110.686 185.266 110.691C186.801 110.691 188.274 111.301 189.359 112.386C190.445 113.472 191.055 114.944 191.055 116.479Z",
    fill: "url(#paint84_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M187.812 118.4C187.817 119.551 187.481 120.678 186.845 121.637C186.209 122.597 185.303 123.346 184.241 123.79C183.179 124.234 182.009 124.353 180.88 124.132C179.75 123.91 178.712 123.359 177.896 122.547C177.08 121.734 176.524 120.698 176.297 119.57C176.071 118.441 176.184 117.271 176.624 116.207C177.063 115.143 177.808 114.233 178.765 113.593C179.722 112.953 180.847 112.612 181.998 112.612C183.536 112.611 185.011 113.221 186.1 114.305C187.19 115.39 187.805 116.862 187.812 118.4Z",
    fill: "url(#paint85_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M197.883 121.203C197.888 122.354 197.551 123.481 196.915 124.441C196.28 125.4 195.373 126.15 194.311 126.594C193.249 127.038 192.08 127.157 190.95 126.935C189.82 126.714 188.782 126.162 187.966 125.35C187.15 124.538 186.594 123.502 186.368 122.373C186.141 121.245 186.255 120.074 186.694 119.01C187.133 117.946 187.879 117.037 188.835 116.397C189.792 115.757 190.917 115.415 192.068 115.415C193.606 115.415 195.081 116.024 196.17 117.109C197.26 118.193 197.876 119.666 197.883 121.203Z",
    fill: "url(#paint86_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M188.721 128.939C191.932 128.939 194.535 126.335 194.535 123.124C194.535 119.913 191.932 117.31 188.721 117.31C185.509 117.31 182.906 119.913 182.906 123.124C182.906 126.335 185.509 128.939 188.721 128.939Z",
    fill: "url(#paint87_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M191.053 125.045C191.079 126.206 190.756 127.347 190.128 128.323C189.499 129.299 188.592 130.064 187.524 130.52C186.457 130.976 185.277 131.102 184.137 130.882C182.998 130.662 181.95 130.106 181.129 129.285C180.308 128.464 179.752 127.416 179.531 126.276C179.311 125.136 179.437 123.957 179.893 122.889C180.349 121.822 181.115 120.915 182.09 120.286C183.066 119.657 184.208 119.335 185.369 119.36C186.868 119.387 188.298 119.994 189.359 121.055C190.419 122.115 191.027 123.546 191.053 125.045Z",
    fill: "url(#paint88_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M187.809 126.966C187.809 128.116 187.467 129.24 186.829 130.196C186.19 131.152 185.282 131.898 184.219 132.338C183.157 132.778 181.988 132.893 180.86 132.669C179.732 132.444 178.696 131.89 177.883 131.077C177.07 130.264 176.516 129.228 176.291 128.1C176.067 126.972 176.182 125.803 176.622 124.741C177.062 123.678 177.808 122.77 178.764 122.131C179.72 121.492 180.844 121.151 181.994 121.151C183.536 121.151 185.015 121.764 186.105 122.854C187.196 123.945 187.809 125.424 187.809 126.966Z",
    fill: "url(#paint89_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M192.068 128.601C195.28 128.601 197.883 125.998 197.883 122.787C197.883 119.576 195.28 116.972 192.068 116.972C188.857 116.972 186.254 119.576 186.254 122.787C186.254 125.998 188.857 128.601 192.068 128.601Z",
    fill: "url(#paint90_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M194.508 124.708C194.508 125.859 194.166 126.984 193.526 127.941C192.886 128.897 191.976 129.643 190.912 130.082C189.848 130.521 188.678 130.635 187.549 130.408C186.421 130.182 185.385 129.625 184.573 128.81C183.761 127.994 183.209 126.956 182.987 125.826C182.766 124.696 182.885 123.526 183.329 122.464C183.773 121.402 184.522 120.496 185.482 119.86C186.441 119.225 187.568 118.888 188.719 118.893C189.482 118.893 190.236 119.044 190.94 119.336C191.644 119.629 192.284 120.057 192.822 120.598C193.359 121.138 193.785 121.779 194.075 122.484C194.364 123.19 194.511 123.945 194.508 124.708Z",
    fill: "url(#paint91_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M191.055 126.628C191.055 127.779 190.713 128.905 190.073 129.861C189.433 130.818 188.523 131.563 187.459 132.003C186.395 132.442 185.225 132.556 184.096 132.329C182.968 132.103 181.932 131.546 181.12 130.731C180.307 129.915 179.756 128.876 179.534 127.747C179.313 126.617 179.432 125.447 179.876 124.385C180.32 123.323 181.069 122.417 182.029 121.781C182.988 121.145 184.115 120.809 185.266 120.814C186.804 120.821 188.276 121.436 189.361 122.526C190.446 123.616 191.055 125.091 191.055 126.628Z",
    fill: "url(#paint92_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M187.809 128.549C187.809 129.699 187.467 130.823 186.829 131.78C186.19 132.736 185.282 133.481 184.219 133.921C183.157 134.361 181.988 134.476 180.86 134.252C179.732 134.028 178.696 133.474 177.883 132.661C177.07 131.848 176.516 130.812 176.291 129.684C176.067 128.556 176.182 127.387 176.622 126.324C177.062 125.262 177.808 124.354 178.764 123.715C179.72 123.076 180.844 122.735 181.994 122.735C182.759 122.731 183.516 122.88 184.223 123.171C184.93 123.462 185.573 123.89 186.113 124.43C186.654 124.971 187.082 125.613 187.373 126.32C187.664 127.027 187.812 127.785 187.809 128.549Z",
    fill: "url(#paint93_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M197.883 131.353C197.883 132.503 197.542 133.627 196.903 134.583C196.264 135.539 195.356 136.284 194.293 136.725C193.231 137.165 192.062 137.28 190.934 137.055C189.806 136.831 188.77 136.277 187.957 135.464C187.144 134.651 186.59 133.615 186.366 132.487C186.141 131.359 186.256 130.19 186.697 129.128C187.137 128.065 187.882 127.157 188.838 126.518C189.794 125.879 190.918 125.538 192.068 125.538C193.61 125.538 195.089 126.151 196.18 127.241C197.27 128.332 197.883 129.811 197.883 131.353Z",
    fill: "url(#paint94_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M188.721 139.088C191.932 139.088 194.535 136.485 194.535 133.273C194.535 130.062 191.932 127.459 188.721 127.459C185.509 127.459 182.906 130.062 182.906 133.273C182.906 136.485 185.509 139.088 188.721 139.088Z",
    fill: "url(#paint95_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M191.055 135.194C191.055 136.345 190.713 137.471 190.073 138.427C189.433 139.384 188.523 140.129 187.459 140.569C186.395 141.008 185.225 141.122 184.096 140.895C182.968 140.669 181.932 140.112 181.12 139.296C180.307 138.481 179.756 137.442 179.534 136.313C179.313 135.183 179.432 134.013 179.876 132.951C180.32 131.889 181.069 130.983 182.029 130.347C182.988 129.711 184.115 129.375 185.266 129.38C186.028 129.38 186.783 129.531 187.487 129.823C188.191 130.116 188.831 130.544 189.368 131.085C189.906 131.625 190.332 132.266 190.621 132.971C190.911 133.677 191.058 134.432 191.055 135.194Z",
    fill: "url(#paint96_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M187.809 137.115C187.809 138.265 187.467 139.389 186.829 140.345C186.19 141.301 185.282 142.047 184.219 142.487C183.157 142.927 181.988 143.042 180.86 142.818C179.732 142.593 178.696 142.04 177.883 141.226C177.07 140.413 176.516 139.377 176.291 138.249C176.067 137.121 176.182 135.952 176.622 134.89C177.062 133.827 177.808 132.919 178.764 132.28C179.72 131.642 180.844 131.301 181.994 131.301C182.759 131.297 183.516 131.445 184.223 131.736C184.93 132.027 185.573 132.455 186.113 132.996C186.654 133.537 187.082 134.179 187.373 134.886C187.664 135.593 187.812 136.35 187.809 137.115Z",
    fill: "url(#paint97_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M135.713 151.469C138.924 151.469 141.527 148.866 141.527 145.655C141.527 142.444 138.924 139.841 135.713 139.841C132.502 139.841 129.898 142.444 129.898 145.655C129.898 148.866 132.502 151.469 135.713 151.469Z",
    fill: "url(#paint98_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M132.365 153.39C135.576 153.39 138.18 150.787 138.18 147.576C138.18 144.365 135.576 141.761 132.365 141.761C129.154 141.761 126.551 144.365 126.551 147.576C126.551 150.787 129.154 153.39 132.365 153.39Z",
    fill: "url(#paint99_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M134.805 149.497C134.805 150.648 134.463 151.773 133.823 152.73C133.183 153.686 132.273 154.432 131.209 154.871C130.145 155.31 128.975 155.424 127.846 155.197C126.718 154.971 125.682 154.414 124.87 153.599C124.057 152.783 123.506 151.745 123.284 150.615C123.063 149.485 123.182 148.315 123.626 147.253C124.07 146.191 124.819 145.285 125.779 144.649C126.738 144.014 127.865 143.677 129.016 143.682C129.778 143.682 130.533 143.833 131.237 144.125C131.941 144.418 132.581 144.846 133.118 145.387C133.656 145.927 134.082 146.568 134.371 147.273C134.661 147.979 134.808 148.734 134.805 149.497Z",
    fill: "url(#paint100_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M131.355 151.417C131.355 152.567 131.014 153.692 130.375 154.648C129.737 155.604 128.828 156.349 127.766 156.789C126.704 157.229 125.535 157.345 124.407 157.12C123.279 156.896 122.243 156.342 121.43 155.529C120.616 154.716 120.063 153.68 119.838 152.552C119.614 151.424 119.729 150.255 120.169 149.192C120.609 148.13 121.354 147.222 122.311 146.583C123.267 145.944 124.391 145.603 125.541 145.603C126.305 145.6 127.063 145.748 127.77 146.039C128.477 146.33 129.119 146.758 129.66 147.298C130.201 147.839 130.629 148.481 130.92 149.188C131.211 149.895 131.359 150.653 131.355 151.417Z",
    fill: "url(#paint101_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M141.527 154.221C141.527 155.371 141.186 156.495 140.547 157.451C139.908 158.407 139 159.153 137.938 159.593C136.875 160.033 135.706 160.148 134.579 159.924C133.451 159.699 132.415 159.145 131.601 158.332C130.788 157.519 130.235 156.483 130.01 155.355C129.786 154.227 129.901 153.058 130.341 151.996C130.781 150.933 131.526 150.025 132.483 149.386C133.439 148.748 134.563 148.406 135.713 148.406C137.255 148.406 138.734 149.019 139.824 150.109C140.915 151.2 141.527 152.679 141.527 154.221Z",
    fill: "url(#paint102_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M138.18 156.142C138.18 157.292 137.839 158.416 137.2 159.372C136.561 160.328 135.653 161.074 134.59 161.514C133.528 161.954 132.359 162.069 131.231 161.844C130.103 161.62 129.067 161.066 128.254 160.253C127.441 159.44 126.887 158.404 126.663 157.276C126.438 156.148 126.553 154.979 126.993 153.917C127.433 152.854 128.179 151.946 129.135 151.307C130.091 150.668 131.215 150.327 132.365 150.327C133.907 150.327 135.386 150.94 136.477 152.03C137.567 153.121 138.18 154.6 138.18 156.142Z",
    fill: "url(#paint103_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M134.805 158.063C134.805 159.214 134.463 160.339 133.823 161.296C133.183 162.252 132.273 162.997 131.209 163.437C130.145 163.876 128.975 163.99 127.846 163.763C126.718 163.537 125.682 162.98 124.87 162.165C124.057 161.349 123.506 160.31 123.284 159.181C123.063 158.051 123.182 156.881 123.626 155.819C124.07 154.757 124.819 153.851 125.779 153.215C126.738 152.58 127.865 152.243 129.016 152.248C129.778 152.248 130.533 152.399 131.237 152.691C131.941 152.984 132.581 153.412 133.118 153.953C133.656 154.493 134.082 155.134 134.371 155.839C134.661 156.545 134.808 157.3 134.805 158.063Z",
    fill: "url(#paint104_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M131.355 159.983C131.355 161.133 131.014 162.258 130.375 163.214C129.737 164.17 128.828 164.915 127.766 165.355C126.704 165.795 125.535 165.91 124.407 165.686C123.279 165.462 122.243 164.908 121.43 164.095C120.616 163.282 120.063 162.246 119.838 161.118C119.614 159.99 119.729 158.821 120.169 157.758C120.609 156.696 121.354 155.788 122.311 155.149C123.267 154.51 124.391 154.169 125.541 154.169C126.305 154.166 127.063 154.314 127.77 154.605C128.477 154.896 129.119 155.324 129.66 155.864C130.201 156.405 130.629 157.047 130.92 157.754C131.211 158.461 131.359 159.219 131.355 159.983Z",
    fill: "url(#paint105_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M135.713 161.619C138.924 161.619 141.527 159.015 141.527 155.804C141.527 152.593 138.924 149.99 135.713 149.99C132.502 149.99 129.898 152.593 129.898 155.804C129.898 159.015 132.502 161.619 135.713 161.619Z",
    fill: "url(#paint106_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M138.18 157.725C138.18 158.875 137.839 159.999 137.2 160.955C136.561 161.912 135.653 162.657 134.59 163.097C133.528 163.537 132.359 163.652 131.231 163.428C130.103 163.203 129.067 162.65 128.254 161.836C127.441 161.023 126.887 159.987 126.663 158.859C126.438 157.731 126.553 156.562 126.993 155.5C127.433 154.438 128.179 153.529 129.135 152.891C130.091 152.252 131.215 151.911 132.365 151.911C133.907 151.911 135.386 152.523 136.477 153.614C137.567 154.704 138.18 156.183 138.18 157.725Z",
    fill: "url(#paint107_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M134.805 159.62C134.81 160.772 134.472 161.9 133.835 162.86C133.199 163.82 132.291 164.57 131.227 165.013C130.164 165.456 128.993 165.573 127.862 165.35C126.732 165.126 125.694 164.572 124.879 163.757C124.064 162.943 123.51 161.904 123.286 160.774C123.063 159.644 123.18 158.472 123.623 157.409C124.067 156.345 124.816 155.438 125.776 154.801C126.736 154.164 127.864 153.826 129.016 153.832C130.551 153.832 132.024 154.441 133.109 155.527C134.195 156.613 134.805 158.085 134.805 159.62Z",
    fill: "url(#paint108_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M131.355 161.541C131.35 162.694 131.002 163.82 130.355 164.774C129.708 165.729 128.792 166.47 127.723 166.903C126.654 167.336 125.481 167.441 124.352 167.205C123.223 166.97 122.19 166.403 121.384 165.579C120.577 164.754 120.035 163.709 119.824 162.575C119.614 161.441 119.745 160.27 120.202 159.211C120.659 158.152 121.42 157.253 122.389 156.628C123.359 156.003 124.492 155.68 125.645 155.7C127.173 155.728 128.63 156.356 129.698 157.449C130.767 158.542 131.362 160.012 131.355 161.541Z",
    fill: "url(#paint109_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M141.527 164.37C141.527 165.52 141.186 166.644 140.547 167.6C139.908 168.557 139 169.302 137.938 169.742C136.875 170.182 135.706 170.297 134.579 170.073C133.451 169.848 132.415 169.295 131.601 168.482C130.788 167.668 130.235 166.632 130.01 165.504C129.786 164.377 129.901 163.207 130.341 162.145C130.781 161.083 131.526 160.175 132.483 159.536C133.439 158.897 134.563 158.556 135.713 158.556C136.477 158.552 137.235 158.7 137.942 158.991C138.649 159.282 139.291 159.71 139.832 160.251C140.373 160.792 140.801 161.434 141.092 162.141C141.383 162.848 141.531 163.606 141.527 164.37Z",
    fill: "url(#paint110_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M132.365 172.079C135.576 172.079 138.18 169.476 138.18 166.265C138.18 163.054 135.576 160.451 132.365 160.451C129.154 160.451 126.551 163.054 126.551 166.265C126.551 169.476 129.154 172.079 132.365 172.079Z",
    fill: "url(#paint111_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M134.805 168.186C134.81 169.338 134.472 170.466 133.835 171.426C133.199 172.386 132.291 173.135 131.227 173.578C130.164 174.022 128.993 174.139 127.862 173.916C126.732 173.692 125.694 173.138 124.879 172.323C124.064 171.508 123.51 170.47 123.286 169.34C123.063 168.209 123.18 167.038 123.623 165.975C124.067 164.911 124.816 164.003 125.776 163.366C126.736 162.729 127.864 162.392 129.016 162.397C130.551 162.397 132.024 163.007 133.109 164.093C134.195 165.178 134.805 166.651 134.805 168.186Z",
    fill: "url(#paint112_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M131.355 170.107C131.36 171.258 131.024 172.384 130.388 173.344C129.752 174.304 128.846 175.053 127.784 175.497C126.722 175.941 125.552 176.06 124.423 175.838C123.293 175.617 122.255 175.065 121.439 174.253C120.623 173.441 120.067 172.405 119.84 171.276C119.614 170.148 119.727 168.977 120.167 167.913C120.606 166.85 121.351 165.94 122.308 165.3C123.265 164.66 124.39 164.318 125.541 164.318C127.078 164.318 128.553 164.927 129.643 166.012C130.733 167.097 131.348 168.569 131.355 170.107Z",
    fill: "url(#paint113_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M124.863 155.389C124.863 156.54 124.522 157.665 123.881 158.622C123.241 159.579 122.332 160.324 121.268 160.763C120.204 161.202 119.033 161.316 117.905 161.09C116.776 160.863 115.74 160.307 114.928 159.491C114.116 158.675 113.564 157.637 113.343 156.507C113.122 155.378 113.24 154.208 113.684 153.146C114.129 152.084 114.878 151.178 115.837 150.542C116.797 149.906 117.924 149.569 119.075 149.575C119.837 149.575 120.592 149.725 121.296 150.018C122 150.31 122.639 150.739 123.177 151.279C123.715 151.819 124.141 152.461 124.43 153.166C124.719 153.871 124.867 154.627 124.863 155.389Z",
    fill: "url(#paint114_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M121.516 157.31C121.515 158.463 121.172 159.59 120.53 160.548C119.888 161.506 118.975 162.251 117.908 162.689C116.841 163.126 115.668 163.237 114.538 163.006C113.408 162.775 112.372 162.214 111.562 161.393C110.752 160.572 110.205 159.529 109.989 158.396C109.774 157.263 109.9 156.091 110.352 155.03C110.804 153.969 111.561 153.067 112.528 152.437C113.494 151.808 114.626 151.48 115.779 151.495C117.31 151.509 118.773 152.129 119.848 153.218C120.923 154.308 121.522 155.779 121.516 157.31Z",
    fill: "url(#paint115_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M118.168 159.231C118.168 160.381 117.827 161.505 117.188 162.461C116.549 163.417 115.641 164.162 114.579 164.603C113.516 165.043 112.347 165.158 111.219 164.933C110.091 164.709 109.055 164.155 108.242 163.342C107.429 162.529 106.875 161.493 106.651 160.365C106.426 159.237 106.542 158.068 106.982 157.006C107.422 155.943 108.167 155.035 109.123 154.396C110.079 153.757 111.203 153.416 112.353 153.416C113.118 153.413 113.876 153.561 114.583 153.852C115.29 154.143 115.932 154.571 116.473 155.112C117.013 155.652 117.441 156.295 117.732 157.002C118.023 157.709 118.171 158.466 118.168 159.231Z",
    fill: "url(#paint116_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M114.793 161.151C114.793 162.303 114.451 163.428 113.811 164.384C113.171 165.341 112.261 166.086 111.198 166.526C110.134 166.965 108.963 167.079 107.835 166.852C106.706 166.626 105.67 166.069 104.858 165.254C104.046 164.438 103.494 163.399 103.273 162.27C103.051 161.14 103.17 159.97 103.614 158.908C104.058 157.846 104.807 156.94 105.767 156.304C106.727 155.669 107.853 155.332 109.004 155.337C109.767 155.337 110.522 155.488 111.226 155.78C111.93 156.073 112.569 156.501 113.107 157.042C113.645 157.582 114.07 158.223 114.36 158.928C114.649 159.634 114.796 160.389 114.793 161.151Z",
    fill: "url(#paint117_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M124.863 163.955C124.863 165.106 124.522 166.231 123.881 167.188C123.241 168.145 122.332 168.89 121.268 169.329C120.204 169.768 119.033 169.882 117.905 169.656C116.776 169.429 115.74 168.873 114.928 168.057C114.116 167.241 113.564 166.203 113.343 165.073C113.122 163.944 113.24 162.774 113.684 161.712C114.129 160.65 114.878 159.743 115.837 159.108C116.797 158.472 117.924 158.135 119.075 158.14C119.837 158.14 120.592 158.291 121.296 158.584C122 158.876 122.639 159.305 123.177 159.845C123.715 160.385 124.141 161.026 124.43 161.732C124.719 162.437 124.867 163.193 124.863 163.955Z",
    fill: "url(#paint118_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M121.516 165.876C121.515 167.029 121.172 168.156 120.53 169.114C119.888 170.072 118.975 170.817 117.908 171.255C116.841 171.692 115.668 171.803 114.538 171.572C113.408 171.341 112.372 170.78 111.562 169.959C110.752 169.138 110.205 168.095 109.989 166.962C109.774 165.829 109.9 164.657 110.352 163.596C110.804 162.535 111.561 161.633 112.528 161.003C113.494 160.374 114.626 160.046 115.779 160.061C117.31 160.075 118.773 160.694 119.848 161.784C120.923 162.874 121.522 164.345 121.516 165.876Z",
    fill: "url(#paint119_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M118.168 167.796C118.168 168.946 117.827 170.071 117.188 171.027C116.549 171.983 115.641 172.728 114.579 173.168C113.516 173.608 112.347 173.723 111.219 173.499C110.091 173.275 109.055 172.721 108.242 171.908C107.429 171.095 106.875 170.059 106.651 168.931C106.426 167.803 106.542 166.634 106.982 165.571C107.422 164.509 108.167 163.601 109.123 162.962C110.079 162.323 111.203 161.982 112.353 161.982C113.118 161.979 113.876 162.127 114.583 162.418C115.29 162.709 115.932 163.137 116.473 163.677C117.013 164.218 117.441 164.86 117.732 165.567C118.023 166.274 118.171 167.032 118.168 167.796Z",
    fill: "url(#paint120_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M109.006 175.506C112.217 175.506 114.82 172.903 114.82 169.691C114.82 166.48 112.217 163.877 109.006 163.877C105.795 163.877 103.191 166.48 103.191 169.691C103.191 172.903 105.795 175.506 109.006 175.506Z",
    fill: "url(#paint121_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M124.863 165.512C124.868 166.664 124.531 167.792 123.894 168.752C123.257 169.712 122.349 170.462 121.286 170.905C120.222 171.348 119.051 171.466 117.921 171.242C116.791 171.018 115.752 170.464 114.937 169.649C114.123 168.835 113.568 167.796 113.345 166.666C113.121 165.536 113.239 164.365 113.682 163.301C114.125 162.238 114.875 161.33 115.835 160.693C116.795 160.056 117.923 159.719 119.075 159.724C120.61 159.724 122.082 160.334 123.168 161.419C124.253 162.505 124.863 163.977 124.863 165.512Z",
    fill: "url(#paint122_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M121.515 167.433C121.521 168.587 121.182 169.717 120.543 170.678C119.903 171.64 118.992 172.389 117.926 172.83C116.859 173.272 115.685 173.386 114.554 173.159C113.422 172.931 112.384 172.371 111.571 171.551C110.759 170.731 110.209 169.688 109.991 168.554C109.773 167.421 109.898 166.248 110.349 165.185C110.801 164.123 111.558 163.219 112.525 162.588C113.492 161.958 114.625 161.629 115.779 161.645C117.303 161.665 118.758 162.283 119.831 163.366C120.904 164.448 121.509 165.909 121.515 167.433Z",
    fill: "url(#paint123_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M118.168 169.354C118.157 170.502 117.808 171.621 117.163 172.57C116.518 173.519 115.606 174.256 114.543 174.689C113.479 175.121 112.312 175.228 111.187 174.998C110.063 174.768 109.032 174.21 108.224 173.395C107.416 172.58 106.867 171.544 106.647 170.417C106.427 169.291 106.545 168.124 106.987 167.065C107.428 166.006 108.173 165.101 109.128 164.464C110.083 163.827 111.205 163.488 112.353 163.488C113.121 163.488 113.882 163.64 114.59 163.935C115.299 164.23 115.943 164.663 116.483 165.209C117.024 165.754 117.451 166.401 117.74 167.113C118.029 167.824 118.174 168.586 118.168 169.354Z",
    fill: "url(#paint124_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M114.793 171.275C114.798 172.427 114.461 173.555 113.824 174.515C113.187 175.475 112.279 176.224 111.216 176.667C110.152 177.111 108.981 177.228 107.85 177.005C106.72 176.781 105.682 176.227 104.867 175.412C104.052 174.597 103.498 173.559 103.275 172.429C103.051 171.298 103.168 170.127 103.612 169.064C104.055 168 104.804 167.092 105.764 166.455C106.724 165.818 107.852 165.481 109.004 165.486C110.54 165.486 112.012 166.096 113.097 167.182C114.183 168.267 114.793 169.74 114.793 171.275Z",
    fill: "url(#paint125_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M124.863 174.078C124.868 175.23 124.531 176.358 123.894 177.318C123.257 178.278 122.349 179.028 121.286 179.471C120.222 179.914 119.051 180.031 117.921 179.808C116.791 179.584 115.752 179.03 114.937 178.215C114.123 177.401 113.568 176.362 113.345 175.232C113.121 174.102 113.239 172.93 113.682 171.867C114.125 170.803 114.875 169.896 115.835 169.259C116.795 168.622 117.923 168.284 119.075 168.29C120.61 168.29 122.082 168.899 123.168 169.985C124.253 171.071 124.863 172.543 124.863 174.078Z",
    fill: "url(#paint126_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M121.515 175.999C121.521 177.153 121.182 178.283 120.543 179.244C119.903 180.205 118.992 180.955 117.926 181.396C116.859 181.838 115.685 181.952 114.554 181.724C113.422 181.497 112.384 180.937 111.571 180.117C110.759 179.297 110.209 178.254 109.991 177.12C109.773 175.987 109.898 174.814 110.349 173.751C110.801 172.689 111.558 171.785 112.525 171.154C113.492 170.524 114.625 170.195 115.779 170.21C117.303 170.231 118.758 170.849 119.831 171.932C120.904 173.014 121.509 174.475 121.515 175.999Z",
    fill: "url(#paint127_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M118.168 177.92C118.173 179.071 117.836 180.198 117.201 181.157C116.565 182.117 115.659 182.866 114.597 183.31C113.535 183.754 112.365 183.873 111.235 183.652C110.105 183.43 109.067 182.878 108.251 182.066C107.436 181.254 106.879 180.218 106.653 179.09C106.426 177.961 106.54 176.791 106.979 175.727C107.418 174.663 108.164 173.753 109.12 173.113C110.077 172.473 111.202 172.131 112.353 172.131C113.891 172.131 115.366 172.74 116.456 173.825C117.545 174.91 118.161 176.382 118.168 177.92Z",
    fill: "url(#paint128_radial_879_24545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M109.006 185.655C112.217 185.655 114.82 183.052 114.82 179.841C114.82 176.629 112.217 174.026 109.006 174.026C105.795 174.026 103.191 176.629 103.191 179.841C103.191 183.052 105.795 185.655 109.006 185.655Z",
    fill: "url(#paint129_radial_879_24545)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_879_24545",
    x1: 199.105,
    y1: 113.806,
    x2: 199.832,
    y2: 113.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_879_24545",
    x1: 202.555,
    y1: 109.03,
    x2: 203.256,
    y2: 109.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_879_24545",
    x1: 199.105,
    y1: 111.028,
    x2: 199.832,
    y2: 111.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_879_24545",
    x1: 205.984,
    y1: 107.057,
    x2: 206.711,
    y2: 107.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_879_24545",
    x1: 202.555,
    y1: 111.807,
    x2: 203.256,
    y2: 111.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_879_24545",
    x1: 209.279,
    y1: 107.965,
    x2: 210.161,
    y2: 107.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_879_24545",
    x1: 209.279,
    y1: 105.188,
    x2: 210.161,
    y2: 105.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_879_24545",
    x1: 205.984,
    y1: 109.834,
    x2: 206.711,
    y2: 109.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_879_24545",
    x1: 199.105,
    y1: 123.955,
    x2: 199.832,
    y2: 123.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_879_24545",
    x1: 202.555,
    y1: 119.179,
    x2: 203.256,
    y2: 119.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_879_24545",
    x1: 199.105,
    y1: 121.178,
    x2: 199.832,
    y2: 121.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_879_24545",
    x1: 205.984,
    y1: 117.206,
    x2: 206.711,
    y2: 117.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_879_24545",
    x1: 202.555,
    y1: 121.956,
    x2: 203.256,
    y2: 121.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_879_24545",
    x1: 209.279,
    y1: 118.089,
    x2: 210.161,
    y2: 118.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_879_24545",
    x1: 209.279,
    y1: 115.337,
    x2: 210.161,
    y2: 115.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_879_24545",
    x1: 205.984,
    y1: 119.983,
    x2: 206.711,
    y2: 119.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_879_24545",
    x1: 182.414,
    y1: 123.462,
    x2: 183.141,
    y2: 123.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_879_24545",
    x1: 185.867,
    y1: 118.712,
    x2: 186.568,
    y2: 118.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_879_24545",
    x1: 182.414,
    y1: 120.71,
    x2: 183.141,
    y2: 120.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_879_24545",
    x1: 189.293,
    y1: 116.739,
    x2: 190.02,
    y2: 116.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_879_24545",
    x1: 185.867,
    y1: 121.463,
    x2: 186.568,
    y2: 121.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_879_24545",
    x1: 192.59,
    y1: 117.621,
    x2: 193.472,
    y2: 117.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_879_24545",
    x1: 192.59,
    y1: 114.844,
    x2: 193.472,
    y2: 114.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_879_24545",
    x1: 189.293,
    y1: 119.49,
    x2: 190.02,
    y2: 119.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_879_24545",
    x1: 182.414,
    y1: 133.611,
    x2: 183.141,
    y2: 133.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_879_24545",
    x1: 185.867,
    y1: 128.835,
    x2: 186.568,
    y2: 128.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_879_24545",
    x1: 182.414,
    y1: 130.834,
    x2: 183.141,
    y2: 130.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_879_24545",
    x1: 189.293,
    y1: 126.862,
    x2: 190.02,
    y2: 126.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_879_24545",
    x1: 185.867,
    y1: 131.612,
    x2: 186.568,
    y2: 131.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_879_24545",
    x1: 192.59,
    y1: 127.745,
    x2: 193.472,
    y2: 127.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_879_24545",
    x1: 192.59,
    y1: 124.993,
    x2: 193.472,
    y2: 124.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_879_24545",
    x1: 189.293,
    y1: 129.64,
    x2: 190.02,
    y2: 129.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_879_24545",
    x1: 126.035,
    y1: 156.505,
    x2: 126.736,
    y2: 156.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_879_24545",
    x1: 129.461,
    y1: 151.729,
    x2: 130.188,
    y2: 151.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_879_24545",
    x1: 126.035,
    y1: 153.728,
    x2: 126.736,
    y2: 153.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_879_24545",
    x1: 132.887,
    y1: 149.756,
    x2: 133.614,
    y2: 149.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_879_24545",
    x1: 129.461,
    y1: 154.507,
    x2: 130.188,
    y2: 154.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_879_24545",
    x1: 136.211,
    y1: 150.639,
    x2: 137.068,
    y2: 150.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_879_24545",
    x1: 136.211,
    y1: 147.887,
    x2: 137.068,
    y2: 147.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_879_24545",
    x1: 132.887,
    y1: 152.534,
    x2: 133.614,
    y2: 152.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_879_24545",
    x1: 126.035,
    y1: 166.629,
    x2: 126.736,
    y2: 166.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_879_24545",
    x1: 129.461,
    y1: 161.878,
    x2: 130.188,
    y2: 161.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_879_24545",
    x1: 126.035,
    y1: 163.877,
    x2: 126.736,
    y2: 163.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_879_24545",
    x1: 132.887,
    y1: 159.906,
    x2: 133.614,
    y2: 159.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_879_24545",
    x1: 129.461,
    y1: 164.656,
    x2: 130.188,
    y2: 164.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_879_24545",
    x1: 136.211,
    y1: 160.788,
    x2: 137.068,
    y2: 160.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_879_24545",
    x1: 136.211,
    y1: 158.037,
    x2: 137.068,
    y2: 158.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_879_24545",
    x1: 132.887,
    y1: 162.683,
    x2: 133.614,
    y2: 162.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_879_24545",
    x1: 109.344,
    y1: 166.161,
    x2: 110.045,
    y2: 166.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_879_24545",
    x1: 112.77,
    y1: 161.385,
    x2: 113.496,
    y2: 161.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_879_24545",
    x1: 109.344,
    y1: 163.384,
    x2: 110.045,
    y2: 163.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_879_24545",
    x1: 116.195,
    y1: 159.412,
    x2: 116.922,
    y2: 159.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_879_24545",
    x1: 112.77,
    y1: 164.162,
    x2: 113.496,
    y2: 164.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_879_24545",
    x1: 119.52,
    y1: 160.295,
    x2: 120.376,
    y2: 160.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_879_24545",
    x1: 119.52,
    y1: 157.543,
    x2: 120.376,
    y2: 157.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_879_24545",
    x1: 116.195,
    y1: 162.19,
    x2: 116.922,
    y2: 162.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_879_24545",
    x1: 109.344,
    y1: 176.31,
    x2: 110.045,
    y2: 176.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_879_24545",
    x1: 112.77,
    y1: 171.534,
    x2: 113.496,
    y2: 171.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_879_24545",
    x1: 109.344,
    y1: 173.533,
    x2: 110.045,
    y2: 173.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_879_24545",
    x1: 116.195,
    y1: 169.562,
    x2: 116.922,
    y2: 169.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_879_24545",
    x1: 112.77,
    y1: 174.312,
    x2: 113.496,
    y2: 174.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_879_24545",
    x1: 119.52,
    y1: 170.444,
    x2: 120.376,
    y2: 170.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_879_24545",
    x1: 119.52,
    y1: 167.693,
    x2: 120.376,
    y2: 167.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_879_24545",
    x1: 116.195,
    y1: 172.339,
    x2: 116.922,
    y2: 172.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C7C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_879_24545",
    x1: 174.704,
    y1: 128.264,
    x2: 174.704,
    y2: 125.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D6DCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E9ECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_879_24545",
    x1: 174.704,
    y1: 138.699,
    x2: 174.704,
    y2: 135.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D6DCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E9ECED"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.733 102.93) scale(5.8144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.357 104.85) scale(5.8144 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(202.01 106.745) scale(5.8144 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.661 108.666) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.733 111.495) scale(5.8144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.357 113.416) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(202.01 115.311) scale(5.8144 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.662 117.232) scale(5.8144 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.733 113.053) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.357 114.974) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(202.01 116.894) scale(5.8144 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.661 118.815) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.733 121.619) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.357 123.539) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(202.01 125.46) scale(5.8144 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.662 127.381) scale(5.8144 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.068 112.637) scale(5.8144 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.719 114.558) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.37 116.479) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.998 118.4) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.068 121.203) scale(5.8144 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.721 123.124) scale(5.8144 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.369 125.045) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.994 126.966) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.068 122.787) scale(5.8144 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.719 124.708) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.37 126.628) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.994 128.549) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.068 131.353) scale(5.8144 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.721 133.273) scale(5.8144 5.8144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.37 135.194) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.994 137.115) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(135.713 145.655) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.365 147.576) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.016 149.497) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.645 151.417) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(135.713 154.221) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.365 156.142) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.016 158.063) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.645 159.983) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(135.713 155.804) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.365 157.725) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.016 159.62) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.645 161.541) scale(5.81441 5.8144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(135.713 164.37) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.365 166.265) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.016 168.186) scale(5.81441 5.8144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.645 170.107) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(119.075 155.389) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.727 157.31) scale(5.8144 5.8144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.353 159.231) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.004 161.151) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(119.075 163.955) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.727 165.876) scale(5.8144 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.353 167.796) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.006 169.691) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(119.075 165.512) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.727 167.433) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.353 169.354) scale(5.8144 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.004 171.275) scale(5.8144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(119.075 174.078) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.727 175.999) scale(5.81441 5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.353 177.92) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_879_24545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.006 179.841) scale(5.81441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6ABB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4E892B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#365F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#223D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#13220B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#020401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_879_24545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 141.025,
    fill: "white",
    transform: "translate(17.1445 49.2761)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/Switch.fefc81a45811f23bd6ab89cef72cdf7f.svg";
export { ForwardRef as ReactComponent };